{
  "source": "third-party/edsy/eddb.js",
  "sha256": "ad6635a6ca6d54e28a1136df7db6adeca12e2ec82488b65840fd796b38c1a815",
  "modules": {
    "int_cargorack_size1_class1": {
      "type": "icr",
      "id": 150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_corrosionproofcargorack_size1_class1": {
      "type": "icr",
      "id": 151,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_corrosionproofcargorack_size1_class2": {
      "type": "icr",
      "id": 161,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_cargorack_size2_class1": {
      "type": "icr",
      "id": 250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_corrosionproofcargorack_size2_class1": {
      "type": "icr",
      "id": 251,
      "noUndersize": false,
      "hidden": true,
      "ships": null,
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_cargorack_size3_class1": {
      "type": "icr",
      "id": 350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_cargorack_size4_class1": {
      "type": "icr",
      "id": 450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_corrosionproofcargorack_size4_class1": {
      "type": "icr",
      "id": 451,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_cargorack_size5_class1": {
      "type": "icr",
      "id": 550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_corrosionproofcargorack_size5_class1": {
      "type": "icr",
      "id": 551,
      "noUndersize": false,
      "hidden": true,
      "ships": null,
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_largecargorack_size6_class1": {
      "type": "icr",
      "id": 640,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "PantherMkII"
      ],
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_cargorack_size6_class1": {
      "type": "icr",
      "id": 650,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_corrosionproofcargorack_size6_class1": {
      "type": "icr",
      "id": 651,
      "noUndersize": false,
      "hidden": true,
      "ships": null,
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_largecargorack_size7_class1": {
      "type": "icr",
      "id": 740,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "PantherMkII"
      ],
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_cargorack_size7_class1": {
      "type": "icr",
      "id": 750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_largecargorack_size8_class1": {
      "type": "icr",
      "id": 840,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "PantherMkII"
      ],
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_cargorack_size8_class1": {
      "type": "icr",
      "id": 850,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "CargoRack_IncreasedCapacity",
        "CargoRack_Extended"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size1_class5": {
      "type": "iafmu",
      "id": 1110,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size1_class4": {
      "type": "iafmu",
      "id": 1120,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size1_class3": {
      "type": "iafmu",
      "id": 1130,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size1_class2": {
      "type": "iafmu",
      "id": 1140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size1_class1": {
      "type": "iafmu",
      "id": 1150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size2_class5": {
      "type": "iafmu",
      "id": 1210,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size2_class4": {
      "type": "iafmu",
      "id": 1220,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size2_class3": {
      "type": "iafmu",
      "id": 1230,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size2_class2": {
      "type": "iafmu",
      "id": 1240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size2_class1": {
      "type": "iafmu",
      "id": 1250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size3_class5": {
      "type": "iafmu",
      "id": 1310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size3_class4": {
      "type": "iafmu",
      "id": 1320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size3_class3": {
      "type": "iafmu",
      "id": 1330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size3_class2": {
      "type": "iafmu",
      "id": 1340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size3_class1": {
      "type": "iafmu",
      "id": 1350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size4_class5": {
      "type": "iafmu",
      "id": 1410,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size4_class4": {
      "type": "iafmu",
      "id": 1420,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size4_class3": {
      "type": "iafmu",
      "id": 1430,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size4_class2": {
      "type": "iafmu",
      "id": 1440,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size4_class1": {
      "type": "iafmu",
      "id": 1450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size5_class5": {
      "type": "iafmu",
      "id": 1510,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size5_class4": {
      "type": "iafmu",
      "id": 1520,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size5_class3": {
      "type": "iafmu",
      "id": 1530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size5_class2": {
      "type": "iafmu",
      "id": 1540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size5_class1": {
      "type": "iafmu",
      "id": 1550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size6_class5": {
      "type": "iafmu",
      "id": 1610,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size6_class4": {
      "type": "iafmu",
      "id": 1620,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size6_class3": {
      "type": "iafmu",
      "id": 1630,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size6_class2": {
      "type": "iafmu",
      "id": 1640,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size6_class1": {
      "type": "iafmu",
      "id": 1650,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size7_class5": {
      "type": "iafmu",
      "id": 1710,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size7_class4": {
      "type": "iafmu",
      "id": 1720,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size7_class3": {
      "type": "iafmu",
      "id": 1730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size7_class2": {
      "type": "iafmu",
      "id": 1740,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size7_class1": {
      "type": "iafmu",
      "id": 1750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size8_class5": {
      "type": "iafmu",
      "id": 1810,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size8_class4": {
      "type": "iafmu",
      "id": 1820,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size8_class3": {
      "type": "iafmu",
      "id": 1830,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size8_class2": {
      "type": "iafmu",
      "id": 1840,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_repairer_size8_class1": {
      "type": "iafmu",
      "id": 1850,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_refinery_size1_class5": {
      "type": "ir",
      "id": 2110,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size1_class4": {
      "type": "ir",
      "id": 2120,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size1_class3": {
      "type": "ir",
      "id": 2130,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size1_class2": {
      "type": "ir",
      "id": 2140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size1_class1": {
      "type": "ir",
      "id": 2150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size2_class5": {
      "type": "ir",
      "id": 2210,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size2_class4": {
      "type": "ir",
      "id": 2220,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size2_class3": {
      "type": "ir",
      "id": 2230,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size2_class2": {
      "type": "ir",
      "id": 2240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size2_class1": {
      "type": "ir",
      "id": 2250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size3_class5": {
      "type": "ir",
      "id": 2310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size3_class4": {
      "type": "ir",
      "id": 2320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size3_class3": {
      "type": "ir",
      "id": 2330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size3_class2": {
      "type": "ir",
      "id": 2340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size3_class1": {
      "type": "ir",
      "id": 2350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size4_class5": {
      "type": "ir",
      "id": 2410,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size4_class4": {
      "type": "ir",
      "id": 2420,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size4_class3": {
      "type": "ir",
      "id": 2430,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size4_class2": {
      "type": "ir",
      "id": 2440,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_refinery_size4_class1": {
      "type": "ir",
      "id": 2450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ir"
    },
    "int_dockingcomputer_standard": {
      "type": "ifa",
      "id": 3150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "ifa_dc"
    },
    "int_dockingcomputer_advanced": {
      "type": "ifa",
      "id": 3151,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "ifa_dc"
    },
    "int_supercruiseassist": {
      "type": "ifa",
      "id": 3152,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "ifa_sc"
    },
    "int_hullreinforcement_size1_class2": {
      "type": "ihrp",
      "id": 4140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "HullReinforcement_Explosive",
        "HullReinforcement_HeavyDuty",
        "HullReinforcement_Kinetic",
        "HullReinforcement_Advanced",
        "HullReinforcement_Thermic"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_guardianhullreinforcement_size1_class2": {
      "type": "ihrp",
      "id": 4141,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_hullreinforcement_size1_class1": {
      "type": "ihrp",
      "id": 4150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "HullReinforcement_Explosive",
        "HullReinforcement_HeavyDuty",
        "HullReinforcement_Kinetic",
        "HullReinforcement_Advanced",
        "HullReinforcement_Thermic"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_guardianhullreinforcement_size1_class1": {
      "type": "ihrp",
      "id": 4151,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_hullreinforcement_size2_class2": {
      "type": "ihrp",
      "id": 4240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "HullReinforcement_Explosive",
        "HullReinforcement_HeavyDuty",
        "HullReinforcement_Kinetic",
        "HullReinforcement_Advanced",
        "HullReinforcement_Thermic"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_guardianhullreinforcement_size2_class2": {
      "type": "ihrp",
      "id": 4241,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_hullreinforcement_size2_class1": {
      "type": "ihrp",
      "id": 4250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "HullReinforcement_Explosive",
        "HullReinforcement_HeavyDuty",
        "HullReinforcement_Kinetic",
        "HullReinforcement_Advanced",
        "HullReinforcement_Thermic"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_guardianhullreinforcement_size2_class1": {
      "type": "ihrp",
      "id": 4251,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_hullreinforcement_size3_class2": {
      "type": "ihrp",
      "id": 4340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "HullReinforcement_Explosive",
        "HullReinforcement_HeavyDuty",
        "HullReinforcement_Kinetic",
        "HullReinforcement_Advanced",
        "HullReinforcement_Thermic"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_guardianhullreinforcement_size3_class2": {
      "type": "ihrp",
      "id": 4341,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_hullreinforcement_size3_class1": {
      "type": "ihrp",
      "id": 4350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "HullReinforcement_Explosive",
        "HullReinforcement_HeavyDuty",
        "HullReinforcement_Kinetic",
        "HullReinforcement_Advanced",
        "HullReinforcement_Thermic"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_guardianhullreinforcement_size3_class1": {
      "type": "ihrp",
      "id": 4351,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_hullreinforcement_size4_class2": {
      "type": "ihrp",
      "id": 4440,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "HullReinforcement_Explosive",
        "HullReinforcement_HeavyDuty",
        "HullReinforcement_Kinetic",
        "HullReinforcement_Advanced",
        "HullReinforcement_Thermic"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_guardianhullreinforcement_size4_class2": {
      "type": "ihrp",
      "id": 4441,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_hullreinforcement_size4_class1": {
      "type": "ihrp",
      "id": 4450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "HullReinforcement_Explosive",
        "HullReinforcement_HeavyDuty",
        "HullReinforcement_Kinetic",
        "HullReinforcement_Advanced",
        "HullReinforcement_Thermic"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_guardianhullreinforcement_size4_class1": {
      "type": "ihrp",
      "id": 4451,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_hullreinforcement_size5_class2": {
      "type": "ihrp",
      "id": 4540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "HullReinforcement_Explosive",
        "HullReinforcement_HeavyDuty",
        "HullReinforcement_Kinetic",
        "HullReinforcement_Advanced",
        "HullReinforcement_Thermic"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_guardianhullreinforcement_size5_class2": {
      "type": "ihrp",
      "id": 4541,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_hullreinforcement_size5_class1": {
      "type": "ihrp",
      "id": 4550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "HullReinforcement_Explosive",
        "HullReinforcement_HeavyDuty",
        "HullReinforcement_Kinetic",
        "HullReinforcement_Advanced",
        "HullReinforcement_Thermic"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_guardianhullreinforcement_size5_class1": {
      "type": "ihrp",
      "id": 4551,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_hullreinforcement_kinetic",
        "special_hullreinforcement_chunky",
        "special_hullreinforcement_explosive",
        "special_hullreinforcement_thermic"
      ],
      "limit": null
    },
    "int_largebuggybay_size2_class3": {
      "type": "ipvh",
      "id": 5260,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "Anaconda",
        "TypeX_2",
        "Krait_MkII",
        "AnacondaMkII",
        "Federation_Gunship",
        "Type9",
        "Independant_Trader",
        "Type9_Military",
        "LakonMiner",
        "Explorer_NX",
        "BelugaLiner",
        "Federation_Corvette",
        "Cutter",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_mkiilargebuggybay_size2_class3": {
      "type": "ipvh",
      "id": 5261,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "LakonMiner",
        "Explorer_NX",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_largebuggybay_size2_class3_free": {
      "type": "ipvh",
      "id": 5262,
      "noUndersize": false,
      "hidden": true,
      "ships": [
        "Anaconda",
        "TypeX_2",
        "Krait_MkII",
        "AnacondaMkII",
        "Federation_Gunship",
        "Type9",
        "Independant_Trader",
        "Type9_Military",
        "LakonMiner",
        "Explorer_NX",
        "BelugaLiner",
        "Federation_Corvette",
        "Cutter",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_mkiilargebuggybay_size2_class3_free": {
      "type": "ipvh",
      "id": 5263,
      "noUndersize": false,
      "hidden": true,
      "ships": [
        "AnacondaMkII",
        "LakonMiner",
        "Explorer_NX",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_buggybay_size2_class2": {
      "type": "ipvh",
      "id": 5270,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_buggybay_size2_class1": {
      "type": "ipvh",
      "id": 5280,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_largebuggybay_size4_class3": {
      "type": "ipvh",
      "id": 5460,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "Anaconda",
        "TypeX_2",
        "Krait_MkII",
        "AnacondaMkII",
        "Federation_Gunship",
        "Type9",
        "Independant_Trader",
        "Type9_Military",
        "LakonMiner",
        "Explorer_NX",
        "BelugaLiner",
        "Federation_Corvette",
        "Cutter",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_mkiilargebuggybay_size4_class3": {
      "type": "ipvh",
      "id": 5461,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "LakonMiner",
        "Explorer_NX",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_largebuggybay_size4_class3_free": {
      "type": "ipvh",
      "id": 5462,
      "noUndersize": false,
      "hidden": true,
      "ships": [
        "Anaconda",
        "TypeX_2",
        "Krait_MkII",
        "AnacondaMkII",
        "Federation_Gunship",
        "Type9",
        "Independant_Trader",
        "Type9_Military",
        "LakonMiner",
        "Explorer_NX",
        "BelugaLiner",
        "Federation_Corvette",
        "Cutter",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_mkiilargebuggybay_size4_class3_free": {
      "type": "ipvh",
      "id": 5463,
      "noUndersize": false,
      "hidden": true,
      "ships": [
        "AnacondaMkII",
        "LakonMiner",
        "Explorer_NX",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_buggybay_size4_class2": {
      "type": "ipvh",
      "id": 5470,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_buggybay_size4_class1": {
      "type": "ipvh",
      "id": 5480,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_largebuggybay_size6_class3": {
      "type": "ipvh",
      "id": 5660,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "Anaconda",
        "TypeX_2",
        "Krait_MkII",
        "AnacondaMkII",
        "Federation_Gunship",
        "Type9",
        "Independant_Trader",
        "Type9_Military",
        "LakonMiner",
        "Explorer_NX",
        "BelugaLiner",
        "Federation_Corvette",
        "Cutter",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_mkiilargebuggybay_size6_class3": {
      "type": "ipvh",
      "id": 5661,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "LakonMiner",
        "Explorer_NX",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_largebuggybay_size6_class3_free": {
      "type": "ipvh",
      "id": 5662,
      "noUndersize": false,
      "hidden": true,
      "ships": [
        "Anaconda",
        "TypeX_2",
        "Krait_MkII",
        "AnacondaMkII",
        "Federation_Gunship",
        "Type9",
        "Independant_Trader",
        "Type9_Military",
        "LakonMiner",
        "Explorer_NX",
        "BelugaLiner",
        "Federation_Corvette",
        "Cutter",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_mkiilargebuggybay_size6_class3_free": {
      "type": "ipvh",
      "id": 5663,
      "noUndersize": false,
      "hidden": true,
      "ships": [
        "AnacondaMkII",
        "LakonMiner",
        "Explorer_NX",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_buggybay_size6_class2": {
      "type": "ipvh",
      "id": 5670,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_buggybay_size6_class1": {
      "type": "ipvh",
      "id": 5680,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_mkii_passengercabin_size2_class1": {
      "type": "ipc",
      "id": 6242,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "MediumTransport01"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_passengercabin_size2_class1": {
      "type": "ipc",
      "id": 6250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_mkii_passengercabin_size3_class2": {
      "type": "ipc",
      "id": 6332,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "MediumTransport01"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_passengercabin_size3_class2": {
      "type": "ipc",
      "id": 6340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_mkii_passengercabin_size3_class1": {
      "type": "ipc",
      "id": 6342,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "MediumTransport01"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_passengercabin_size3_class1": {
      "type": "ipc",
      "id": 6350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_passengercabin_size4_class3": {
      "type": "ipc",
      "id": 6430,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_mkii_passengercabin_size4_class2": {
      "type": "ipc",
      "id": 6432,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "MediumTransport01"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_passengercabin_size4_class2": {
      "type": "ipc",
      "id": 6440,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_mkii_passengercabin_size4_class1": {
      "type": "ipc",
      "id": 6442,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "MediumTransport01"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_passengercabin_size4_class1": {
      "type": "ipc",
      "id": 6450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_passengercabin_size5_class4": {
      "type": "ipc",
      "id": 6520,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "Orca",
        "BelugaLiner",
        "Dolphin"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_passengercabin_size5_class3": {
      "type": "ipc",
      "id": 6530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_mkii_passengercabin_size5_class2": {
      "type": "ipc",
      "id": 6532,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "MediumTransport01"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_passengercabin_size5_class2": {
      "type": "ipc",
      "id": 6540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_mkii_passengercabin_size5_class1": {
      "type": "ipc",
      "id": 6542,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "MediumTransport01"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_passengercabin_size5_class1": {
      "type": "ipc",
      "id": 6550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_passengercabin_size6_class4": {
      "type": "ipc",
      "id": 6620,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "Orca",
        "BelugaLiner",
        "Dolphin"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_passengercabin_size6_class3": {
      "type": "ipc",
      "id": 6630,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_mkii_passengercabin_size6_class2": {
      "type": "ipc",
      "id": 6632,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "MediumTransport01"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_passengercabin_size6_class2": {
      "type": "ipc",
      "id": 6640,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_mkii_passengercabin_size6_class1": {
      "type": "ipc",
      "id": 6642,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "MediumTransport01"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_passengercabin_size6_class1": {
      "type": "ipc",
      "id": 6650,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_fighterbay_size5_class1": {
      "type": "ifh",
      "id": 7540,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "Anaconda",
        "TypeX_2",
        "Krait_MkII",
        "AnacondaMkII",
        "Federation_Gunship",
        "Type9",
        "Independant_Trader",
        "Type9_Military",
        "LakonMiner",
        "Explorer_NX",
        "BelugaLiner",
        "Federation_Corvette",
        "Cutter",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": "ifh"
    },
    "int_fighterbay_size5_class1_free": {
      "type": "ifh",
      "id": 7541,
      "noUndersize": false,
      "hidden": true,
      "ships": [
        "Anaconda",
        "TypeX_2",
        "Krait_MkII",
        "AnacondaMkII",
        "Federation_Gunship",
        "Type9",
        "Independant_Trader",
        "Type9_Military",
        "LakonMiner",
        "Explorer_NX",
        "BelugaLiner",
        "Federation_Corvette",
        "Cutter",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": "ifh"
    },
    "int_fighterbaymk2_size5_class1": {
      "type": "ifh",
      "id": 7542,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "LakonMiner",
        "Explorer_NX",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": "ifh"
    },
    "int_fighterbaymk2_size5_class1_free": {
      "type": "ifh",
      "id": 7543,
      "noUndersize": false,
      "hidden": true,
      "ships": [
        "AnacondaMkII",
        "LakonMiner",
        "Explorer_NX",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": "ifh"
    },
    "int_fighterbay_size6_class1": {
      "type": "ifh",
      "id": 7640,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "Anaconda",
        "TypeX_2",
        "Krait_MkII",
        "AnacondaMkII",
        "Federation_Gunship",
        "Type9",
        "Independant_Trader",
        "Type9_Military",
        "LakonMiner",
        "Explorer_NX",
        "BelugaLiner",
        "Federation_Corvette",
        "Cutter",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": "ifh"
    },
    "int_fighterbay_size6_class1_free": {
      "type": "ifh",
      "id": 7641,
      "noUndersize": false,
      "hidden": true,
      "ships": [
        "Anaconda",
        "TypeX_2",
        "Krait_MkII",
        "AnacondaMkII",
        "Federation_Gunship",
        "Type9",
        "Independant_Trader",
        "Type9_Military",
        "LakonMiner",
        "Explorer_NX",
        "BelugaLiner",
        "Federation_Corvette",
        "Cutter",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": "ifh"
    },
    "int_fighterbaymk2_size6_class1": {
      "type": "ifh",
      "id": 7642,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "LakonMiner",
        "Explorer_NX",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": "ifh"
    },
    "int_fighterbaymk2_size6_class1_free": {
      "type": "ifh",
      "id": 7643,
      "noUndersize": false,
      "hidden": true,
      "ships": [
        "AnacondaMkII",
        "LakonMiner",
        "Explorer_NX",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": "ifh"
    },
    "int_fighterbay_size7_class1": {
      "type": "ifh",
      "id": 7740,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "Anaconda",
        "TypeX_2",
        "Krait_MkII",
        "AnacondaMkII",
        "Federation_Gunship",
        "Type9",
        "Independant_Trader",
        "Type9_Military",
        "LakonMiner",
        "Explorer_NX",
        "BelugaLiner",
        "Federation_Corvette",
        "Cutter",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": "ifh"
    },
    "int_fighterbay_size7_class1_free": {
      "type": "ifh",
      "id": 7741,
      "noUndersize": false,
      "hidden": true,
      "ships": [
        "Anaconda",
        "TypeX_2",
        "Krait_MkII",
        "AnacondaMkII",
        "Federation_Gunship",
        "Type9",
        "Independant_Trader",
        "Type9_Military",
        "LakonMiner",
        "Explorer_NX",
        "BelugaLiner",
        "Federation_Corvette",
        "Cutter",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": "ifh"
    },
    "int_fighterbaymk2_size7_class1": {
      "type": "ifh",
      "id": 7742,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "LakonMiner",
        "Explorer_NX",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": "ifh"
    },
    "int_fighterbaymk2_size7_class1_free": {
      "type": "ifh",
      "id": 7743,
      "noUndersize": false,
      "hidden": true,
      "ships": [
        "AnacondaMkII",
        "LakonMiner",
        "Explorer_NX",
        "PantherMkII"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": "ifh"
    },
    "int_modulereinforcement_size1_class2": {
      "type": "imrp",
      "id": 8140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianmodulereinforcement_size1_class2": {
      "type": "imrp",
      "id": 8141,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_modulereinforcement_size1_class1": {
      "type": "imrp",
      "id": 8150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianmodulereinforcement_size1_class1": {
      "type": "imrp",
      "id": 8151,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_modulereinforcement_size2_class2": {
      "type": "imrp",
      "id": 8240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianmodulereinforcement_size2_class2": {
      "type": "imrp",
      "id": 8241,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_modulereinforcement_size2_class1": {
      "type": "imrp",
      "id": 8250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianmodulereinforcement_size2_class1": {
      "type": "imrp",
      "id": 8251,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_modulereinforcement_size3_class2": {
      "type": "imrp",
      "id": 8340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianmodulereinforcement_size3_class2": {
      "type": "imrp",
      "id": 8341,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_modulereinforcement_size3_class1": {
      "type": "imrp",
      "id": 8350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianmodulereinforcement_size3_class1": {
      "type": "imrp",
      "id": 8351,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_modulereinforcement_size4_class2": {
      "type": "imrp",
      "id": 8440,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianmodulereinforcement_size4_class2": {
      "type": "imrp",
      "id": 8441,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_modulereinforcement_size4_class1": {
      "type": "imrp",
      "id": 8450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianmodulereinforcement_size4_class1": {
      "type": "imrp",
      "id": 8451,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_modulereinforcement_size5_class2": {
      "type": "imrp",
      "id": 8540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianmodulereinforcement_size5_class2": {
      "type": "imrp",
      "id": 8541,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_modulereinforcement_size5_class1": {
      "type": "imrp",
      "id": 8550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianmodulereinforcement_size5_class1": {
      "type": "imrp",
      "id": 8551,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "MRP_HeavyDuty"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_metaalloyhullreinforcement_size1_class2": {
      "type": "imahrp",
      "id": 9141,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_metaalloyhullreinforcement_size1_class1": {
      "type": "imahrp",
      "id": 9151,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_metaalloyhullreinforcement_size2_class2": {
      "type": "imahrp",
      "id": 9241,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_metaalloyhullreinforcement_size2_class1": {
      "type": "imahrp",
      "id": 9251,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_metaalloyhullreinforcement_size3_class2": {
      "type": "imahrp",
      "id": 9341,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_metaalloyhullreinforcement_size3_class1": {
      "type": "imahrp",
      "id": 9351,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_metaalloyhullreinforcement_size4_class2": {
      "type": "imahrp",
      "id": 9441,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_metaalloyhullreinforcement_size4_class1": {
      "type": "imahrp",
      "id": 9451,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_metaalloyhullreinforcement_size5_class2": {
      "type": "imahrp",
      "id": 9541,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_metaalloyhullreinforcement_size5_class1": {
      "type": "imahrp",
      "id": 9551,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_detailedsurfacescanner_tiny": {
      "type": "iss",
      "id": 11130,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_Expanded",
        "Sensor_LongRangeDSS"
      ],
      "experimentals": [],
      "limit": "iss"
    },
    "int_guardianfsdbooster_size1": {
      "type": "ifsdb",
      "id": 12180,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "ifsdb"
    },
    "int_guardianfsdbooster_size2": {
      "type": "ifsdb",
      "id": 12280,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "ifsdb"
    },
    "int_guardianfsdbooster_size3": {
      "type": "ifsdb",
      "id": 12380,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "ifsdb"
    },
    "int_guardianfsdbooster_size4": {
      "type": "ifsdb",
      "id": 12480,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "ifsdb"
    },
    "int_guardianfsdbooster_size5": {
      "type": "ifsdb",
      "id": 12580,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "ifsdb"
    },
    "int_expmodulestabiliser_size3_class3": {
      "type": "iex",
      "id": 13360,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "iex"
    },
    "int_expmodulestabiliser_size5_class3": {
      "type": "iex",
      "id": 13560,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "iex"
    },
    "int_multidronecontrol_operations_size3_class4": {
      "type": "imlc",
      "id": 19322,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "imlc"
    },
    "int_multidronecontrol_xeno_size3_class4": {
      "type": "imlc",
      "id": 19324,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "imlc"
    },
    "int_multidronecontrol_mining_size3_class3": {
      "type": "imlc",
      "id": 19331,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "imlc"
    },
    "int_multidronecontrol_operations_size3_class3": {
      "type": "imlc",
      "id": 19332,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "imlc"
    },
    "int_multidronecontrol_rescue_size3_class3": {
      "type": "imlc",
      "id": 19333,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "imlc"
    },
    "int_multidronecontrol_xeno_size3_class3": {
      "type": "imlc",
      "id": 19334,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "imlc"
    },
    "int_multidronecontrol_rescue_size3_class2": {
      "type": "imlc",
      "id": 19343,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "imlc"
    },
    "int_multidronecontrol_mining_size3_class1": {
      "type": "imlc",
      "id": 19351,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "imlc"
    },
    "int_multidronecontrol_miningv2_size5_class5": {
      "type": "imlc",
      "id": 19511,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "LakonMiner"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": "imlc"
    },
    "int_multidronecontrol_universal_size7_class5": {
      "type": "imlc",
      "id": 19710,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "imlc"
    },
    "int_multidronecontrol_universal_size7_class3": {
      "type": "imlc",
      "id": 19730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "imlc"
    },
    "int_fuelscoop_size1_class5": {
      "type": "ifs",
      "id": 20110,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size1_class4": {
      "type": "ifs",
      "id": 20120,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size1_class3": {
      "type": "ifs",
      "id": 20130,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size1_class2": {
      "type": "ifs",
      "id": 20140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size1_class1": {
      "type": "ifs",
      "id": 20150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size2_class5": {
      "type": "ifs",
      "id": 20210,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size2_class4": {
      "type": "ifs",
      "id": 20220,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size2_class3": {
      "type": "ifs",
      "id": 20230,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size2_class2": {
      "type": "ifs",
      "id": 20240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size2_class1": {
      "type": "ifs",
      "id": 20250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size3_class5": {
      "type": "ifs",
      "id": 20310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size3_class4": {
      "type": "ifs",
      "id": 20320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size3_class3": {
      "type": "ifs",
      "id": 20330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size3_class2": {
      "type": "ifs",
      "id": 20340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size3_class1": {
      "type": "ifs",
      "id": 20350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size4_class5": {
      "type": "ifs",
      "id": 20410,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size4_class4": {
      "type": "ifs",
      "id": 20420,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size4_class3": {
      "type": "ifs",
      "id": 20430,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size4_class2": {
      "type": "ifs",
      "id": 20440,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size4_class1": {
      "type": "ifs",
      "id": 20450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size5_class5": {
      "type": "ifs",
      "id": 20510,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size5_class4": {
      "type": "ifs",
      "id": 20520,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size5_class3": {
      "type": "ifs",
      "id": 20530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size5_class2": {
      "type": "ifs",
      "id": 20540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size5_class1": {
      "type": "ifs",
      "id": 20550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size6_class5": {
      "type": "ifs",
      "id": 20610,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size6_class4": {
      "type": "ifs",
      "id": 20620,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size6_class3": {
      "type": "ifs",
      "id": 20630,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size6_class2": {
      "type": "ifs",
      "id": 20640,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size6_class1": {
      "type": "ifs",
      "id": 20650,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size7_class5": {
      "type": "ifs",
      "id": 20710,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size7_class4": {
      "type": "ifs",
      "id": 20720,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size7_class3": {
      "type": "ifs",
      "id": 20730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size7_class2": {
      "type": "ifs",
      "id": 20740,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size7_class1": {
      "type": "ifs",
      "id": 20750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size8_class5": {
      "type": "ifs",
      "id": 20810,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size8_class4": {
      "type": "ifs",
      "id": 20820,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size8_class3": {
      "type": "ifs",
      "id": 20830,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size8_class2": {
      "type": "ifs",
      "id": 20840,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_fuelscoop_size8_class1": {
      "type": "ifs",
      "id": 20850,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FuelScoop_ScoopRateEnhanced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": "ifs"
    },
    "int_dronecontrol_recon_size1_class1": {
      "type": "inlc",
      "id": 21150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_recon_size3_class1": {
      "type": "inlc",
      "id": 21350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_recon_size5_class1": {
      "type": "inlc",
      "id": 21550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_recon_size7_class1": {
      "type": "inlc",
      "id": 21750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size1_class5": {
      "type": "iclc",
      "id": 22110,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size1_class4": {
      "type": "iclc",
      "id": 22120,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size1_class3": {
      "type": "iclc",
      "id": 22130,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size1_class2": {
      "type": "iclc",
      "id": 22140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size1_class1": {
      "type": "iclc",
      "id": 22150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size3_class5": {
      "type": "iclc",
      "id": 22310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size3_class4": {
      "type": "iclc",
      "id": 22320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size3_class3": {
      "type": "iclc",
      "id": 22330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size3_class2": {
      "type": "iclc",
      "id": 22340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size3_class1": {
      "type": "iclc",
      "id": 22350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size5_class5": {
      "type": "iclc",
      "id": 22510,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size5_class4": {
      "type": "iclc",
      "id": 22520,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size5_class3": {
      "type": "iclc",
      "id": 22530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size5_class2": {
      "type": "iclc",
      "id": 22540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size5_class1": {
      "type": "iclc",
      "id": 22550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size7_class5": {
      "type": "iclc",
      "id": 22710,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size7_class4": {
      "type": "iclc",
      "id": 22720,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size7_class3": {
      "type": "iclc",
      "id": 22730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size7_class2": {
      "type": "iclc",
      "id": 22740,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_collection_size7_class1": {
      "type": "iclc",
      "id": 22750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size1_class5": {
      "type": "iftlc",
      "id": 23110,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size1_class4": {
      "type": "iftlc",
      "id": 23120,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size1_class3": {
      "type": "iftlc",
      "id": 23130,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size1_class2": {
      "type": "iftlc",
      "id": 23140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size1_class1": {
      "type": "iftlc",
      "id": 23150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size3_class5": {
      "type": "iftlc",
      "id": 23310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size3_class4": {
      "type": "iftlc",
      "id": 23320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size3_class3": {
      "type": "iftlc",
      "id": 23330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size3_class2": {
      "type": "iftlc",
      "id": 23340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size3_class1": {
      "type": "iftlc",
      "id": 23350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size5_class5": {
      "type": "iftlc",
      "id": 23510,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size5_class4": {
      "type": "iftlc",
      "id": 23520,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size5_class3": {
      "type": "iftlc",
      "id": 23530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size5_class2": {
      "type": "iftlc",
      "id": 23540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size5_class1": {
      "type": "iftlc",
      "id": 23550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size7_class5": {
      "type": "iftlc",
      "id": 23710,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size7_class4": {
      "type": "iftlc",
      "id": 23720,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size7_class3": {
      "type": "iftlc",
      "id": 23730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size7_class2": {
      "type": "iftlc",
      "id": 23740,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_fueltransfer_size7_class1": {
      "type": "iftlc",
      "id": 23750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size1_class5": {
      "type": "iplc",
      "id": 24110,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size1_class4": {
      "type": "iplc",
      "id": 24120,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size1_class3": {
      "type": "iplc",
      "id": 24130,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size1_class2": {
      "type": "iplc",
      "id": 24140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size1_class1": {
      "type": "iplc",
      "id": 24150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size3_class5": {
      "type": "iplc",
      "id": 24310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size3_class4": {
      "type": "iplc",
      "id": 24320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size3_class3": {
      "type": "iplc",
      "id": 24330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size3_class2": {
      "type": "iplc",
      "id": 24340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size3_class1": {
      "type": "iplc",
      "id": 24350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size5_class5": {
      "type": "iplc",
      "id": 24510,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size5_class4": {
      "type": "iplc",
      "id": 24520,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size5_class3": {
      "type": "iplc",
      "id": 24530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size5_class2": {
      "type": "iplc",
      "id": 24540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size5_class1": {
      "type": "iplc",
      "id": 24550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size7_class5": {
      "type": "iplc",
      "id": 24710,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size7_class4": {
      "type": "iplc",
      "id": 24720,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size7_class3": {
      "type": "iplc",
      "id": 24730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size7_class2": {
      "type": "iplc",
      "id": 24740,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_prospector_size7_class1": {
      "type": "iplc",
      "id": 24750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_fsdinterdictor_size1_class5": {
      "type": "ifsdi",
      "id": 25110,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size1_class4": {
      "type": "ifsdi",
      "id": 25120,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size1_class3": {
      "type": "ifsdi",
      "id": 25130,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size1_class2": {
      "type": "ifsdi",
      "id": 25140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size1_class1": {
      "type": "ifsdi",
      "id": 25150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size2_class5": {
      "type": "ifsdi",
      "id": 25210,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size2_class4": {
      "type": "ifsdi",
      "id": 25220,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size2_class3": {
      "type": "ifsdi",
      "id": 25230,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size2_class2": {
      "type": "ifsdi",
      "id": 25240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size2_class1": {
      "type": "ifsdi",
      "id": 25250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size3_class5": {
      "type": "ifsdi",
      "id": 25310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size3_class4": {
      "type": "ifsdi",
      "id": 25320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size3_class3": {
      "type": "ifsdi",
      "id": 25330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size3_class2": {
      "type": "ifsdi",
      "id": 25340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size3_class1": {
      "type": "ifsdi",
      "id": 25350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size4_class5": {
      "type": "ifsdi",
      "id": 25410,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size4_class4": {
      "type": "ifsdi",
      "id": 25420,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size4_class3": {
      "type": "ifsdi",
      "id": 25430,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size4_class2": {
      "type": "ifsdi",
      "id": 25440,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_fsdinterdictor_size4_class1": {
      "type": "ifsdi",
      "id": 25450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSDinterdictor_Expanded",
        "FSDinterdictor_LongRange"
      ],
      "experimentals": [],
      "limit": "ifsdi"
    },
    "int_dronecontrol_resourcesiphon_size1_class5": {
      "type": "ihblc",
      "id": 26110,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size1_class4": {
      "type": "ihblc",
      "id": 26120,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size1_class3": {
      "type": "ihblc",
      "id": 26130,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size1_class2": {
      "type": "ihblc",
      "id": 26140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size1_class1": {
      "type": "ihblc",
      "id": 26150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon": {
      "type": "ihblc",
      "id": 26191,
      "noUndersize": false,
      "hidden": true,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size3_class5": {
      "type": "ihblc",
      "id": 26310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size3_class4": {
      "type": "ihblc",
      "id": 26320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size3_class3": {
      "type": "ihblc",
      "id": 26330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size3_class2": {
      "type": "ihblc",
      "id": 26340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size3_class1": {
      "type": "ihblc",
      "id": 26350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size5_class5": {
      "type": "ihblc",
      "id": 26510,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size5_class4": {
      "type": "ihblc",
      "id": 26520,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size5_class3": {
      "type": "ihblc",
      "id": 26530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size5_class2": {
      "type": "ihblc",
      "id": 26540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size5_class1": {
      "type": "ihblc",
      "id": 26550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size7_class5": {
      "type": "ihblc",
      "id": 26710,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size7_class4": {
      "type": "ihblc",
      "id": 26720,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size7_class3": {
      "type": "ihblc",
      "id": 26730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size7_class2": {
      "type": "ihblc",
      "id": 26740,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_resourcesiphon_size7_class1": {
      "type": "ihblc",
      "id": 26750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size1_class5": {
      "type": "irlc",
      "id": 27110,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size1_class4": {
      "type": "irlc",
      "id": 27120,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size1_class3": {
      "type": "irlc",
      "id": 27130,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size1_class2": {
      "type": "irlc",
      "id": 27140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size1_class1": {
      "type": "irlc",
      "id": 27150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size3_class5": {
      "type": "irlc",
      "id": 27310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size3_class4": {
      "type": "irlc",
      "id": 27320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size3_class3": {
      "type": "irlc",
      "id": 27330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size3_class2": {
      "type": "irlc",
      "id": 27340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size3_class1": {
      "type": "irlc",
      "id": 27350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size5_class5": {
      "type": "irlc",
      "id": 27510,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size5_class4": {
      "type": "irlc",
      "id": 27520,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size5_class3": {
      "type": "irlc",
      "id": 27530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size5_class2": {
      "type": "irlc",
      "id": 27540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size5_class1": {
      "type": "irlc",
      "id": 27550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size7_class5": {
      "type": "irlc",
      "id": 27710,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size7_class4": {
      "type": "irlc",
      "id": 27720,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size7_class3": {
      "type": "irlc",
      "id": 27730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size7_class2": {
      "type": "irlc",
      "id": 27740,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_repair_size7_class1": {
      "type": "irlc",
      "id": 27750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_unkvesselresearch": {
      "type": "islc",
      "id": 28150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_decontamination_size1_class1": {
      "type": "idlc",
      "id": 29150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_decontamination_size3_class1": {
      "type": "idlc",
      "id": 29350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_decontamination_size5_class1": {
      "type": "idlc",
      "id": 29550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_dronecontrol_decontamination_size7_class1": {
      "type": "idlc",
      "id": 29750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_shieldgenerator_size1_class5": {
      "type": "isg",
      "id": 30110,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size1_class5_strong": {
      "type": "isg",
      "id": 30111,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size1_class3": {
      "type": "isg",
      "id": 30130,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size1_class3_fast": {
      "type": "isg",
      "id": 30132,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size1_class2": {
      "type": "isg",
      "id": 30140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size1_class1": {
      "type": "isg",
      "id": 30150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size2_class5": {
      "type": "isg",
      "id": 30210,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size2_class5_strong": {
      "type": "isg",
      "id": 30211,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size2_class4": {
      "type": "isg",
      "id": 30220,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size2_class3": {
      "type": "isg",
      "id": 30230,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size2_class3_fast": {
      "type": "isg",
      "id": 30232,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size2_class2": {
      "type": "isg",
      "id": 30240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size2_class1": {
      "type": "isg",
      "id": 30250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size3_class5": {
      "type": "isg",
      "id": 30310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size3_class5_strong": {
      "type": "isg",
      "id": 30311,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size3_class4": {
      "type": "isg",
      "id": 30320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size3_class3": {
      "type": "isg",
      "id": 30330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size3_class3_fast": {
      "type": "isg",
      "id": 30332,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size3_class2": {
      "type": "isg",
      "id": 30340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size3_class1": {
      "type": "isg",
      "id": 30350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size4_class5": {
      "type": "isg",
      "id": 30410,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size4_class5_strong": {
      "type": "isg",
      "id": 30411,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size4_class4": {
      "type": "isg",
      "id": 30420,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size4_class3": {
      "type": "isg",
      "id": 30430,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size4_class3_fast": {
      "type": "isg",
      "id": 30432,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size4_class2": {
      "type": "isg",
      "id": 30440,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size4_class1": {
      "type": "isg",
      "id": 30450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size5_class5": {
      "type": "isg",
      "id": 30510,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size5_class5_strong": {
      "type": "isg",
      "id": 30511,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size5_class4": {
      "type": "isg",
      "id": 30520,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size5_class3": {
      "type": "isg",
      "id": 30530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size5_class3_fast": {
      "type": "isg",
      "id": 30532,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size5_class2": {
      "type": "isg",
      "id": 30540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size5_class1": {
      "type": "isg",
      "id": 30550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size6_class5": {
      "type": "isg",
      "id": 30610,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size6_class5_strong": {
      "type": "isg",
      "id": 30611,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size6_class4": {
      "type": "isg",
      "id": 30620,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size6_class3": {
      "type": "isg",
      "id": 30630,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size6_class3_fast": {
      "type": "isg",
      "id": 30632,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size6_class2": {
      "type": "isg",
      "id": 30640,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size6_class1": {
      "type": "isg",
      "id": 30650,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size7_class5": {
      "type": "isg",
      "id": 30710,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size7_class5_strong": {
      "type": "isg",
      "id": 30711,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size7_class4": {
      "type": "isg",
      "id": 30720,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size7_class3": {
      "type": "isg",
      "id": 30730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size7_class3_fast": {
      "type": "isg",
      "id": 30732,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size7_class2": {
      "type": "isg",
      "id": 30740,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size7_class1": {
      "type": "isg",
      "id": 30750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size8_class5": {
      "type": "isg",
      "id": 30810,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size8_class5_strong": {
      "type": "isg",
      "id": 30811,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size8_class4": {
      "type": "isg",
      "id": 30820,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size8_class3": {
      "type": "isg",
      "id": 30830,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size8_class3_fast": {
      "type": "isg",
      "id": 30832,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size8_class2": {
      "type": "isg",
      "id": 30840,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldgenerator_size8_class1": {
      "type": "isg",
      "id": 30850,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldGenerator_Optimised",
        "ShieldGenerator_Kinetic",
        "ShieldGenerator_Reinforced",
        "ShieldGenerator_Thermic"
      ],
      "experimentals": [
        "special_shield_toughened",
        "special_shield_regenerative",
        "special_shield_kinetic",
        "special_shield_health",
        "special_shield_efficient",
        "special_shield_resistive",
        "special_shield_lightweight",
        "special_shield_thermic"
      ],
      "limit": "isg"
    },
    "int_shieldcellbank_size1_class5": {
      "type": "iscb",
      "id": 31110,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size1_class4": {
      "type": "iscb",
      "id": 31120,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size1_class3": {
      "type": "iscb",
      "id": 31130,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size1_class2": {
      "type": "iscb",
      "id": 31140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size1_class1": {
      "type": "iscb",
      "id": 31150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size2_class5": {
      "type": "iscb",
      "id": 31210,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size2_class4": {
      "type": "iscb",
      "id": 31220,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size2_class3": {
      "type": "iscb",
      "id": 31230,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size2_class2": {
      "type": "iscb",
      "id": 31240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size2_class1": {
      "type": "iscb",
      "id": 31250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size3_class5": {
      "type": "iscb",
      "id": 31310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size3_class4": {
      "type": "iscb",
      "id": 31320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size3_class3": {
      "type": "iscb",
      "id": 31330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size3_class2": {
      "type": "iscb",
      "id": 31340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size3_class1": {
      "type": "iscb",
      "id": 31350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size4_class5": {
      "type": "iscb",
      "id": 31410,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size4_class4": {
      "type": "iscb",
      "id": 31420,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size4_class3": {
      "type": "iscb",
      "id": 31430,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size4_class2": {
      "type": "iscb",
      "id": 31440,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size4_class1": {
      "type": "iscb",
      "id": 31450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size5_class5": {
      "type": "iscb",
      "id": 31510,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size5_class4": {
      "type": "iscb",
      "id": 31520,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size5_class3": {
      "type": "iscb",
      "id": 31530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size5_class2": {
      "type": "iscb",
      "id": 31540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size5_class1": {
      "type": "iscb",
      "id": 31550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size6_class5": {
      "type": "iscb",
      "id": 31610,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size6_class4": {
      "type": "iscb",
      "id": 31620,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size6_class3": {
      "type": "iscb",
      "id": 31630,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size6_class2": {
      "type": "iscb",
      "id": 31640,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size6_class1": {
      "type": "iscb",
      "id": 31650,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size7_class5": {
      "type": "iscb",
      "id": 31710,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size7_class4": {
      "type": "iscb",
      "id": 31720,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size7_class3": {
      "type": "iscb",
      "id": 31730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size7_class2": {
      "type": "iscb",
      "id": 31740,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size7_class1": {
      "type": "iscb",
      "id": 31750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size8_class5": {
      "type": "iscb",
      "id": 31810,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size8_class4": {
      "type": "iscb",
      "id": 31820,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size8_class3": {
      "type": "iscb",
      "id": 31830,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size8_class2": {
      "type": "iscb",
      "id": 31840,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_shieldcellbank_size8_class1": {
      "type": "iscb",
      "id": 31850,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldCellBank_Rapid",
        "ShieldCellBank_Specialised"
      ],
      "experimentals": [
        "special_shieldcell_oversized",
        "special_shieldcell_toughened",
        "special_shieldcell_efficient",
        "special_shieldcell_gradual",
        "special_shieldcell_lightweight"
      ],
      "limit": null
    },
    "int_guardianshieldreinforcement_size1_class2": {
      "type": "isrp",
      "id": 32141,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianshieldreinforcement_size1_class1": {
      "type": "isrp",
      "id": 32151,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianshieldreinforcement_size2_class2": {
      "type": "isrp",
      "id": 32241,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianshieldreinforcement_size2_class1": {
      "type": "isrp",
      "id": 32251,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianshieldreinforcement_size3_class2": {
      "type": "isrp",
      "id": 32341,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianshieldreinforcement_size3_class1": {
      "type": "isrp",
      "id": 32351,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianshieldreinforcement_size4_class2": {
      "type": "isrp",
      "id": 32441,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianshieldreinforcement_size4_class1": {
      "type": "isrp",
      "id": 32451,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianshieldreinforcement_size5_class2": {
      "type": "isrp",
      "id": 32541,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_guardianshieldreinforcement_size5_class1": {
      "type": "isrp",
      "id": 32551,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_powerplant_size2_class5": {
      "type": "cpp",
      "id": 41210,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_guardianpowerplant_size2": {
      "type": "cpp",
      "id": 41211,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size2_class4": {
      "type": "cpp",
      "id": 41220,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size2_class3": {
      "type": "cpp",
      "id": 41230,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size2_class2": {
      "type": "cpp",
      "id": 41240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size2_class1": {
      "type": "cpp",
      "id": 41250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size3_class5": {
      "type": "cpp",
      "id": 41310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_guardianpowerplant_size3": {
      "type": "cpp",
      "id": 41311,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size3_class4": {
      "type": "cpp",
      "id": 41320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size3_class3": {
      "type": "cpp",
      "id": 41330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size3_class2": {
      "type": "cpp",
      "id": 41340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size3_class1": {
      "type": "cpp",
      "id": 41350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size4_class5": {
      "type": "cpp",
      "id": 41410,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_guardianpowerplant_size4": {
      "type": "cpp",
      "id": 41411,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size4_class4": {
      "type": "cpp",
      "id": 41420,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size4_class3": {
      "type": "cpp",
      "id": 41430,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size4_class2": {
      "type": "cpp",
      "id": 41440,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size4_class1": {
      "type": "cpp",
      "id": 41450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size5_class5": {
      "type": "cpp",
      "id": 41510,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_guardianpowerplant_size5": {
      "type": "cpp",
      "id": 41511,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size5_class4": {
      "type": "cpp",
      "id": 41520,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size5_class3": {
      "type": "cpp",
      "id": 41530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size5_class2": {
      "type": "cpp",
      "id": 41540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size5_class1": {
      "type": "cpp",
      "id": 41550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size6_class5": {
      "type": "cpp",
      "id": 41610,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_guardianpowerplant_size6": {
      "type": "cpp",
      "id": 41611,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size6_class4": {
      "type": "cpp",
      "id": 41620,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size6_class3": {
      "type": "cpp",
      "id": 41630,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size6_class2": {
      "type": "cpp",
      "id": 41640,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size6_class1": {
      "type": "cpp",
      "id": 41650,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size7_class5": {
      "type": "cpp",
      "id": 41710,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_guardianpowerplant_size7": {
      "type": "cpp",
      "id": 41711,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size7_class4": {
      "type": "cpp",
      "id": 41720,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size7_class3": {
      "type": "cpp",
      "id": 41730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size7_class2": {
      "type": "cpp",
      "id": 41740,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size7_class1": {
      "type": "cpp",
      "id": 41750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size8_class5": {
      "type": "cpp",
      "id": 41810,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_guardianpowerplant_size8": {
      "type": "cpp",
      "id": 41811,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size8_class4": {
      "type": "cpp",
      "id": 41820,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size8_class3": {
      "type": "cpp",
      "id": 41830,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size8_class2": {
      "type": "cpp",
      "id": 41840,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_powerplant_size8_class1": {
      "type": "cpp",
      "id": 41850,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerPlant_Armoured",
        "PowerPlant_Stealth",
        "PowerPlant_Boosted"
      ],
      "experimentals": [
        "special_powerplant_toughened",
        "special_powerplant_highcharge",
        "special_powerplant_lightweight",
        "special_powerplant_cooled"
      ],
      "limit": null
    },
    "int_engine_size2_class5": {
      "type": "ct",
      "id": 42210,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size2_class5_fast": {
      "type": "ct",
      "id": 42211,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size2_class4": {
      "type": "ct",
      "id": 42220,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size2_class3": {
      "type": "ct",
      "id": 42230,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size2_class2": {
      "type": "ct",
      "id": 42240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size2_class1": {
      "type": "ct",
      "id": 42250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size3_class5": {
      "type": "ct",
      "id": 42310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size3_class5_fast": {
      "type": "ct",
      "id": 42311,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size3_class4": {
      "type": "ct",
      "id": 42320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size3_class3": {
      "type": "ct",
      "id": 42330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size3_class2": {
      "type": "ct",
      "id": 42340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size3_class1": {
      "type": "ct",
      "id": 42350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size4_class5": {
      "type": "ct",
      "id": 42410,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size4_class4": {
      "type": "ct",
      "id": 42420,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size4_class3": {
      "type": "ct",
      "id": 42430,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size4_class2": {
      "type": "ct",
      "id": 42440,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size4_class1": {
      "type": "ct",
      "id": 42450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size5_class5": {
      "type": "ct",
      "id": 42510,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_mkiiagileboost_engine_size5_class5": {
      "type": "ct",
      "id": 42513,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "SmallCombat01_NX"
      ],
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size5_class4": {
      "type": "ct",
      "id": 42520,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size5_class3": {
      "type": "ct",
      "id": 42530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size5_class2": {
      "type": "ct",
      "id": 42540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size5_class1": {
      "type": "ct",
      "id": 42550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size6_class5": {
      "type": "ct",
      "id": 42610,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size6_class4": {
      "type": "ct",
      "id": 42620,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size6_class3": {
      "type": "ct",
      "id": 42630,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size6_class2": {
      "type": "ct",
      "id": 42640,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size6_class1": {
      "type": "ct",
      "id": 42650,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size7_class5": {
      "type": "ct",
      "id": 42710,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size7_class5_gravityoptimised_mkii": {
      "type": "ct",
      "id": 42712,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "Explorer_NX"
      ],
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size7_class4": {
      "type": "ct",
      "id": 42720,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size7_class3": {
      "type": "ct",
      "id": 42730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size7_class2": {
      "type": "ct",
      "id": 42740,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size7_class1": {
      "type": "ct",
      "id": 42750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size8_class5": {
      "type": "ct",
      "id": 42810,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size8_class4": {
      "type": "ct",
      "id": 42820,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size8_class3": {
      "type": "ct",
      "id": 42830,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size8_class2": {
      "type": "ct",
      "id": 42840,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_engine_size8_class1": {
      "type": "ct",
      "id": 42850,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Engine_Tuned",
        "Engine_Dirty",
        "Engine_Reinforced"
      ],
      "experimentals": [
        "special_engine_toughened",
        "special_engine_overloaded",
        "special_engine_haulage",
        "special_engine_lightweight",
        "special_engine_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size2_class5": {
      "type": "cfsd",
      "id": 43210,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size2_class5": {
      "type": "cfsdo",
      "id": 43211,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size2_class4": {
      "type": "cfsd",
      "id": 43220,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size2_class4": {
      "type": "cfsdo",
      "id": 43221,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size2_class3": {
      "type": "cfsd",
      "id": 43230,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size2_class3": {
      "type": "cfsdo",
      "id": 43231,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size2_class2": {
      "type": "cfsd",
      "id": 43240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size2_class2": {
      "type": "cfsdo",
      "id": 43241,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size2_class1": {
      "type": "cfsd",
      "id": 43250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size2_class1": {
      "type": "cfsdo",
      "id": 43251,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size3_class5": {
      "type": "cfsd",
      "id": 43310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size3_class5": {
      "type": "cfsdo",
      "id": 43311,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size3_class4": {
      "type": "cfsd",
      "id": 43320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size3_class4": {
      "type": "cfsdo",
      "id": 43321,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size3_class3": {
      "type": "cfsd",
      "id": 43330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size3_class3": {
      "type": "cfsdo",
      "id": 43331,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size3_class2": {
      "type": "cfsd",
      "id": 43340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size3_class2": {
      "type": "cfsdo",
      "id": 43341,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size3_class1": {
      "type": "cfsd",
      "id": 43350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size3_class1": {
      "type": "cfsdo",
      "id": 43351,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size4_class5": {
      "type": "cfsd",
      "id": 43410,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size4_class5": {
      "type": "cfsdo",
      "id": 43411,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size4_class4": {
      "type": "cfsd",
      "id": 43420,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size4_class4": {
      "type": "cfsdo",
      "id": 43421,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size4_class3": {
      "type": "cfsd",
      "id": 43430,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size4_class3": {
      "type": "cfsdo",
      "id": 43431,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size4_class2": {
      "type": "cfsd",
      "id": 43440,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size4_class2": {
      "type": "cfsdo",
      "id": 43441,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size4_class1": {
      "type": "cfsd",
      "id": 43450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size4_class1": {
      "type": "cfsdo",
      "id": 43451,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size5_class5": {
      "type": "cfsd",
      "id": 43510,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size5_class5": {
      "type": "cfsdo",
      "id": 43511,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size5_class4": {
      "type": "cfsd",
      "id": 43520,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size5_class4": {
      "type": "cfsdo",
      "id": 43521,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size5_class3": {
      "type": "cfsd",
      "id": 43530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size5_class3": {
      "type": "cfsdo",
      "id": 43531,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size5_class2": {
      "type": "cfsd",
      "id": 43540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size5_class2": {
      "type": "cfsdo",
      "id": 43541,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size5_class1": {
      "type": "cfsd",
      "id": 43550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size5_class1": {
      "type": "cfsdo",
      "id": 43551,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size6_class5": {
      "type": "cfsd",
      "id": 43610,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size6_class5": {
      "type": "cfsdo",
      "id": 43611,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size6_class4": {
      "type": "cfsd",
      "id": 43620,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size6_class4": {
      "type": "cfsdo",
      "id": 43621,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size6_class3": {
      "type": "cfsd",
      "id": 43630,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size6_class3": {
      "type": "cfsdo",
      "id": 43631,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size6_class2": {
      "type": "cfsd",
      "id": 43640,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size6_class2": {
      "type": "cfsdo",
      "id": 43641,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size6_class1": {
      "type": "cfsd",
      "id": 43650,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size6_class1": {
      "type": "cfsdo",
      "id": 43651,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size7_class5": {
      "type": "cfsd",
      "id": 43710,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size7_class5": {
      "type": "cfsdo",
      "id": 43711,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size7_class4": {
      "type": "cfsd",
      "id": 43720,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size7_class4": {
      "type": "cfsdo",
      "id": 43721,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size7_class3": {
      "type": "cfsd",
      "id": 43730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size7_class3": {
      "type": "cfsdo",
      "id": 43731,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size7_class2": {
      "type": "cfsd",
      "id": 43740,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size7_class2": {
      "type": "cfsdo",
      "id": 43741,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_size7_class1": {
      "type": "cfsd",
      "id": 43750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size7_class1": {
      "type": "cfsdo",
      "id": 43751,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size8_class5": {
      "type": "cfsdo",
      "id": 43811,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size8_class5_overchargebooster_mkii": {
      "type": "cfsdo",
      "id": 43812,
      "noUndersize": true,
      "hidden": false,
      "ships": [
        "Explorer_NX"
      ],
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size8_class4": {
      "type": "cfsdo",
      "id": 43821,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size8_class3": {
      "type": "cfsdo",
      "id": 43831,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size8_class2": {
      "type": "cfsdo",
      "id": 43841,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_hyperdrive_overcharge_size8_class1": {
      "type": "cfsdo",
      "id": 43851,
      "noUndersize": true,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "FSD_FastBoot",
        "FSD_LongRange",
        "FSD_Shielded"
      ],
      "experimentals": [
        "special_fsd_fuelcapacity",
        "special_fsd_toughened",
        "special_fsd_heavy",
        "special_fsd_lightweight",
        "special_fsd_cooled"
      ],
      "limit": null
    },
    "int_lifesupport_size1_class5": {
      "type": "cls",
      "id": 44110,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size1_class4": {
      "type": "cls",
      "id": 44120,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size1_class3": {
      "type": "cls",
      "id": 44130,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size1_class2": {
      "type": "cls",
      "id": 44140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size1_class1": {
      "type": "cls",
      "id": 44150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size2_class5": {
      "type": "cls",
      "id": 44210,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size2_class4": {
      "type": "cls",
      "id": 44220,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size2_class3": {
      "type": "cls",
      "id": 44230,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size2_class2": {
      "type": "cls",
      "id": 44240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size2_class1": {
      "type": "cls",
      "id": 44250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size3_class5": {
      "type": "cls",
      "id": 44310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size3_class4": {
      "type": "cls",
      "id": 44320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size3_class3": {
      "type": "cls",
      "id": 44330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size3_class2": {
      "type": "cls",
      "id": 44340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size3_class1": {
      "type": "cls",
      "id": 44350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size4_class5": {
      "type": "cls",
      "id": 44410,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size4_class4": {
      "type": "cls",
      "id": 44420,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size4_class3": {
      "type": "cls",
      "id": 44430,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size4_class2": {
      "type": "cls",
      "id": 44440,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size4_class1": {
      "type": "cls",
      "id": 44450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size5_class5": {
      "type": "cls",
      "id": 44510,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size5_class4": {
      "type": "cls",
      "id": 44520,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size5_class3": {
      "type": "cls",
      "id": 44530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size5_class2": {
      "type": "cls",
      "id": 44540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size5_class1": {
      "type": "cls",
      "id": 44550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size6_class5": {
      "type": "cls",
      "id": 44610,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size6_class4": {
      "type": "cls",
      "id": 44620,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size6_class3": {
      "type": "cls",
      "id": 44630,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size6_class2": {
      "type": "cls",
      "id": 44640,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size6_class1": {
      "type": "cls",
      "id": 44650,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size7_class5": {
      "type": "cls",
      "id": 44710,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size7_class4": {
      "type": "cls",
      "id": 44720,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size7_class3": {
      "type": "cls",
      "id": 44730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size7_class2": {
      "type": "cls",
      "id": 44740,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size7_class1": {
      "type": "cls",
      "id": 44750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size8_class5": {
      "type": "cls",
      "id": 44810,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size8_class4": {
      "type": "cls",
      "id": 44820,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size8_class3": {
      "type": "cls",
      "id": 44830,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size8_class2": {
      "type": "cls",
      "id": 44840,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_lifesupport_size8_class1": {
      "type": "cls",
      "id": 44850,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_powerdistributor_size1_class5": {
      "type": "cpd",
      "id": 45110,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_guardianpowerdistributor_size1": {
      "type": "cpd",
      "id": 45111,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size1_class4": {
      "type": "cpd",
      "id": 45120,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size1_class3": {
      "type": "cpd",
      "id": 45130,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size1_class2": {
      "type": "cpd",
      "id": 45140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size1_class1": {
      "type": "cpd",
      "id": 45150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size2_class5": {
      "type": "cpd",
      "id": 45210,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_guardianpowerdistributor_size2": {
      "type": "cpd",
      "id": 45211,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size2_class4": {
      "type": "cpd",
      "id": 45220,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size2_class3": {
      "type": "cpd",
      "id": 45230,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size2_class2": {
      "type": "cpd",
      "id": 45240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size2_class1": {
      "type": "cpd",
      "id": 45250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size3_class5": {
      "type": "cpd",
      "id": 45310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_guardianpowerdistributor_size3": {
      "type": "cpd",
      "id": 45311,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size3_class4": {
      "type": "cpd",
      "id": 45320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size3_class3": {
      "type": "cpd",
      "id": 45330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size3_class2": {
      "type": "cpd",
      "id": 45340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size3_class1": {
      "type": "cpd",
      "id": 45350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size4_class5": {
      "type": "cpd",
      "id": 45410,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_guardianpowerdistributor_size4": {
      "type": "cpd",
      "id": 45411,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size4_class4": {
      "type": "cpd",
      "id": 45420,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size4_class3": {
      "type": "cpd",
      "id": 45430,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size4_class2": {
      "type": "cpd",
      "id": 45440,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size4_class1": {
      "type": "cpd",
      "id": 45450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size5_class5": {
      "type": "cpd",
      "id": 45510,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_guardianpowerdistributor_size5": {
      "type": "cpd",
      "id": 45511,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size5_class4": {
      "type": "cpd",
      "id": 45520,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size5_class3": {
      "type": "cpd",
      "id": 45530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size5_class2": {
      "type": "cpd",
      "id": 45540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size5_class1": {
      "type": "cpd",
      "id": 45550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size6_class5": {
      "type": "cpd",
      "id": 45610,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_guardianpowerdistributor_size6": {
      "type": "cpd",
      "id": 45611,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size6_class4": {
      "type": "cpd",
      "id": 45620,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size6_class3": {
      "type": "cpd",
      "id": 45630,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size6_class2": {
      "type": "cpd",
      "id": 45640,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size6_class1": {
      "type": "cpd",
      "id": 45650,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size7_class5": {
      "type": "cpd",
      "id": 45710,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_guardianpowerdistributor_size7": {
      "type": "cpd",
      "id": 45711,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size7_class4": {
      "type": "cpd",
      "id": 45720,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size7_class3": {
      "type": "cpd",
      "id": 45730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size7_class2": {
      "type": "cpd",
      "id": 45740,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size7_class1": {
      "type": "cpd",
      "id": 45750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size8_class5": {
      "type": "cpd",
      "id": 45810,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_guardianpowerdistributor_size8": {
      "type": "cpd",
      "id": 45811,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "GuardianModule_Sturdy",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size8_class4": {
      "type": "cpd",
      "id": 45820,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size8_class3": {
      "type": "cpd",
      "id": 45830,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size8_class2": {
      "type": "cpd",
      "id": 45840,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_powerdistributor_size8_class1": {
      "type": "cpd",
      "id": 45850,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "PowerDistributor_HighFrequency",
        "PowerDistributor_PriorityEngines",
        "PowerDistributor_HighCapacity",
        "PowerDistributor_Shielded",
        "PowerDistributor_PrioritySystems",
        "PowerDistributor_PriorityWeapons",
        "PowerDistributor_Balanced",
        "PowerDistributor_SupportFocused"
      ],
      "experimentals": [
        "special_powerdistributor_capacity",
        "special_powerdistributor_toughened",
        "special_powerdistributor_efficient",
        "special_powerdistributor_lightweight",
        "special_powerdistributor_fast"
      ],
      "limit": null
    },
    "int_sensors_size1_class5": {
      "type": "cs",
      "id": 46110,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size1_class4": {
      "type": "cs",
      "id": 46120,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size1_class3": {
      "type": "cs",
      "id": 46130,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size1_class2": {
      "type": "cs",
      "id": 46140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size1_class1": {
      "type": "cs",
      "id": 46150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size2_class5": {
      "type": "cs",
      "id": 46210,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size2_class4": {
      "type": "cs",
      "id": 46220,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size2_class3": {
      "type": "cs",
      "id": 46230,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size2_class2": {
      "type": "cs",
      "id": 46240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size2_class1": {
      "type": "cs",
      "id": 46250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size3_class5": {
      "type": "cs",
      "id": 46310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size3_class4": {
      "type": "cs",
      "id": 46320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size3_class3": {
      "type": "cs",
      "id": 46330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size3_class2": {
      "type": "cs",
      "id": 46340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size3_class1": {
      "type": "cs",
      "id": 46350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size4_class5": {
      "type": "cs",
      "id": 46410,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size4_class4": {
      "type": "cs",
      "id": 46420,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size4_class3": {
      "type": "cs",
      "id": 46430,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size4_class2": {
      "type": "cs",
      "id": 46440,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size4_class1": {
      "type": "cs",
      "id": 46450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size5_class5": {
      "type": "cs",
      "id": 46510,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size5_class4": {
      "type": "cs",
      "id": 46520,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size5_class3": {
      "type": "cs",
      "id": 46530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size5_class2": {
      "type": "cs",
      "id": 46540,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size5_class1": {
      "type": "cs",
      "id": 46550,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size6_class5": {
      "type": "cs",
      "id": 46610,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size6_class4": {
      "type": "cs",
      "id": 46620,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size6_class3": {
      "type": "cs",
      "id": 46630,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size6_class2": {
      "type": "cs",
      "id": 46640,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size6_class1": {
      "type": "cs",
      "id": 46650,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size7_class5": {
      "type": "cs",
      "id": 46710,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size7_class4": {
      "type": "cs",
      "id": 46720,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size7_class3": {
      "type": "cs",
      "id": 46730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size7_class2": {
      "type": "cs",
      "id": 46740,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size7_class1": {
      "type": "cs",
      "id": 46750,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size8_class5": {
      "type": "cs",
      "id": 46810,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size8_class4": {
      "type": "cs",
      "id": 46820,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size8_class3": {
      "type": "cs",
      "id": 46830,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size8_class2": {
      "type": "cs",
      "id": 46840,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_sensors_size8_class1": {
      "type": "cs",
      "id": 46850,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_LightWeight",
        "Sensor_LongRange",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": null
    },
    "int_fueltank_size1_class3": {
      "type": "cft",
      "id": 47130,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_fueltank_size2_class3": {
      "type": "cft",
      "id": 47230,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_fueltank_size3_class3": {
      "type": "cft",
      "id": 47330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_fueltank_size4_class3": {
      "type": "cft",
      "id": 47430,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_fueltank_size5_class3": {
      "type": "cft",
      "id": 47530,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_fueltank_size6_class3": {
      "type": "cft",
      "id": 47630,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_fueltank_size7_class3": {
      "type": "cft",
      "id": 47730,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "int_fueltank_size8_class3": {
      "type": "cft",
      "id": 47830,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "modularcargobaydoor": {
      "type": "cch",
      "id": 49180,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_chafflauncher_tiny": {
      "type": "ucl",
      "id": 50090,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_ChaffCapacity",
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "hpt_electroniccountermeasure_tiny": {
      "type": "uec",
      "id": 51060,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "hpt_heatsinklauncher_turret_tiny": {
      "type": "uhsl",
      "id": 52090,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_HeatSinkCapacity",
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "hpt_causticsinklauncher_turret_tiny": {
      "type": "uhsl",
      "id": 52091,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_HeatSinkCapacity",
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "hpt_plasmapointdefence_turret_tiny": {
      "type": "upd",
      "id": 53090,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Misc_PointDefenseCapacity",
        "Misc_LightWeight",
        "Misc_Reinforced",
        "Misc_Shielded"
      ],
      "experimentals": [],
      "limit": null
    },
    "hpt_shieldbooster_size0_class5": {
      "type": "usb",
      "id": 54010,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldBooster_Explosive",
        "ShieldBooster_HeavyDuty",
        "ShieldBooster_Kinetic",
        "ShieldBooster_Resistive",
        "ShieldBooster_Thermic"
      ],
      "experimentals": [
        "special_shieldbooster_explosive",
        "special_shieldbooster_toughened",
        "special_shieldbooster_efficient",
        "special_shieldbooster_kinetic",
        "special_shieldbooster_chunky",
        "special_shieldbooster_thermic"
      ],
      "limit": null
    },
    "hpt_shieldbooster_size0_class4": {
      "type": "usb",
      "id": 54020,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldBooster_Explosive",
        "ShieldBooster_HeavyDuty",
        "ShieldBooster_Kinetic",
        "ShieldBooster_Resistive",
        "ShieldBooster_Thermic"
      ],
      "experimentals": [
        "special_shieldbooster_explosive",
        "special_shieldbooster_toughened",
        "special_shieldbooster_efficient",
        "special_shieldbooster_kinetic",
        "special_shieldbooster_chunky",
        "special_shieldbooster_thermic"
      ],
      "limit": null
    },
    "hpt_shieldbooster_size0_class3": {
      "type": "usb",
      "id": 54030,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldBooster_Explosive",
        "ShieldBooster_HeavyDuty",
        "ShieldBooster_Kinetic",
        "ShieldBooster_Resistive",
        "ShieldBooster_Thermic"
      ],
      "experimentals": [
        "special_shieldbooster_explosive",
        "special_shieldbooster_toughened",
        "special_shieldbooster_efficient",
        "special_shieldbooster_kinetic",
        "special_shieldbooster_chunky",
        "special_shieldbooster_thermic"
      ],
      "limit": null
    },
    "hpt_shieldbooster_size0_class2": {
      "type": "usb",
      "id": 54040,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldBooster_Explosive",
        "ShieldBooster_HeavyDuty",
        "ShieldBooster_Kinetic",
        "ShieldBooster_Resistive",
        "ShieldBooster_Thermic"
      ],
      "experimentals": [
        "special_shieldbooster_explosive",
        "special_shieldbooster_toughened",
        "special_shieldbooster_efficient",
        "special_shieldbooster_kinetic",
        "special_shieldbooster_chunky",
        "special_shieldbooster_thermic"
      ],
      "limit": null
    },
    "hpt_shieldbooster_size0_class1": {
      "type": "usb",
      "id": 54050,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "ShieldBooster_Explosive",
        "ShieldBooster_HeavyDuty",
        "ShieldBooster_Kinetic",
        "ShieldBooster_Resistive",
        "ShieldBooster_Thermic"
      ],
      "experimentals": [
        "special_shieldbooster_explosive",
        "special_shieldbooster_toughened",
        "special_shieldbooster_efficient",
        "special_shieldbooster_kinetic",
        "special_shieldbooster_chunky",
        "special_shieldbooster_thermic"
      ],
      "limit": null
    },
    "hpt_cargoscanner_size0_class5": {
      "type": "ucs",
      "id": 55010,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_FastScan",
        "Misc_LightWeight",
        "Sensor_LongRange",
        "Misc_Reinforced",
        "Misc_Shielded",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": "ucs"
    },
    "hpt_cargoscanner_size0_class4": {
      "type": "ucs",
      "id": 55020,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_FastScan",
        "Misc_LightWeight",
        "Sensor_LongRange",
        "Misc_Reinforced",
        "Misc_Shielded",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": "ucs"
    },
    "hpt_cargoscanner_size0_class3": {
      "type": "ucs",
      "id": 55030,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_FastScan",
        "Misc_LightWeight",
        "Sensor_LongRange",
        "Misc_Reinforced",
        "Misc_Shielded",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": "ucs"
    },
    "hpt_cargoscanner_size0_class2": {
      "type": "ucs",
      "id": 55040,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_FastScan",
        "Misc_LightWeight",
        "Sensor_LongRange",
        "Misc_Reinforced",
        "Misc_Shielded",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": "ucs"
    },
    "hpt_cargoscanner_size0_class1": {
      "type": "ucs",
      "id": 55050,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_FastScan",
        "Misc_LightWeight",
        "Sensor_LongRange",
        "Misc_Reinforced",
        "Misc_Shielded",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": "ucs"
    },
    "hpt_cloudscanner_size0_class5": {
      "type": "ufsws",
      "id": 56010,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_FastScan",
        "Misc_LightWeight",
        "Sensor_LongRange",
        "Misc_Reinforced",
        "Misc_Shielded",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": "ufsws"
    },
    "hpt_cloudscanner_size0_class4": {
      "type": "ufsws",
      "id": 56020,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_FastScan",
        "Misc_LightWeight",
        "Sensor_LongRange",
        "Misc_Reinforced",
        "Misc_Shielded",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": "ufsws"
    },
    "hpt_cloudscanner_size0_class3": {
      "type": "ufsws",
      "id": 56030,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_FastScan",
        "Misc_LightWeight",
        "Sensor_LongRange",
        "Misc_Reinforced",
        "Misc_Shielded",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": "ufsws"
    },
    "hpt_cloudscanner_size0_class2": {
      "type": "ufsws",
      "id": 56040,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_FastScan",
        "Misc_LightWeight",
        "Sensor_LongRange",
        "Misc_Reinforced",
        "Misc_Shielded",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": "ufsws"
    },
    "hpt_cloudscanner_size0_class1": {
      "type": "ufsws",
      "id": 56050,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_FastScan",
        "Misc_LightWeight",
        "Sensor_LongRange",
        "Misc_Reinforced",
        "Misc_Shielded",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": "ufsws"
    },
    "hpt_crimescanner_size0_class5": {
      "type": "ukws",
      "id": 57010,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_FastScan",
        "Misc_LightWeight",
        "Sensor_LongRange",
        "Misc_Reinforced",
        "Misc_Shielded",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": "ukws"
    },
    "hpt_crimescanner_size0_class4": {
      "type": "ukws",
      "id": 57020,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_FastScan",
        "Misc_LightWeight",
        "Sensor_LongRange",
        "Misc_Reinforced",
        "Misc_Shielded",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": "ukws"
    },
    "hpt_crimescanner_size0_class3": {
      "type": "ukws",
      "id": 57030,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_FastScan",
        "Misc_LightWeight",
        "Sensor_LongRange",
        "Misc_Reinforced",
        "Misc_Shielded",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": "ukws"
    },
    "hpt_crimescanner_size0_class2": {
      "type": "ukws",
      "id": 57040,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_FastScan",
        "Misc_LightWeight",
        "Sensor_LongRange",
        "Misc_Reinforced",
        "Misc_Shielded",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": "ukws"
    },
    "hpt_crimescanner_size0_class1": {
      "type": "ukws",
      "id": 57050,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Sensor_FastScan",
        "Misc_LightWeight",
        "Sensor_LongRange",
        "Misc_Reinforced",
        "Misc_Shielded",
        "Sensor_WideAngle"
      ],
      "experimentals": [],
      "limit": "ukws"
    },
    "hpt_xenoscannermk2_basic_tiny": {
      "type": "uex",
      "id": 58030,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "uex"
    },
    "hpt_xenoscanner_advanced_tiny": {
      "type": "uex",
      "id": 58031,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "uex"
    },
    "hpt_xenoscanner_basic_tiny": {
      "type": "uex",
      "id": 58050,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "uex"
    },
    "hpt_antiunknownshutdown_tiny_v2": {
      "type": "uex",
      "id": 58052,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_antiunknownshutdown_tiny": {
      "type": "uex",
      "id": 58061,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_mrascanner_size0_class5": {
      "type": "upwa",
      "id": 59010,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "upwa"
    },
    "hpt_mrascanner_size0_class4": {
      "type": "upwa",
      "id": 59020,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "upwa"
    },
    "hpt_mrascanner_size0_class3": {
      "type": "upwa",
      "id": 59030,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "upwa"
    },
    "hpt_mrascanner_size0_class2": {
      "type": "upwa",
      "id": 59040,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "upwa"
    },
    "hpt_mrascanner_size0_class1": {
      "type": "upwa",
      "id": 59050,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "upwa"
    },
    "hpt_beamlaser_fixed_small": {
      "type": "hel",
      "id": 60150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BeamLaser_Overloaded"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_damage",
        "special_regeneration_sequence",
        "special_weapon_lightweight",
        "special_thermal_conduit",
        "special_thermalshock",
        "special_thermal_vent"
      ],
      "limit": null
    },
    "hpt_beamlaser_gimbal_small": {
      "type": "hel",
      "id": 60151,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BeamLaser_Overloaded"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_damage",
        "special_regeneration_sequence",
        "special_weapon_lightweight",
        "special_thermal_conduit",
        "special_thermalshock",
        "special_thermal_vent"
      ],
      "limit": null
    },
    "hpt_beamlaser_fixed_small_heat": {
      "type": "hel",
      "id": 60154,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BeamLaser_Overloaded"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_damage",
        "special_regeneration_sequence",
        "special_weapon_lightweight",
        "special_thermal_conduit",
        "special_thermalshock",
        "special_thermal_vent"
      ],
      "limit": null
    },
    "hpt_beamlaser_turret_small": {
      "type": "hel",
      "id": 60162,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BeamLaser_Overloaded"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_damage",
        "special_regeneration_sequence",
        "special_weapon_lightweight",
        "special_thermal_conduit",
        "special_thermalshock",
        "special_thermal_vent"
      ],
      "limit": null
    },
    "hpt_beamlaser_fixed_medium": {
      "type": "hel",
      "id": 60240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BeamLaser_Overloaded"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_damage",
        "special_regeneration_sequence",
        "special_weapon_lightweight",
        "special_thermal_conduit",
        "special_thermalshock",
        "special_thermal_vent"
      ],
      "limit": null
    },
    "hpt_beamlaser_gimbal_medium": {
      "type": "hel",
      "id": 60241,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BeamLaser_Overloaded"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_damage",
        "special_regeneration_sequence",
        "special_weapon_lightweight",
        "special_thermal_conduit",
        "special_thermalshock",
        "special_thermal_vent"
      ],
      "limit": null
    },
    "hpt_beamlaser_turret_medium": {
      "type": "hel",
      "id": 60252,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BeamLaser_Overloaded"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_damage",
        "special_regeneration_sequence",
        "special_weapon_lightweight",
        "special_thermal_conduit",
        "special_thermalshock",
        "special_thermal_vent"
      ],
      "limit": null
    },
    "hpt_beamlaser_fixed_large": {
      "type": "hel",
      "id": 60330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BeamLaser_Overloaded"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_damage",
        "special_regeneration_sequence",
        "special_weapon_lightweight",
        "special_thermal_conduit",
        "special_thermalshock",
        "special_thermal_vent"
      ],
      "limit": null
    },
    "hpt_beamlaser_gimbal_large": {
      "type": "hel",
      "id": 60331,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BeamLaser_Overloaded"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_damage",
        "special_regeneration_sequence",
        "special_weapon_lightweight",
        "special_thermal_conduit",
        "special_thermalshock",
        "special_thermal_vent"
      ],
      "limit": null
    },
    "hpt_beamlaser_turret_large": {
      "type": "hel",
      "id": 60332,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BeamLaser_Overloaded"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_damage",
        "special_regeneration_sequence",
        "special_weapon_lightweight",
        "special_thermal_conduit",
        "special_thermalshock",
        "special_thermal_vent"
      ],
      "limit": null
    },
    "hpt_beamlaser_fixed_huge": {
      "type": "hel",
      "id": 60410,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BeamLaser_Overloaded"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_damage",
        "special_regeneration_sequence",
        "special_weapon_lightweight",
        "special_thermal_conduit",
        "special_thermalshock",
        "special_thermal_vent"
      ],
      "limit": null
    },
    "hpt_beamlaser_gimbal_huge": {
      "type": "hel",
      "id": 60411,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BeamLaser_Overloaded"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_damage",
        "special_regeneration_sequence",
        "special_weapon_lightweight",
        "special_thermal_conduit",
        "special_thermalshock",
        "special_thermal_vent"
      ],
      "limit": null
    },
    "hpt_pulselaserburst_fixed_small": {
      "type": "hul",
      "id": 61160,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BurstLaser_Regenerative"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_distortion_field",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock",
        "special_regeneration_sequence"
      ],
      "limit": null
    },
    "hpt_pulselaserburst_fixed_small_scatter": {
      "type": "hul",
      "id": 61164,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BurstLaser_Regenerative"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_distortion_field",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock",
        "special_regeneration_sequence"
      ],
      "limit": null
    },
    "hpt_pulselaserburst_gimbal_small": {
      "type": "hul",
      "id": 61171,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BurstLaser_Regenerative"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_distortion_field",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock",
        "special_regeneration_sequence"
      ],
      "limit": null
    },
    "hpt_pulselaserburst_turret_small": {
      "type": "hul",
      "id": 61172,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BurstLaser_Regenerative"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_distortion_field",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock",
        "special_regeneration_sequence"
      ],
      "limit": null
    },
    "hpt_pulselaserburst_fixed_medium": {
      "type": "hul",
      "id": 61250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BurstLaser_Regenerative"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_distortion_field",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock",
        "special_regeneration_sequence"
      ],
      "limit": null
    },
    "hpt_pulselaserburst_gimbal_medium": {
      "type": "hul",
      "id": 61261,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BurstLaser_Regenerative"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_distortion_field",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock",
        "special_regeneration_sequence"
      ],
      "limit": null
    },
    "hpt_pulselaserburst_turret_medium": {
      "type": "hul",
      "id": 61262,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BurstLaser_Regenerative"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_distortion_field",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock",
        "special_regeneration_sequence"
      ],
      "limit": null
    },
    "hpt_pulselaserburst_fixed_large": {
      "type": "hul",
      "id": 61340,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BurstLaser_Regenerative"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_distortion_field",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock",
        "special_regeneration_sequence"
      ],
      "limit": null
    },
    "hpt_pulselaserburst_gimbal_large": {
      "type": "hul",
      "id": 61351,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BurstLaser_Regenerative"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_distortion_field",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock",
        "special_regeneration_sequence"
      ],
      "limit": null
    },
    "hpt_pulselaserburst_turret_large": {
      "type": "hul",
      "id": 61352,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BurstLaser_Regenerative"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_distortion_field",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock",
        "special_regeneration_sequence"
      ],
      "limit": null
    },
    "hpt_pulselaserburst_fixed_huge": {
      "type": "hul",
      "id": 61450,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BurstLaser_Regenerative"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_distortion_field",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock",
        "special_regeneration_sequence"
      ],
      "limit": null
    },
    "hpt_pulselaserburst_gimbal_huge": {
      "type": "hul",
      "id": 61451,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion",
        "BurstLaser_Regenerative"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_distortion_field",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock",
        "special_regeneration_sequence"
      ],
      "limit": null
    },
    "hpt_pulselaser_fixed_small": {
      "type": "hpl",
      "id": 62160,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_pulselaser_gimbal_small": {
      "type": "hpl",
      "id": 62171,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_pulselaser_turret_small": {
      "type": "hpl",
      "id": 62172,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_pulselaser_fixed_medium": {
      "type": "hpl",
      "id": 62250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_pulselaser_fixed_medium_disruptor": {
      "type": "hpl",
      "id": 62254,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_pulselaser_gimbal_medium": {
      "type": "hpl",
      "id": 62261,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_pulselaser_turret_medium": {
      "type": "hpl",
      "id": 62262,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_pulselaser_fixed_large": {
      "type": "hpl",
      "id": 62350,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_pulselaser_gimbal_large": {
      "type": "hpl",
      "id": 62361,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_pulselaser_turret_large": {
      "type": "hpl",
      "id": 62362,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_pulselaser_fixed_huge": {
      "type": "hpl",
      "id": 62410,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_pulselaser_gimbal_huge": {
      "type": "hpl",
      "id": 62411,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_PlasmaConversion"
      ],
      "experimentals": [
        "special_concordant_sequence",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_scramble_spectrum",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_cannon_fixed_small": {
      "type": "hc",
      "id": 70140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Cannon_ForceImpact"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_force_shell",
        "special_high_yield_shell",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_cannon_gimbal_small": {
      "type": "hc",
      "id": 70151,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Cannon_ForceImpact"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_force_shell",
        "special_high_yield_shell",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_cannon_turret_small": {
      "type": "hc",
      "id": 70162,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Cannon_ForceImpact"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_force_shell",
        "special_high_yield_shell",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_cannon_fixed_medium": {
      "type": "hc",
      "id": 70240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Cannon_ForceImpact"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_force_shell",
        "special_high_yield_shell",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_cannon_gimbal_medium": {
      "type": "hc",
      "id": 70241,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Cannon_ForceImpact"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_force_shell",
        "special_high_yield_shell",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_cannon_gimbal_medium_burst": {
      "type": "hc",
      "id": 70244,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Cannon_ForceImpact"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_force_shell",
        "special_high_yield_shell",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_cannon_turret_medium": {
      "type": "hc",
      "id": 70252,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Cannon_ForceImpact"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_force_shell",
        "special_high_yield_shell",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_cannon_fixed_large": {
      "type": "hc",
      "id": 70330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Cannon_ForceImpact"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_force_shell",
        "special_high_yield_shell",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_cannon_gimbal_large": {
      "type": "hc",
      "id": 70331,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Cannon_ForceImpact"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_force_shell",
        "special_high_yield_shell",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_cannon_turret_large": {
      "type": "hc",
      "id": 70342,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Cannon_ForceImpact"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_force_shell",
        "special_high_yield_shell",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_cannon_fixed_huge": {
      "type": "hc",
      "id": 70420,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Cannon_ForceImpact"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_force_shell",
        "special_high_yield_shell",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_cannon_gimbal_huge": {
      "type": "hc",
      "id": 70421,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Cannon_ForceImpact"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_force_shell",
        "special_high_yield_shell",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_slugshot_fixed_small": {
      "type": "hfc",
      "id": 71150,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_DoubleShot",
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DoubleScreaming"
      ],
      "experimentals": [
        "special_corrosive_shell",
        "special_blinding_shell",
        "special_weapon_toughened",
        "special_drag_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_screening_shell",
        "special_weapon_lightweight"
      ],
      "limit": null
    },
    "hpt_slugshot_gimbal_small": {
      "type": "hfc",
      "id": 71151,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_DoubleShot",
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DoubleScreaming"
      ],
      "experimentals": [
        "special_corrosive_shell",
        "special_blinding_shell",
        "special_weapon_toughened",
        "special_drag_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_screening_shell",
        "special_weapon_lightweight"
      ],
      "limit": null
    },
    "hpt_slugshot_turret_small": {
      "type": "hfc",
      "id": 71152,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_DoubleShot",
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DoubleScreaming"
      ],
      "experimentals": [
        "special_corrosive_shell",
        "special_blinding_shell",
        "special_weapon_toughened",
        "special_drag_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_screening_shell",
        "special_weapon_lightweight"
      ],
      "limit": null
    },
    "hpt_slugshot_fixed_medium": {
      "type": "hfc",
      "id": 71210,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_DoubleShot",
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DoubleScreaming"
      ],
      "experimentals": [
        "special_corrosive_shell",
        "special_blinding_shell",
        "special_weapon_toughened",
        "special_drag_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_screening_shell",
        "special_weapon_lightweight"
      ],
      "limit": null
    },
    "hpt_slugshot_gimbal_medium": {
      "type": "hfc",
      "id": 71241,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_DoubleShot",
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DoubleScreaming"
      ],
      "experimentals": [
        "special_corrosive_shell",
        "special_blinding_shell",
        "special_weapon_toughened",
        "special_drag_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_screening_shell",
        "special_weapon_lightweight"
      ],
      "limit": null
    },
    "hpt_slugshot_turret_medium": {
      "type": "hfc",
      "id": 71242,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_DoubleShot",
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DoubleScreaming"
      ],
      "experimentals": [
        "special_corrosive_shell",
        "special_blinding_shell",
        "special_weapon_toughened",
        "special_drag_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_screening_shell",
        "special_weapon_lightweight"
      ],
      "limit": null
    },
    "hpt_slugshot_fixed_large": {
      "type": "hfc",
      "id": 71330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_DoubleShot",
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DoubleScreaming"
      ],
      "experimentals": [
        "special_corrosive_shell",
        "special_blinding_shell",
        "special_weapon_toughened",
        "special_drag_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_screening_shell",
        "special_weapon_lightweight"
      ],
      "limit": null
    },
    "hpt_slugshot_gimbal_large": {
      "type": "hfc",
      "id": 71331,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_DoubleShot",
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DoubleScreaming"
      ],
      "experimentals": [
        "special_corrosive_shell",
        "special_blinding_shell",
        "special_weapon_toughened",
        "special_drag_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_screening_shell",
        "special_weapon_lightweight"
      ],
      "limit": null
    },
    "hpt_slugshot_turret_large": {
      "type": "hfc",
      "id": 71332,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_DoubleShot",
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DoubleScreaming"
      ],
      "experimentals": [
        "special_corrosive_shell",
        "special_blinding_shell",
        "special_weapon_toughened",
        "special_drag_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_screening_shell",
        "special_weapon_lightweight"
      ],
      "limit": null
    },
    "hpt_slugshot_fixed_large_range": {
      "type": "hfc",
      "id": 71334,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_DoubleShot",
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DoubleScreaming"
      ],
      "experimentals": [
        "special_corrosive_shell",
        "special_blinding_shell",
        "special_weapon_toughened",
        "special_drag_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_screening_shell",
        "special_weapon_lightweight"
      ],
      "limit": null
    },
    "hpt_multicannon_fixed_small_strong": {
      "type": "hmc",
      "id": 72144,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_RapidPhase"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_corrosive_shell",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_multicannon_fixed_small": {
      "type": "hmc",
      "id": 72160,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_RapidPhase"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_corrosive_shell",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_multicannon_fixed_small_advanced": {
      "type": "hmc",
      "id": 72163,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_RapidPhase"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_corrosive_shell",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_multicannon_gimbal_small": {
      "type": "hmc",
      "id": 72171,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_RapidPhase"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_corrosive_shell",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_multicannon_turret_small": {
      "type": "hmc",
      "id": 72172,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_RapidPhase"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_corrosive_shell",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_multicannon_fixed_medium": {
      "type": "hmc",
      "id": 72250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_RapidPhase"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_corrosive_shell",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermalshock",
        "special_phasing_sequence"
      ],
      "limit": null
    },
    "hpt_multicannon_fixed_medium_advanced": {
      "type": "hmc",
      "id": 72253,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_RapidPhase"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_corrosive_shell",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_multicannon_gimbal_medium": {
      "type": "hmc",
      "id": 72261,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_RapidPhase"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_corrosive_shell",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_multicannon_turret_medium": {
      "type": "hmc",
      "id": 72262,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_RapidPhase"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_corrosive_shell",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_multicannon_fixed_large": {
      "type": "hmc",
      "id": 72330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_RapidPhase"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_corrosive_shell",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_multicannon_gimbal_large": {
      "type": "hmc",
      "id": 72331,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_RapidPhase"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_corrosive_shell",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_multicannon_turret_large": {
      "type": "hmc",
      "id": 72352,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_RapidPhase"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_corrosive_shell",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_multicannon_fixed_huge": {
      "type": "hmc",
      "id": 72410,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_RapidPhase"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_corrosive_shell",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_multicannon_gimbal_huge": {
      "type": "hmc",
      "id": 72411,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_RapidPhase"
      ],
      "experimentals": [
        "special_auto_loader",
        "special_corrosive_shell",
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_incendiary_rounds",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_smart_rounds",
        "special_weapon_lightweight",
        "special_thermalshock"
      ],
      "limit": null
    },
    "hpt_minelauncher_fixed_small": {
      "type": "hm",
      "id": 80190,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_RapidFire",
        "Weapon_Sturdy"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_choke_canister",
        "special_overload_munitions",
        "special_weapon_damage",
        "special_radiant_canister",
        "special_reverberating_cascade",
        "special_shiftlock_canister",
        "special_weapon_lightweight"
      ],
      "limit": null
    },
    "hpt_minelauncher_fixed_small_impulse": {
      "type": "hm",
      "id": 80191,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_RapidFire",
        "Weapon_Sturdy"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_choke_canister",
        "special_overload_munitions",
        "special_weapon_damage",
        "special_radiant_canister",
        "special_reverberating_cascade",
        "special_shiftlock_canister",
        "special_weapon_lightweight"
      ],
      "limit": null
    },
    "hpt_minelauncher_fixed_medium": {
      "type": "hm",
      "id": 80290,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_RapidFire",
        "Weapon_Sturdy"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_choke_canister",
        "special_overload_munitions",
        "special_weapon_damage",
        "special_radiant_canister",
        "special_reverberating_cascade",
        "special_shiftlock_canister",
        "special_weapon_lightweight"
      ],
      "limit": null
    },
    "hpt_miningtoolv2_fixed_large": {
      "type": "hmtl",
      "id": 80339,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "LakonMiner"
      ],
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_mining_subsurfdispmisle_fixed_small": {
      "type": "hmtm",
      "id": 81127,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_mining_subsurfdispmisle_turret_small": {
      "type": "hmtm",
      "id": 81128,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_mininglaser_fixed_small": {
      "type": "hmtl",
      "id": 81140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_LongRange",
        "Weapon_FarReaching",
        "Weapon_LongRangeMiningLaser"
      ],
      "experimentals": [
        "special_incendiary_rounds"
      ],
      "limit": null
    },
    "hpt_mining_abrblstr_fixed_small": {
      "type": "hmtl",
      "id": 81141,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_LongRange",
        "Weapon_FarReaching",
        "Weapon_LongRangeMiningLaser"
      ],
      "experimentals": [],
      "limit": null
    },
    "hpt_mininglaser_turret_small": {
      "type": "hmtl",
      "id": 81142,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_mining_abrblstr_turret_small": {
      "type": "hmtl",
      "id": 81143,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_mininglaser_fixed_small_advanced": {
      "type": "hmtl",
      "id": 81144,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_mining_seismchrgwarhd_fixed_medium": {
      "type": "hmtm",
      "id": 81225,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_mining_seismchrgwarhd_turret_medium": {
      "type": "hmtm",
      "id": 81226,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_mining_subsurfdispmisle_fixed_medium": {
      "type": "hmtm",
      "id": 81227,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_mining_subsurfdispmisle_turret_medium": {
      "type": "hmtm",
      "id": 81228,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_human_extraction_fixed_medium": {
      "type": "hmtm",
      "id": 81229,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_mininglaser_fixed_medium": {
      "type": "hmtl",
      "id": 81240,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_mininglaser_turret_medium": {
      "type": "hmtl",
      "id": 81242,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_dumbfiremissilerack_fixed_small": {
      "type": "hmr",
      "id": 82120,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DragSeeker",
        "Weapon_LightweightThermalSeeker",
        "Weapon_LockdownSeeker"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_fsd_interrupt",
        "special_weapon_rateoffire",
        "special_overload_munitions",
        "special_weapon_damage",
        "special_penetrator_munitions",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_basicmissilerack_fixed_small": {
      "type": "hmr",
      "id": 82123,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DragSeeker",
        "Weapon_LightweightThermalSeeker",
        "Weapon_LockdownSeeker"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_overload_munitions",
        "special_weapon_damage",
        "special_weapon_lightweight",
        "special_thermal_cascade",
        "special_drag_munitions"
      ],
      "limit": null
    },
    "hpt_dumbfiremissilerack_fixed_small_advanced": {
      "type": "hmr",
      "id": 82126,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DragSeeker",
        "Weapon_LightweightThermalSeeker",
        "Weapon_LockdownSeeker"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_fsd_interrupt",
        "special_weapon_rateoffire",
        "special_overload_munitions",
        "special_weapon_damage",
        "special_penetrator_munitions",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_dumbfiremissilerack_fixed_medium": {
      "type": "hmr",
      "id": 82220,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DragSeeker",
        "Weapon_LightweightThermalSeeker",
        "Weapon_LockdownSeeker"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_fsd_interrupt",
        "special_weapon_rateoffire",
        "special_overload_munitions",
        "special_weapon_damage",
        "special_penetrator_munitions",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_basicmissilerack_fixed_medium": {
      "type": "hmr",
      "id": 82223,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DragSeeker",
        "Weapon_LightweightThermalSeeker",
        "Weapon_LockdownSeeker"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_fsd_interrupt",
        "special_weapon_rateoffire",
        "special_overload_munitions",
        "special_weapon_damage",
        "special_weapon_lightweight",
        "special_thermal_cascade",
        "special_drag_munitions"
      ],
      "limit": null
    },
    "hpt_drunkmissilerack_fixed_medium": {
      "type": "hmr",
      "id": 82224,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DragSeeker",
        "Weapon_LightweightThermalSeeker",
        "Weapon_LockdownSeeker"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_overload_munitions",
        "special_weapon_damage",
        "special_weapon_lightweight",
        "special_thermal_cascade",
        "special_drag_munitions"
      ],
      "limit": null
    },
    "hpt_dumbfiremissilerack_fixed_medium_lasso": {
      "type": "hmr",
      "id": 82225,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DragSeeker",
        "Weapon_LightweightThermalSeeker",
        "Weapon_LockdownSeeker"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_fsd_interrupt",
        "special_weapon_rateoffire",
        "special_overload_munitions",
        "special_weapon_damage",
        "special_penetrator_munitions",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_dumbfiremissilerack_fixed_medium_advanced": {
      "type": "hmr",
      "id": 82226,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DragSeeker",
        "Weapon_LightweightThermalSeeker",
        "Weapon_LockdownSeeker"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_fsd_interrupt",
        "special_weapon_rateoffire",
        "special_overload_munitions",
        "special_weapon_damage",
        "special_penetrator_munitions",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_dumbfiremissilerack_fixed_large": {
      "type": "hmr",
      "id": 82310,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DragSeeker",
        "Weapon_LightweightThermalSeeker",
        "Weapon_LockdownSeeker"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_fsd_interrupt",
        "special_weapon_rateoffire",
        "special_overload_munitions",
        "special_weapon_damage",
        "special_penetrator_munitions",
        "special_weapon_lightweight",
        "special_thermal_cascade"
      ],
      "limit": null
    },
    "hpt_basicmissilerack_fixed_large": {
      "type": "hmr",
      "id": 82313,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_RapidFire",
        "Weapon_Sturdy",
        "Weapon_DragSeeker",
        "Weapon_LightweightThermalSeeker",
        "Weapon_LockdownSeeker"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_emissive_munitions",
        "special_weapon_efficient",
        "special_fsd_interrupt",
        "special_weapon_rateoffire",
        "special_overload_munitions",
        "special_weapon_damage",
        "special_weapon_lightweight",
        "special_thermal_cascade",
        "special_drag_munitions"
      ],
      "limit": null
    },
    "hpt_plasmaaccelerator_fixed_medium": {
      "type": "hpa",
      "id": 83230,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy"
      ],
      "experimentals": [
        "special_blinding_shell",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_plasma_slug",
        "special_weapon_lightweight",
        "special_lock_breaker",
        "special_thermal_conduit"
      ],
      "limit": null
    },
    "hpt_plasmaaccelerator_fixed_large": {
      "type": "hpa",
      "id": 83320,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy"
      ],
      "experimentals": [
        "special_blinding_shell",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_plasma_slug",
        "special_weapon_lightweight",
        "special_lock_breaker",
        "special_thermal_conduit"
      ],
      "limit": null
    },
    "hpt_plasmaaccelerator_fixed_large_advanced": {
      "type": "hpa",
      "id": 83324,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy"
      ],
      "experimentals": [
        "special_blinding_shell",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_plasma_slug",
        "special_weapon_lightweight",
        "special_lock_breaker",
        "special_thermal_conduit"
      ],
      "limit": null
    },
    "hpt_mkiiplasmashockautocannon_fixed_large": {
      "type": "hpa",
      "id": 83325,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "SmallCombat01_NX"
      ],
      "blueprints": [],
      "experimentals": [
        "special_blinding_shell",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_plasma_slug",
        "special_weapon_lightweight",
        "special_lock_breaker",
        "special_thermal_conduit"
      ],
      "limit": null
    },
    "hpt_plasmaaccelerator_fixed_huge": {
      "type": "hpa",
      "id": 83410,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Efficient",
        "Weapon_Focused",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_Overcharged",
        "Weapon_RapidFire",
        "Weapon_ShortRange",
        "Weapon_Sturdy"
      ],
      "experimentals": [
        "special_blinding_shell",
        "special_dispersal_field",
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_phasing_sequence",
        "special_plasma_slug",
        "special_weapon_lightweight",
        "special_lock_breaker",
        "special_thermal_conduit"
      ],
      "limit": null
    },
    "hpt_railgun_fixed_small": {
      "type": "hrg",
      "id": 84140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_EnduringFeedback"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_feedback_cascade_cooled",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_plasma_slug_cooled",
        "special_weapon_lightweight",
        "special_super_penetrator_cooled",
        "special_super_penetrator"
      ],
      "limit": null
    },
    "hpt_railgun_fixed_medium": {
      "type": "hrg",
      "id": 84220,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_EnduringFeedback"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_feedback_cascade_cooled",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_plasma_slug_cooled",
        "special_weapon_lightweight",
        "special_super_penetrator_cooled",
        "special_super_penetrator"
      ],
      "limit": null
    },
    "hpt_railgun_fixed_medium_burst": {
      "type": "hrg",
      "id": 84224,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_LightWeight",
        "Weapon_LongRange",
        "Weapon_ShortRange",
        "Weapon_Sturdy",
        "Weapon_EnduringFeedback"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_feedback_cascade_cooled",
        "special_weapon_efficient",
        "special_weapon_rateoffire",
        "special_weapon_damage",
        "special_plasma_slug_cooled",
        "special_weapon_lightweight",
        "special_super_penetrator_cooled",
        "special_super_penetrator"
      ],
      "limit": null
    },
    "hpt_advancedtorppylon_fixed_small": {
      "type": "htp",
      "id": 85193,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_LightWeight",
        "Weapon_Sturdy"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_mass_lock",
        "special_weapon_damage",
        "special_deep_cut_payload",
        "special_reverberating_cascade",
        "special_weapon_lightweight"
      ],
      "limit": null
    },
    "hpt_advancedtorppylon_fixed_medium": {
      "type": "htp",
      "id": 85293,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_LightWeight",
        "Weapon_Sturdy"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_mass_lock",
        "special_weapon_damage",
        "special_deep_cut_payload",
        "special_reverberating_cascade",
        "special_weapon_lightweight"
      ],
      "limit": null
    },
    "hpt_advancedtorppylon_fixed_large": {
      "type": "htp",
      "id": 85393,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_LightWeight",
        "Weapon_Sturdy"
      ],
      "experimentals": [
        "special_weapon_toughened",
        "special_weapon_efficient",
        "special_mass_lock",
        "special_weapon_damage",
        "special_deep_cut_payload",
        "special_reverberating_cascade",
        "special_weapon_lightweight"
      ],
      "limit": null
    },
    "hpt_flakmortar_fixed_medium": {
      "type": "hex",
      "id": 86226,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_flakmortar_turret_medium": {
      "type": "hex",
      "id": 86228,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Decorative_Green",
        "Decorative_Pink",
        "Decorative_Red",
        "Decorative_Yellow",
        "Weapon_HighYieldEnzyme"
      ],
      "experimentals": [],
      "limit": null
    },
    "hpt_atdumbfiremissile_fixed_medium_v2": {
      "type": "hexxm",
      "id": 86241,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_atmulticannon_fixed_medium_v2": {
      "type": "hexxc",
      "id": 86246,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [
        "special_auto_loader"
      ],
      "limit": "hex"
    },
    "hpt_atdumbfiremissile_fixed_medium": {
      "type": "hexxm",
      "id": 86250,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_atmulticannon_fixed_medium": {
      "type": "hexxc",
      "id": 86253,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [
        "special_auto_loader"
      ],
      "limit": "hex"
    },
    "hpt_atmulticannon_gimbal_medium": {
      "type": "hexxc",
      "id": 86257,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Overcharged"
      ],
      "experimentals": [
        "special_auto_loader"
      ],
      "limit": "hex"
    },
    "hpt_atmulticannon_turret_medium_v2": {
      "type": "hexxc",
      "id": 86258,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [
        "special_auto_loader"
      ],
      "limit": "hex"
    },
    "hpt_atdumbfiremissile_turret_medium_v2": {
      "type": "hexxm",
      "id": 86259,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_atdumbfiremissile_turret_medium": {
      "type": "hexxm",
      "id": 86262,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_atmulticannon_turret_medium": {
      "type": "hexxc",
      "id": 86265,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [
        "special_auto_loader"
      ],
      "limit": "hex"
    },
    "hpt_atdumbfiremissile_fixed_large_v2": {
      "type": "hexxm",
      "id": 86321,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_atmulticannon_fixed_large_v2": {
      "type": "hexxc",
      "id": 86326,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [
        "special_auto_loader"
      ],
      "limit": "hex"
    },
    "hpt_atdumbfiremissile_fixed_large": {
      "type": "hexxm",
      "id": 86330,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_atmulticannon_fixed_large": {
      "type": "hexxc",
      "id": 86333,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [
        "special_auto_loader"
      ],
      "limit": "hex"
    },
    "hpt_atmulticannon_gimbal_large": {
      "type": "hexxc",
      "id": 86337,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Overcharged"
      ],
      "experimentals": [
        "special_auto_loader"
      ],
      "limit": "hex"
    },
    "hpt_atmulticannon_turret_large_v2": {
      "type": "hexxc",
      "id": 86348,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [
        "special_auto_loader"
      ],
      "limit": "hex"
    },
    "hpt_atdumbfiremissile_turret_large_v2": {
      "type": "hexxm",
      "id": 86349,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_atdumbfiremissile_turret_large": {
      "type": "hexxm",
      "id": 86352,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_atmulticannon_turret_large": {
      "type": "hexxc",
      "id": 86355,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [
        "special_auto_loader"
      ],
      "limit": "hex"
    },
    "hpt_plasmashockcannon_fixed_small": {
      "type": "hexsc",
      "id": 87144,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_plasmashockcannon_gimbal_small": {
      "type": "hexsc",
      "id": 87155,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_plasmashockcannon_turret_small": {
      "type": "hexsc",
      "id": 87166,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_causticmissile_fixed_medium": {
      "type": "hex",
      "id": 87220,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_HighCapacity",
        "Weapon_HighYieldEnzyme"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_flechettelauncher_turret_medium": {
      "type": "hex",
      "id": 87222,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_flechettelauncher_fixed_medium": {
      "type": "hex",
      "id": 87223,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_plasmashockcannon_fixed_medium": {
      "type": "hexsc",
      "id": 87244,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_plasmashockcannon_gimbal_medium": {
      "type": "hexsc",
      "id": 87245,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_plasmashockcannon_turret_medium": {
      "type": "hexsc",
      "id": 87256,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_plasmashockcannon_fixed_large": {
      "type": "hexsc",
      "id": 87334,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_plasmashockcannon_gimbal_large": {
      "type": "hexsc",
      "id": 87335,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_plasmashockcannon_turret_large": {
      "type": "hexsc",
      "id": 87346,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_guardian_gausscannon_fixed_small": {
      "type": "hexgg",
      "id": 88140,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_RapidFire",
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_guardian_plasmalauncher_fixed_small": {
      "type": "hexgp",
      "id": 88143,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Overcharged",
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_guardian_shardcannon_fixed_small": {
      "type": "hexgs",
      "id": 88146,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_LongRange",
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_guardian_plasmalauncher_turret_small": {
      "type": "hexgp",
      "id": 88165,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Overcharged",
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_guardian_shardcannon_turret_small": {
      "type": "hexgs",
      "id": 88168,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_LongRange",
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_guardian_shardcannon_fixed_medium": {
      "type": "hexgs",
      "id": 88216,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_LongRange",
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_guardian_shardcannon_turret_medium": {
      "type": "hexgs",
      "id": 88218,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_LongRange",
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_guardian_gausscannon_fixed_medium": {
      "type": "hexgg",
      "id": 88220,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_RapidFire",
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_guardian_plasmalauncher_fixed_medium": {
      "type": "hexgp",
      "id": 88223,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Overcharged",
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_guardian_plasmalauncher_turret_medium": {
      "type": "hexgp",
      "id": 88255,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Overcharged",
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_atventdisruptorpylon_fixed_medium": {
      "type": "hextp",
      "id": 88299,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "hpt_guardian_plasmalauncher_fixed_large": {
      "type": "hexgp",
      "id": 88333,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Overcharged",
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_guardian_shardcannon_fixed_large": {
      "type": "hexgs",
      "id": 88336,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_LongRange",
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_guardian_plasmalauncher_turret_large": {
      "type": "hexgp",
      "id": 88345,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_Overcharged",
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_guardian_shardcannon_turret_large": {
      "type": "hexgs",
      "id": 88348,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Weapon_LongRange",
        "GuardianModule_Sturdy"
      ],
      "experimentals": [],
      "limit": "hex"
    },
    "hpt_atventdisruptorpylon_fixed_large": {
      "type": "hextp",
      "id": 88399,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [],
      "experimentals": [],
      "limit": null
    },
    "sidewinder_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "sidewinder_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "sidewinder_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "sidewinder_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "sidewinder_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cobramkiii_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cobramkiii_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cobramkiii_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cobramkiii_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cobramkiii_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "empire_trader_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "empire_trader_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "empire_trader_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "empire_trader_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "empire_trader_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_dropship_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_dropship_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_dropship_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_dropship_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_dropship_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "python_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "python_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "python_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "python_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "python_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "anaconda_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "anaconda_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "anaconda_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "anaconda_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "anaconda_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "empire_courier_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "empire_courier_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "empire_courier_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "empire_courier_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "empire_courier_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cobramkiv_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cobramkiv_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cobramkiv_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cobramkiv_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cobramkiv_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "typex_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "typex_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "typex_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "typex_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "typex_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "typex_2_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "typex_2_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "typex_2_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "typex_2_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "typex_2_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "krait_light_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "krait_light_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "krait_light_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "krait_light_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "krait_light_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "mamba_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "mamba_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "mamba_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "mamba_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "mamba_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "typex_3_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "typex_3_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "typex_3_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "typex_3_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "typex_3_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "krait_mkii_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "krait_mkii_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "krait_mkii_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "krait_mkii_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "krait_mkii_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "python_nx_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "python_nx_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "python_nx_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "python_nx_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "python_nx_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cobramkv_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cobramkv_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cobramkv_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cobramkv_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cobramkv_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "corsair_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "corsair_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "corsair_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "corsair_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "corsair_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "anacondamkii_armour_reactive": {
      "type": "cbh",
      "id": 40110,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "Explorer_NX"
      ],
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "anacondamkii_armour_grade3": {
      "type": "cbh",
      "id": 40118,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "Explorer_NX"
      ],
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "anacondamkii_armour_mirrored": {
      "type": "cbh",
      "id": 40119,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "Explorer_NX"
      ],
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "anacondamkii_armour_grade2": {
      "type": "cbh",
      "id": 40127,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "Explorer_NX"
      ],
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "anacondamkii_armour_grade1_default": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "anacondamkii_armour_grade1": {
      "type": "cbh",
      "id": 40136,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "Explorer_NX"
      ],
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "eagle_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "eagle_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "eagle_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "eagle_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "eagle_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "viper_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "viper_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "viper_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "viper_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "viper_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "vulture_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "vulture_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "vulture_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "vulture_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "vulture_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "ferdelance_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "ferdelance_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "ferdelance_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "ferdelance_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "ferdelance_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "empire_eagle_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "empire_eagle_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "empire_eagle_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "empire_eagle_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "empire_eagle_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_dropship_mkii_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_dropship_mkii_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_dropship_mkii_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_dropship_mkii_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_dropship_mkii_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_gunship_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_gunship_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_gunship_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_gunship_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_gunship_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "viper_mkiv_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "viper_mkiv_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "viper_mkiv_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "viper_mkiv_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "viper_mkiv_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "smallcombat01_nx_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "smallcombat01_nx_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "smallcombat01_nx_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "smallcombat01_nx_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "smallcombat01_nx_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "hauler_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "hauler_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "hauler_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "hauler_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "hauler_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type6_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type6_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type6_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type6_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type6_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type7_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type7_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type7_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type7_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type7_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type9_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type9_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type9_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type9_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type9_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "independant_trader_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "independant_trader_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "independant_trader_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "independant_trader_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "independant_trader_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type9_military_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type9_military_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type9_military_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type9_military_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type9_military_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type8_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type8_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type8_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type8_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "type8_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "lakonminer_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "lakonminer_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "lakonminer_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "lakonminer_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "lakonminer_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "adder_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "adder_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "adder_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "adder_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "adder_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "asp_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "asp_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "asp_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "asp_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "asp_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "diamondback_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "diamondback_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "diamondback_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "diamondback_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "diamondback_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "diamondbackxl_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "diamondbackxl_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "diamondbackxl_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "diamondbackxl_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "diamondbackxl_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "asp_scout_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "asp_scout_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "asp_scout_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "asp_scout_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "asp_scout_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "mandalay_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "mandalay_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "mandalay_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "mandalay_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "mandalay_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "explorer_nx_armour_reactive": {
      "type": "cbh",
      "id": 40110,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "Explorer_NX"
      ],
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "explorer_nx_armour_grade3": {
      "type": "cbh",
      "id": 40118,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "Explorer_NX"
      ],
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "explorer_nx_armour_mirrored": {
      "type": "cbh",
      "id": 40119,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "Explorer_NX"
      ],
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "explorer_nx_armour_grade2": {
      "type": "cbh",
      "id": 40127,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "Explorer_NX"
      ],
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "explorer_nx_armour_grade1_default": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "explorer_nx_armour_grade1": {
      "type": "cbh",
      "id": 40136,
      "noUndersize": false,
      "hidden": false,
      "ships": [
        "AnacondaMkII",
        "Explorer_NX"
      ],
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "orca_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "orca_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "orca_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "orca_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "orca_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "belugaliner_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "belugaliner_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "belugaliner_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "belugaliner_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "belugaliner_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "dolphin_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "dolphin_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "dolphin_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "dolphin_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "dolphin_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "mediumtransport01_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "mediumtransport01_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "mediumtransport01_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "mediumtransport01_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "mediumtransport01_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_corvette_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_corvette_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_corvette_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_corvette_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "federation_corvette_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cutter_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cutter_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cutter_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cutter_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "cutter_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "panthermkii_armour_grade3": {
      "type": "cbh",
      "id": 40113,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "panthermkii_armour_mirrored": {
      "type": "cbh",
      "id": 40114,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "panthermkii_armour_reactive": {
      "type": "cbh",
      "id": 40115,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "panthermkii_armour_grade2": {
      "type": "cbh",
      "id": 40122,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    },
    "panthermkii_armour_grade1": {
      "type": "cbh",
      "id": 40131,
      "noUndersize": false,
      "hidden": false,
      "ships": null,
      "blueprints": [
        "Armour_Explosive",
        "Armour_HeavyDuty",
        "Armour_Kinetic",
        "Armour_Advanced",
        "Armour_Thermic"
      ],
      "experimentals": [
        "special_armour_kinetic",
        "special_armour_chunky",
        "special_armour_explosive",
        "special_armour_thermic"
      ],
      "limit": null
    }
  },
  "limits": {
    "hex": 4,
    "uex": 1,
    "ukws": 1,
    "ucs": 1,
    "upwa": 1,
    "ufsws": 1,
    "iex": 1,
    "ifh": 1,
    "ifa_dc": 1,
    "ifa_sc": 1,
    "ifsdb": 1,
    "ifsdi": 1,
    "ifs": 1,
    "imlc": 1,
    "ir": 1,
    "isg": 1,
    "isbs": 1,
    "iss": 1
  },
  "ships": {
    "sidewinder": {
      "fdid": 128049249,
      "fdname": "SideWinder",
      "eddbid": 18,
      "id": 1,
      "stype": "mp",
      "name": "Sidewinder",
      "class": 1,
      "cost": 5070,
      "retail": 32000,
      "topspd": 220,
      "bstspd": 320,
      "mnv": 6,
      "shields": 55,
      "armour": 60,
      "mass": 25,
      "fwdacc": 44.39,
      "revacc": 29.96,
      "latacc": 29.96,
      "minthrust": 45.454,
      "boostcost": 7,
      "boostint": 4,
      "pitch": 43,
      "yaw": 17,
      "roll": 110,
      "pitchacc": 220,
      "yawacc": 110,
      "rollacc": 240,
      "minpitch": 34,
      "heatcap": 140,
      "heatdismin": 1.18,
      "heatdismax": 18.15,
      "fuelcost": 50,
      "fuelreserve": 0.3,
      "hardness": 20,
      "masslock": 6,
      "crew": 1,
      "slots": {
        "hardpoint": [
          1,
          1
        ],
        "utility": [
          0,
          0
        ],
        "component": [
          1,
          2,
          2,
          2,
          1,
          1,
          1,
          1
        ],
        "military": [],
        "internal": [
          2,
          2,
          1,
          1,
          1,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          62171,
          62171
        ],
        "utility": [
          0,
          0
        ],
        "component": [
          40131,
          41250,
          42250,
          43250,
          44150,
          45150,
          46150,
          47130
        ],
        "military": [],
        "internal": [
          30250,
          250,
          0,
          0,
          -3152,
          -3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 80320,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 4,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049252,
          "fdname": "SideWinder_Armour_Grade3",
          "eddbid": 740
        },
        "40114": {
          "mtype": "cbh",
          "cost": 132060,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 4,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049253,
          "fdname": "SideWinder_Armour_Mirrored",
          "eddbid": 741
        },
        "40115": {
          "mtype": "cbh",
          "cost": 139420,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 4,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049254,
          "fdname": "SideWinder_Armour_Reactive",
          "eddbid": 742
        },
        "40122": {
          "mtype": "cbh",
          "cost": 25600,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 2,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049251,
          "fdname": "SideWinder_Armour_Grade2",
          "eddbid": 739
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049250,
          "fdname": "SideWinder_Armour_Grade1",
          "eddbid": 738
        }
      }
    },
    "cobramkiii": {
      "fdid": 128049279,
      "fdname": "CobraMkIII",
      "eddbid": 4,
      "id": 2,
      "stype": "mp",
      "name": "Cobra Mk III",
      "class": 1,
      "cost": 186260,
      "retail": 349720,
      "topspd": 280,
      "bstspd": 400,
      "mnv": 5,
      "shields": 80,
      "armour": 120,
      "mass": 180,
      "fwdacc": 35.03,
      "revacc": 25.16,
      "latacc": 20.02,
      "minthrust": 50,
      "boostcost": 10,
      "boostint": 5,
      "pitch": 40,
      "yaw": 10,
      "roll": 100,
      "pitchacc": 200,
      "yawacc": 100,
      "rollacc": 220,
      "minpitch": 30,
      "heatcap": 225,
      "heatdismin": 1.92,
      "heatdismax": 30.63,
      "fuelcost": 50,
      "fuelreserve": 0.49,
      "hardness": 35,
      "masslock": 8,
      "crew": 2,
      "slots": {
        "hardpoint": [
          2,
          2,
          1,
          1
        ],
        "utility": [
          0,
          0
        ],
        "component": [
          1,
          4,
          4,
          4,
          3,
          3,
          3,
          4
        ],
        "military": [],
        "internal": [
          4,
          4,
          4,
          2,
          2,
          2,
          1,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          62160,
          62160,
          0,
          0
        ],
        "utility": [
          0,
          0
        ],
        "component": [
          40131,
          41450,
          42450,
          43450,
          44350,
          45350,
          46350,
          47430
        ],
        "military": [],
        "internal": [
          350,
          350,
          30450,
          150,
          0,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 341750,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 27,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049282,
          "fdname": "CobraMkIII_Armour_Grade3",
          "eddbid": 765
        },
        "40114": {
          "mtype": "cbh",
          "cost": 797410,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 27,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049283,
          "fdname": "CobraMkIII_Armour_Mirrored",
          "eddbid": 766
        },
        "40115": {
          "mtype": "cbh",
          "cost": 895000,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 27,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049284,
          "fdname": "CobraMkIII_Armour_Reactive",
          "eddbid": 767
        },
        "40122": {
          "mtype": "cbh",
          "cost": 151890,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 14,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049281,
          "fdname": "CobraMkIII_Armour_Grade2",
          "eddbid": 764
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049280,
          "fdname": "CobraMkIII_Armour_Grade1",
          "eddbid": 763
        }
      }
    },
    "empire_trader": {
      "fdid": 128049315,
      "fdname": "Empire_Trader",
      "eddbid": 13,
      "id": 3,
      "stype": "mp",
      "name": "Imperial Clipper",
      "class": 3,
      "cost": 21035250,
      "retail": 22295860,
      "faction": "Empire",
      "rank": 7,
      "topspd": 300,
      "bstspd": 380,
      "mnv": 5,
      "shields": 200,
      "armour": 270,
      "mass": 350,
      "fwdacc": 24.74,
      "revacc": 20.05,
      "latacc": 10.1,
      "minthrust": 60,
      "boostcost": 19,
      "boostint": 4.5,
      "pitch": 40,
      "yaw": 18,
      "roll": 80,
      "pitchacc": 200,
      "yawacc": 100,
      "rollacc": 220,
      "minpitch": 30,
      "heatcap": 304,
      "heatdismin": 2.63,
      "heatdismax": 46.8,
      "fuelcost": 50,
      "fuelreserve": 0.74,
      "hardness": 60,
      "masslock": 12,
      "crew": 2,
      "slots": {
        "hardpoint": [
          3,
          3,
          2,
          2
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          6,
          6,
          5,
          5,
          6,
          5,
          5
        ],
        "military": [],
        "internal": [
          7,
          7,
          6,
          4,
          4,
          3,
          3,
          2,
          2,
          1
        ]
      },
      "slotnames": {
        "internal": [
          "Slot00_Size7",
          "Slot01_Size7",
          "Slot02_Size6",
          "Slot03_Size4",
          "Slot04_Size4",
          "Slot05_Size3",
          "Slot06_Size3",
          "Slot07_Size2",
          "Slot08_Size2",
          "Slot09_Size1"
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41650,
          42650,
          43550,
          44550,
          45650,
          46550,
          47530
        ],
        "military": [],
        "internal": [
          0,
          650,
          30650,
          350,
          0,
          0,
          0,
          150,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 20066270,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049318,
          "fdname": "Empire_Trader_Armour_Grade3",
          "eddbid": 790
        },
        "40114": {
          "mtype": "cbh",
          "cost": 47423290,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049319,
          "fdname": "Empire_Trader_Armour_Mirrored",
          "eddbid": 791
        },
        "40115": {
          "mtype": "cbh",
          "cost": 52551340,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049320,
          "fdname": "Empire_Trader_Armour_Reactive",
          "eddbid": 792
        },
        "40122": {
          "mtype": "cbh",
          "cost": 8918340,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 30,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049317,
          "fdname": "Empire_Trader_Armour_Grade2",
          "eddbid": 789
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049316,
          "fdname": "Empire_Trader_Armour_Grade1",
          "eddbid": 788
        }
      }
    },
    "federation_dropship": {
      "fdid": 128049321,
      "fdname": "Federation_Dropship",
      "eddbid": 9,
      "id": 4,
      "stype": "co",
      "name": "Federal Dropship",
      "class": 2,
      "cost": 13501480,
      "retail": 14314210,
      "faction": "Federation",
      "rank": 3,
      "topspd": 200,
      "bstspd": 300,
      "mnv": 3,
      "shields": 200,
      "armour": 300,
      "mass": 500,
      "fwdacc": 29.99,
      "revacc": 20.34,
      "latacc": 10.19,
      "minthrust": 55.556,
      "boostcost": 19,
      "boostint": 6,
      "pitch": 30,
      "yaw": 14,
      "roll": 80,
      "pitchacc": 100,
      "yawacc": 50,
      "rollacc": 80,
      "minpitch": 20,
      "heatcap": 331,
      "heatdismin": 2.6,
      "heatdismax": 46.5,
      "fuelcost": 50,
      "fuelreserve": 0.83,
      "hardness": 60,
      "masslock": 14,
      "crew": 2,
      "slots": {
        "hardpoint": [
          3,
          2,
          2,
          2,
          2
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          6,
          6,
          5,
          5,
          6,
          4,
          4
        ],
        "military": [
          4,
          4
        ],
        "internal": [
          6,
          6,
          5,
          5,
          4,
          3,
          3,
          2,
          1
        ]
      },
      "slotnames": {
        "internal": [
          "Slot00_Size6",
          "Slot01_Size6",
          "Slot02_Size5",
          "Slot03_Size5",
          "Slot04_Size4",
          "Slot05_Size3",
          "Slot06_Size3",
          "Slot09_Size2",
          "Slot10_Size1"
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41650,
          42650,
          43550,
          44550,
          45650,
          46450,
          47430
        ],
        "military": [
          0,
          0
        ],
        "internal": [
          0,
          550,
          450,
          30550,
          350,
          0,
          0,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 12882780,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 87,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049324,
          "fdname": "Federation_Dropship_Armour_Grade3",
          "eddbid": 795
        },
        "40114": {
          "mtype": "cbh",
          "cost": 30446310,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 87,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049325,
          "fdname": "Federation_Dropship_Armour_Mirrored",
          "eddbid": 796
        },
        "40115": {
          "mtype": "cbh",
          "cost": 33738580,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 87,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049326,
          "fdname": "Federation_Dropship_Armour_Reactive",
          "eddbid": 797
        },
        "40122": {
          "mtype": "cbh",
          "cost": 5725680,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 44,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049323,
          "fdname": "Federation_Dropship_Armour_Grade2",
          "eddbid": 794
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049322,
          "fdname": "Federation_Dropship_Armour_Grade1",
          "eddbid": 793
        }
      }
    },
    "python": {
      "fdid": 128049339,
      "fdname": "Python",
      "eddbid": 17,
      "id": 5,
      "stype": "mp",
      "name": "Python",
      "class": 2,
      "cost": 55316050,
      "retail": 56978180,
      "topspd": 230,
      "bstspd": 300,
      "mnv": 2,
      "shields": 260,
      "armour": 260,
      "mass": 350,
      "fwdacc": 29.59,
      "revacc": 18.02,
      "latacc": 15.92,
      "minthrust": 60.87,
      "boostcost": 23,
      "boostint": 4.5,
      "pitch": 29,
      "yaw": 10,
      "roll": 90,
      "pitchacc": 200,
      "yawacc": 100,
      "rollacc": 220,
      "minpitch": 24,
      "heatcap": 300,
      "heatdismin": 2.68,
      "heatdismax": 52.05,
      "fuelcost": 50,
      "fuelreserve": 0.83,
      "hardness": 65,
      "masslock": 17,
      "crew": 2,
      "slots": {
        "hardpoint": [
          3,
          3,
          3,
          2,
          2
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          7,
          6,
          5,
          4,
          7,
          6,
          5
        ],
        "military": [],
        "internal": [
          6,
          6,
          6,
          5,
          5,
          4,
          3,
          3,
          2,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41750,
          42650,
          43550,
          44450,
          45750,
          46650,
          47530
        ],
        "military": [],
        "internal": [
          550,
          550,
          30650,
          450,
          0,
          0,
          0,
          0,
          150,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 51280360,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 53,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049342,
          "fdname": "Python_Armour_Grade3",
          "eddbid": 810
        },
        "40114": {
          "mtype": "cbh",
          "cost": 121192590,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 53,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049343,
          "fdname": "Python_Armour_Mirrored",
          "eddbid": 811
        },
        "40115": {
          "mtype": "cbh",
          "cost": 134297570,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 53,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049344,
          "fdname": "Python_Armour_Reactive",
          "eddbid": 812
        },
        "40122": {
          "mtype": "cbh",
          "cost": 22791270,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 26,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049341,
          "fdname": "Python_Armour_Grade2",
          "eddbid": 809
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049340,
          "fdname": "Python_Armour_Grade1",
          "eddbid": 808
        }
      }
    },
    "anaconda": {
      "fdid": 128049363,
      "fdname": "Anaconda",
      "eddbid": 2,
      "id": 6,
      "stype": "sh",
      "name": "Anaconda",
      "class": 3,
      "cost": 142447820,
      "retail": 146969450,
      "topspd": 180,
      "bstspd": 240,
      "mnv": 1,
      "shields": 350,
      "armour": 525,
      "mass": 400,
      "fwdacc": 19.85,
      "revacc": 10.03,
      "latacc": 10.05,
      "minthrust": 44.444,
      "boostcost": 27,
      "boostint": 6,
      "pitch": 25,
      "yaw": 10,
      "roll": 60,
      "pitchacc": 100,
      "yawacc": 50,
      "rollacc": 80,
      "minpitch": 20,
      "heatcap": 334,
      "heatdismin": 3.16,
      "heatdismax": 67.15,
      "fuelcost": 50,
      "fuelreserve": 1.07,
      "hardness": 65,
      "masslock": 23,
      "crew": 4,
      "slots": {
        "hardpoint": [
          4,
          3,
          3,
          3,
          2,
          2,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          8,
          7,
          6,
          5,
          8,
          8,
          5
        ],
        "military": [
          5
        ],
        "internal": [
          7,
          6,
          6,
          6,
          5,
          5,
          5,
          4,
          4,
          4,
          2,
          1
        ]
      },
      "slotnames": {
        "internal": [
          "Slot01_Size7",
          "Slot02_Size6",
          "Slot03_Size6",
          "Slot04_Size6",
          "Slot05_Size5",
          "Slot06_Size5",
          "Slot07_Size5",
          "Slot08_Size4",
          "Slot09_Size4",
          "Slot10_Size4",
          "Slot13_Size2",
          "Slot14_Size1"
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          0,
          0,
          0,
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41850,
          42750,
          43650,
          44550,
          45850,
          46850,
          47530
        ],
        "military": [
          0
        ],
        "internal": [
          650,
          550,
          30650,
          0,
          450,
          0,
          0,
          0,
          0,
          0,
          150,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 132272510,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049366,
          "fdname": "Anaconda_Armour_Grade3",
          "eddbid": 820
        },
        "40114": {
          "mtype": "cbh",
          "cost": 312604020,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049367,
          "fdname": "Anaconda_Armour_Mirrored",
          "eddbid": 821
        },
        "40115": {
          "mtype": "cbh",
          "cost": 346407000,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049368,
          "fdname": "Anaconda_Armour_Reactive",
          "eddbid": 822
        },
        "40122": {
          "mtype": "cbh",
          "cost": 58787780,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 30,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049365,
          "fdname": "Anaconda_Armour_Grade2",
          "eddbid": 819
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049364,
          "fdname": "Anaconda_Armour_Grade1",
          "eddbid": 818
        }
      }
    },
    "empire_courier": {
      "fdid": 128671223,
      "fdname": "Empire_Courier",
      "eddbid": 14,
      "id": 7,
      "stype": "mp",
      "name": "Imperial Courier",
      "class": 1,
      "cost": 2462010,
      "retail": 2542930,
      "faction": "Empire",
      "rank": 3,
      "topspd": 280,
      "bstspd": 380,
      "mnv": 4,
      "shields": 200,
      "armour": 80,
      "mass": 35,
      "fwdacc": 57.53,
      "revacc": 30.02,
      "latacc": 24.88,
      "minthrust": 78.571,
      "boostcost": 10,
      "boostint": 4,
      "pitch": 38,
      "yaw": 16,
      "roll": 90,
      "pitchacc": 200,
      "yawacc": 100,
      "rollacc": 220,
      "minpitch": 32,
      "heatcap": 230,
      "heatdismin": 1.62,
      "heatdismax": 25.05,
      "fuelcost": 50,
      "fuelreserve": 0.41,
      "hardness": 30,
      "masslock": 7,
      "crew": 1,
      "slots": {
        "hardpoint": [
          2,
          2,
          2
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          4,
          3,
          3,
          1,
          3,
          2,
          3
        ],
        "military": [],
        "internal": [
          3,
          3,
          2,
          2,
          2,
          1,
          1,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          62160,
          62160,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41450,
          42350,
          43350,
          44150,
          45350,
          46250,
          47330
        ],
        "military": [],
        "internal": [
          250,
          250,
          30250,
          150,
          150,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 2288640,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 8,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128671226,
          "fdname": "Empire_Courier_Armour_Grade3",
          "eddbid": 1391
        },
        "40114": {
          "mtype": "cbh",
          "cost": 5408810,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 8,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128671227,
          "fdname": "Empire_Courier_Armour_Mirrored",
          "eddbid": 1392
        },
        "40115": {
          "mtype": "cbh",
          "cost": 5993690,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 8,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128671228,
          "fdname": "Empire_Courier_Armour_Reactive",
          "eddbid": 1393
        },
        "40122": {
          "mtype": "cbh",
          "cost": 1017170,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 4,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128671225,
          "fdname": "Empire_Courier_Armour_Grade2",
          "eddbid": 1390
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128671224,
          "fdname": "Empire_Courier_Armour_Grade1",
          "eddbid": 1389
        }
      }
    },
    "cobramkiv": {
      "fdid": 128672262,
      "fdname": "CobraMkIV",
      "eddbid": 29,
      "id": 8,
      "stype": "mp",
      "name": "Cobra Mk IV",
      "class": 1,
      "cost": 584200,
      "retail": 764720,
      "topspd": 200,
      "bstspd": 300,
      "mnv": 3,
      "shields": 120,
      "armour": 120,
      "mass": 210,
      "fwdacc": 27.84,
      "revacc": 19.91,
      "latacc": 15.03,
      "minthrust": 50,
      "boostcost": 10,
      "boostint": 5,
      "pitch": 30,
      "yaw": 10,
      "roll": 90,
      "pitchacc": 200,
      "yawacc": 100,
      "rollacc": 220,
      "minpitch": 25,
      "heatcap": 228,
      "heatdismin": 1.99,
      "heatdismax": 31.68,
      "fuelcost": 50,
      "fuelreserve": 0.51,
      "hardness": 35,
      "masslock": 8,
      "crew": 2,
      "slots": {
        "hardpoint": [
          2,
          2,
          1,
          1,
          1
        ],
        "utility": [
          0,
          0
        ],
        "component": [
          1,
          4,
          4,
          4,
          3,
          3,
          3,
          4
        ],
        "military": [],
        "internal": [
          4,
          4,
          4,
          4,
          3,
          3,
          2,
          2,
          1,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          62160,
          62160,
          0,
          0,
          0
        ],
        "utility": [
          0,
          0
        ],
        "component": [
          40131,
          41450,
          42450,
          43450,
          44350,
          45350,
          46350,
          47430
        ],
        "military": [],
        "internal": [
          30450,
          350,
          350,
          350,
          250,
          250,
          150,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 688250,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 27,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672266,
          "fdname": "CobraMkIV_Armour_Grade3",
          "eddbid": 1520
        },
        "40114": {
          "mtype": "cbh",
          "cost": 1605910,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 27,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128672267,
          "fdname": "CobraMkIV_Armour_Mirrored",
          "eddbid": 1521
        },
        "40115": {
          "mtype": "cbh",
          "cost": 1802440,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 27,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128672268,
          "fdname": "CobraMkIV_Armour_Reactive",
          "eddbid": 1522
        },
        "40122": {
          "mtype": "cbh",
          "cost": 305890,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 14,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672265,
          "fdname": "CobraMkIV_Armour_Grade2",
          "eddbid": 1519
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672264,
          "fdname": "CobraMkIV_Armour_Grade1",
          "eddbid": 1518
        }
      }
    },
    "typex": {
      "fdid": 128816574,
      "fdname": "TypeX",
      "eddbid": 33,
      "id": 9,
      "stype": "co",
      "name": "Alliance Chieftain",
      "class": 2,
      "cost": 18603850,
      "retail": 19382250,
      "topspd": 230,
      "bstspd": 330,
      "mnv": 4,
      "shields": 200,
      "armour": 280,
      "mass": 400,
      "fwdacc": 37.84,
      "revacc": 25.84,
      "latacc": 20.01,
      "minthrust": 65.217,
      "boostcost": 19,
      "boostint": 6,
      "pitch": 38,
      "yaw": 16,
      "roll": 90,
      "pitchacc": 170,
      "yawacc": 60,
      "rollacc": 150,
      "minpitch": 32,
      "heatcap": 289,
      "heatdismin": 2.6,
      "heatdismax": 46.5,
      "fuelcost": 50,
      "fuelreserve": 0.77,
      "hardness": 65,
      "masslock": 13,
      "crew": 2,
      "slots": {
        "hardpoint": [
          3,
          3,
          2,
          1,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          6,
          6,
          5,
          5,
          6,
          4,
          4
        ],
        "military": [
          4,
          4,
          4
        ],
        "internal": [
          6,
          5,
          4,
          2,
          2,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          62160,
          0,
          62160,
          0,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41650,
          42650,
          43550,
          44550,
          45650,
          46450,
          47430
        ],
        "military": [
          0,
          0,
          0
        ],
        "internal": [
          550,
          30550,
          350,
          0,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 17444030,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 78,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128816578,
          "fdname": "TypeX_Armour_Grade3",
          "eddbid": 1642
        },
        "40114": {
          "mtype": "cbh",
          "cost": 41226050,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 78,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128816579,
          "fdname": "TypeX_Armour_Mirrored",
          "eddbid": 1643
        },
        "40115": {
          "mtype": "cbh",
          "cost": 45683980,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 78,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128816580,
          "fdname": "TypeX_Armour_Reactive",
          "eddbid": 1644
        },
        "40122": {
          "mtype": "cbh",
          "cost": 7752900,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 40,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128816577,
          "fdname": "TypeX_Armour_Grade2",
          "eddbid": 1641
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128816576,
          "fdname": "TypeX_Armour_Grade1",
          "eddbid": 1640
        }
      }
    },
    "typex_2": {
      "fdid": 128816581,
      "fdname": "TypeX_2",
      "eddbid": 36,
      "id": 10,
      "stype": "co",
      "name": "Alliance Crusader",
      "class": 2,
      "cost": 22092000,
      "retail": 22866340,
      "topspd": 180,
      "bstspd": 300,
      "mnv": 3,
      "shields": 200,
      "armour": 300,
      "mass": 500,
      "fwdacc": 29.78,
      "revacc": 24.78,
      "latacc": 18.96,
      "minthrust": 61.11,
      "boostcost": 19,
      "boostint": 6,
      "pitch": 32,
      "yaw": 16,
      "roll": 80,
      "pitchacc": 150,
      "yawacc": 50,
      "rollacc": 150,
      "minpitch": 30,
      "heatcap": 316,
      "heatdismin": 2.53,
      "heatdismax": 45.23,
      "fuelcost": 50,
      "fuelreserve": 0.77,
      "hardness": 65,
      "masslock": 13,
      "crew": 4,
      "slots": {
        "hardpoint": [
          3,
          2,
          2,
          1,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          6,
          6,
          5,
          5,
          6,
          4,
          4
        ],
        "military": [
          4,
          4,
          4
        ],
        "internal": [
          6,
          5,
          3,
          3,
          2,
          2,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          62160,
          62160,
          0,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41650,
          42650,
          43550,
          44550,
          45650,
          46450,
          47430
        ],
        "military": [
          0,
          0,
          0
        ],
        "internal": [
          550,
          30550,
          250,
          250,
          0,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 20579710,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 78,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128816585,
          "fdname": "TypeX_2_Armour_Grade3",
          "eddbid": 1661
        },
        "40114": {
          "mtype": "cbh",
          "cost": 48636710,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 78,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128816586,
          "fdname": "TypeX_2_Armour_Mirrored",
          "eddbid": 1662
        },
        "40115": {
          "mtype": "cbh",
          "cost": 53895970,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 78,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128816587,
          "fdname": "TypeX_2_Armour_Reactive",
          "eddbid": 1663
        },
        "40122": {
          "mtype": "cbh",
          "cost": 9146540,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 40,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128816584,
          "fdname": "TypeX_2_Armour_Grade2",
          "eddbid": 1660
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128816583,
          "fdname": "TypeX_2_Armour_Grade1",
          "eddbid": 1659
        }
      }
    },
    "krait_light": {
      "fdid": 128839281,
      "fdname": "Krait_Light",
      "eddbid": 37,
      "id": 11,
      "stype": "mp",
      "name": "Krait Phantom",
      "class": 2,
      "cost": 35810120,
      "retail": 37472250,
      "topspd": 250,
      "bstspd": 350,
      "mnv": 3,
      "shields": 200,
      "armour": 180,
      "mass": 270,
      "fwdacc": null,
      "revacc": null,
      "latacc": null,
      "minthrust": 64,
      "boostcost": 13,
      "boostint": 4.5,
      "pitch": 31,
      "yaw": 10,
      "roll": 90,
      "pitchacc": 200,
      "yawacc": 100,
      "rollacc": 200,
      "minpitch": 26,
      "heatcap": 300,
      "heatdismin": 2.68,
      "heatdismax": 52.05,
      "fuelcost": 50,
      "fuelreserve": 0.63,
      "hardness": 55,
      "masslock": 14,
      "crew": 2,
      "slots": {
        "hardpoint": [
          3,
          3,
          2,
          2
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          7,
          6,
          5,
          4,
          7,
          6,
          5
        ],
        "military": [],
        "internal": [
          6,
          5,
          5,
          5,
          3,
          3,
          3,
          2,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41750,
          42650,
          43550,
          44450,
          45750,
          46650,
          47530
        ],
        "military": [],
        "internal": [
          30650,
          550,
          550,
          450,
          0,
          0,
          0,
          150,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 33725030,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 53,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128839285,
          "fdname": "Krait_Light_Armour_Grade3",
          "eddbid": 1770
        },
        "40114": {
          "mtype": "cbh",
          "cost": 79703480,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 53,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128839286,
          "fdname": "Krait_Light_Armour_Mirrored",
          "eddbid": 1771
        },
        "40115": {
          "mtype": "cbh",
          "cost": 88322100,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 53,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128839287,
          "fdname": "Krait_Light_Armour_Reactive",
          "eddbid": 1772
        },
        "40122": {
          "mtype": "cbh",
          "cost": 14988900,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 26,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128839284,
          "fdname": "Krait_Light_Armour_Grade2",
          "eddbid": 1769
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128839283,
          "fdname": "Krait_Light_Armour_Grade1",
          "eddbid": 1768
        }
      }
    },
    "mamba": {
      "fdid": 128915979,
      "fdname": "Mamba",
      "eddbid": 38,
      "id": 12,
      "stype": "co",
      "name": "Mamba",
      "class": 2,
      "cost": 55434290,
      "retail": 55867040,
      "topspd": 310,
      "bstspd": 380,
      "mnv": 3,
      "shields": 270,
      "armour": 230,
      "mass": 250,
      "fwdacc": null,
      "revacc": null,
      "latacc": null,
      "minthrust": 77.42,
      "boostcost": 16,
      "boostint": 5,
      "pitch": 30,
      "yaw": 10,
      "roll": 75,
      "pitchacc": 180,
      "yawacc": 90,
      "rollacc": 200,
      "minpitch": 27,
      "heatcap": 165,
      "heatdismin": 2.05,
      "heatdismax": 41.63,
      "fuelcost": 50,
      "fuelreserve": 0.5,
      "hardness": 70,
      "masslock": 12,
      "crew": 2,
      "slots": {
        "hardpoint": [
          4,
          3,
          3,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          6,
          5,
          4,
          4,
          6,
          4,
          3
        ],
        "military": [],
        "internal": [
          5,
          4,
          3,
          2,
          2,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41650,
          42550,
          43450,
          44450,
          45650,
          46450,
          47330
        ],
        "military": [],
        "internal": [
          450,
          30450,
          250,
          0,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 46410340,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 38,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128915983,
          "fdname": "Mamba_Armour_Grade3",
          "eddbid": 1800
        },
        "40114": {
          "mtype": "cbh",
          "cost": 109683090,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 38,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128915984,
          "fdname": "Mamba_Armour_Mirrored",
          "eddbid": 1801
        },
        "40115": {
          "mtype": "cbh",
          "cost": 121543510,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 38,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128915985,
          "fdname": "Mamba_Armour_Reactive",
          "eddbid": 1802
        },
        "40122": {
          "mtype": "cbh",
          "cost": 20626820,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 19,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128915982,
          "fdname": "Mamba_Armour_Grade2",
          "eddbid": 1799
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128915981,
          "fdname": "Mamba_Armour_Grade1",
          "eddbid": 1798
        }
      }
    },
    "typex_3": {
      "fdid": 128816588,
      "fdname": "TypeX_3",
      "eddbid": 34,
      "id": 13,
      "stype": "co",
      "name": "Alliance Challenger",
      "class": 2,
      "cost": 29561170,
      "retail": 30472250,
      "topspd": 200,
      "bstspd": 310,
      "mnv": 4,
      "shields": 220,
      "armour": 300,
      "mass": 450,
      "fwdacc": 31.65,
      "revacc": 25.94,
      "latacc": 20.09,
      "minthrust": 65,
      "boostcost": 19,
      "boostint": 6,
      "pitch": 35,
      "yaw": 16,
      "roll": 90,
      "pitchacc": 120,
      "yawacc": 50,
      "rollacc": 120,
      "minpitch": 32,
      "heatcap": 316,
      "heatdismin": 2.87,
      "heatdismax": 51.4,
      "fuelcost": 50,
      "fuelreserve": 0.77,
      "hardness": 65,
      "masslock": 13,
      "crew": 2,
      "slots": {
        "hardpoint": [
          3,
          2,
          2,
          2,
          1,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          6,
          6,
          5,
          5,
          6,
          4,
          4
        ],
        "military": [
          4,
          4,
          4
        ],
        "internal": [
          6,
          6,
          3,
          3,
          2,
          2,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          62160,
          62160,
          0,
          0,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41650,
          42650,
          43550,
          44550,
          45650,
          46450,
          47430
        ],
        "military": [
          0,
          0,
          0
        ],
        "internal": [
          550,
          30650,
          250,
          250,
          0,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 15307130,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 78,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128816592,
          "fdname": "TypeX_3_Armour_Grade3",
          "eddbid": 1652
        },
        "40114": {
          "mtype": "cbh",
          "cost": 36175860,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 78,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128816593,
          "fdname": "TypeX_3_Armour_Mirrored",
          "eddbid": 1653
        },
        "40115": {
          "mtype": "cbh",
          "cost": 40087680,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 78,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128816594,
          "fdname": "TypeX_3_Armour_Reactive",
          "eddbid": 1654
        },
        "40122": {
          "mtype": "cbh",
          "cost": 6803170,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 40,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128816591,
          "fdname": "TypeX_3_Armour_Grade2",
          "eddbid": 1651
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128816590,
          "fdname": "TypeX_3_Armour_Grade1",
          "eddbid": 1650
        }
      }
    },
    "krait_mkii": {
      "fdid": 128816567,
      "fdname": "Krait_MkII",
      "eddbid": 35,
      "id": 14,
      "stype": "mp",
      "name": "Krait Mk II",
      "class": 2,
      "cost": 44152080,
      "retail": 45814210,
      "topspd": 240,
      "bstspd": 330,
      "mnv": 3,
      "shields": 220,
      "armour": 220,
      "mass": 320,
      "fwdacc": 28.01,
      "revacc": 18.04,
      "latacc": 15.12,
      "minthrust": 62.3,
      "boostcost": 13,
      "boostint": 4.5,
      "pitch": 31,
      "yaw": 10,
      "roll": 90,
      "pitchacc": 200,
      "yawacc": 100,
      "rollacc": 200,
      "minpitch": 26,
      "heatcap": 300,
      "heatdismin": 2.68,
      "heatdismax": 52.05,
      "fuelcost": 50,
      "fuelreserve": 0.63,
      "hardness": 55,
      "masslock": 16,
      "crew": 3,
      "slots": {
        "hardpoint": [
          3,
          3,
          3,
          2,
          2
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          7,
          6,
          5,
          4,
          7,
          6,
          5
        ],
        "military": [],
        "internal": [
          6,
          6,
          5,
          5,
          4,
          3,
          3,
          2,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41750,
          42650,
          43550,
          44450,
          45750,
          46650,
          47530
        ],
        "military": [],
        "internal": [
          30650,
          550,
          550,
          450,
          0,
          0,
          0,
          150,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 41232790,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 67,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128816571,
          "fdname": "Krait_MkII_Armour_Grade3",
          "eddbid": 1647
        },
        "40114": {
          "mtype": "cbh",
          "cost": 97446810,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 67,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128816572,
          "fdname": "Krait_MkII_Armour_Mirrored",
          "eddbid": 1648
        },
        "40115": {
          "mtype": "cbh",
          "cost": 107984080,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 67,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128816573,
          "fdname": "Krait_MkII_Armour_Reactive",
          "eddbid": 1649
        },
        "40122": {
          "mtype": "cbh",
          "cost": 18325680,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 36,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128816570,
          "fdname": "Krait_MkII_Armour_Grade2",
          "eddbid": 1646
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128816569,
          "fdname": "Krait_MkII_Armour_Grade1",
          "eddbid": 1645
        }
      }
    },
    "python_nx": {
      "fdid": 128666762,
      "fdname": "Python_NX",
      "id": 15,
      "stype": "mp",
      "name": "Python Mk II",
      "class": 2,
      "cost": 64731711,
      "retail": 67527361,
      "topspd": 256,
      "bstspd": 345,
      "mnv": 4,
      "shields": 335,
      "armour": 280,
      "mass": 450,
      "fwdacc": null,
      "revacc": null,
      "latacc": null,
      "minthrust": 85.75,
      "boostcost": 20,
      "boostint": 5,
      "pitch": 37,
      "yaw": 12.5,
      "roll": 91,
      "pitchacc": null,
      "yawacc": null,
      "rollacc": null,
      "minpitch": 30,
      "heatcap": 260,
      "heatdismin": 2.68,
      "heatdismax": 52,
      "fuelcost": 50,
      "fuelreserve": 0.83,
      "hardness": 70,
      "masslock": 17,
      "crew": 2,
      "slots": {
        "hardpoint": [
          3,
          3,
          3,
          3,
          2,
          2
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          6,
          6,
          5,
          4,
          6,
          5,
          4
        ],
        "military": [],
        "internal": [
          6,
          4,
          3,
          2,
          1,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          0,
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41650,
          42650,
          43531,
          44450,
          45650,
          46550,
          47430
        ],
        "military": [],
        "internal": [
          30650,
          350,
          0,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 60774623,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 53,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129030468,
          "fdname": "Python_NX_Armour_Grade3",
          "eddbid": null
        },
        "40114": {
          "mtype": "cbh",
          "cost": 143630693,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 53,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 129030469,
          "fdname": "Python_NX_Armour_Mirrored",
          "eddbid": null
        },
        "40115": {
          "mtype": "cbh",
          "cost": 159161986,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 53,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 129030470,
          "fdname": "Python_NX_Armour_Reactive",
          "eddbid": null
        },
        "40122": {
          "mtype": "cbh",
          "cost": 27010944,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 26,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129030467,
          "fdname": "Python_NX_Armour_Grade2",
          "eddbid": null
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129030466,
          "fdname": "Python_NX_Armour_Grade1",
          "eddbid": null
        }
      }
    },
    "cobramkv": {
      "fdid": 129031229,
      "fdname": "CobraMkV",
      "id": 16,
      "stype": "mp",
      "name": "Cobra Mk V",
      "class": 1,
      "cost": 1473191,
      "retail": 1989461,
      "topspd": 290,
      "bstspd": 410,
      "mnv": 5,
      "shields": 160,
      "armour": 180,
      "mass": 150,
      "fwdacc": null,
      "revacc": null,
      "latacc": null,
      "minthrust": 79,
      "boostcost": 10,
      "boostint": 5,
      "pitch": 45,
      "yaw": 33,
      "roll": 120,
      "pitchacc": null,
      "yawacc": null,
      "rollacc": null,
      "minpitch": 40,
      "heatcap": 245,
      "heatdismin": 2.06,
      "heatdismax": 40.5,
      "fuelcost": 50,
      "fuelreserve": 0.49,
      "hardness": 40,
      "masslock": 8,
      "crew": 3,
      "slots": {
        "hardpoint": [
          2,
          2,
          2,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          4,
          4,
          4,
          3,
          4,
          3,
          4
        ],
        "military": [],
        "internal": [
          5,
          4,
          4,
          4,
          3,
          3,
          3,
          2,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          62160,
          62160,
          0,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41450,
          42450,
          43451,
          44350,
          45450,
          46350,
          47430
        ],
        "military": [],
        "internal": [
          30430,
          0,
          350,
          0,
          250,
          0,
          0,
          3151,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 1790515,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 27,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129031233,
          "fdname": "CobraMkV_Armour_Grade3",
          "eddbid": null
        },
        "40114": {
          "mtype": "cbh",
          "cost": 4177867,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 27,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 129031234,
          "fdname": "CobraMkV_Armour_Mirrored",
          "eddbid": null
        },
        "40115": {
          "mtype": "cbh",
          "cost": 4689158,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 27,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 129031235,
          "fdname": "CobraMkV_Armour_Reactive",
          "eddbid": null
        },
        "40122": {
          "mtype": "cbh",
          "cost": 795785,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 14,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129031232,
          "fdname": "CobraMkV_Armour_Grade2",
          "eddbid": null
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129031231,
          "fdname": "CobraMkV_Armour_Grade1",
          "eddbid": null
        }
      }
    },
    "corsair": {
      "fdid": 129031320,
      "fdname": "Corsair",
      "id": 17,
      "stype": "mp",
      "name": "Corsair",
      "class": 2,
      "cost": 76884160,
      "retail": 79304750,
      "topspd": 280,
      "bstspd": 355,
      "mnv": 4,
      "shields": 235,
      "armour": 270,
      "mass": 265,
      "fwdacc": null,
      "revacc": null,
      "latacc": null,
      "minthrust": 65,
      "boostcost": 19,
      "boostint": 5,
      "pitch": 26,
      "yaw": 10,
      "roll": 80,
      "pitchacc": null,
      "yawacc": null,
      "rollacc": null,
      "minpitch": 23,
      "heatcap": 230,
      "heatdismin": 1.62,
      "heatdismax": 52,
      "fuelcost": 50,
      "fuelreserve": 0.41,
      "hardness": 65,
      "masslock": 17,
      "crew": 2,
      "slots": {
        "hardpoint": [
          3,
          3,
          3,
          2,
          2,
          2
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          7,
          7,
          5,
          4,
          7,
          6,
          5
        ],
        "military": [],
        "internal": [
          6,
          6,
          6,
          5,
          5,
          5,
          4,
          3,
          2,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          0,
          62160,
          62160,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41750,
          42750,
          43551,
          44450,
          45750,
          46650,
          47530
        ],
        "military": [],
        "internal": [
          550,
          30550,
          0,
          450,
          0,
          0,
          0,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 71374270,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 63,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129031324,
          "fdname": "Corsair_Armour_Grade3",
          "eddbid": null
        },
        "40114": {
          "mtype": "cbh",
          "cost": 166539970,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 63,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 129031325,
          "fdname": "Corsair_Armour_Mirrored",
          "eddbid": null
        },
        "40115": {
          "mtype": "cbh",
          "cost": 186921290,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 63,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 129031326,
          "fdname": "Corsair_Armour_Reactive",
          "eddbid": null
        },
        "40122": {
          "mtype": "cbh",
          "cost": 31721900,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 32,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129031323,
          "fdname": "Corsair_Armour_Grade2",
          "eddbid": null
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129031322,
          "fdname": "Corsair_Armour_Grade1",
          "eddbid": null
        }
      }
    },
    "anacondamkii": {
      "fdid": 129046025,
      "fdname": "AnacondaMkII",
      "eddbid": null,
      "id": 18,
      "stype": "sh",
      "name": "Anaconda Mk II",
      "class": 3,
      "cost": 372041780,
      "retail": 384958850,
      "topspd": 190,
      "bstspd": 250,
      "mnv": 2,
      "shields": 450,
      "armour": 745,
      "mass": 940,
      "fwdacc": null,
      "revacc": null,
      "latacc": null,
      "minthrust": 47,
      "boostcost": 27,
      "boostint": 6,
      "pitch": 27,
      "yaw": 14,
      "roll": 65,
      "pitchacc": null,
      "yawacc": null,
      "rollacc": null,
      "minpitch": 22,
      "heatcap": null,
      "heatdismin": null,
      "heatdismax": null,
      "fuelcost": 50,
      "fuelreserve": 1.08,
      "hardness": 65,
      "masslock": null,
      "crew": 4,
      "slots": {
        "hardpoint": [
          4,
          3,
          3,
          3,
          3,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          8,
          7,
          8,
          5,
          8,
          8,
          6
        ],
        "military": [
          5,
          5
        ],
        "internal": [
          8,
          7,
          7,
          6,
          5,
          5,
          5,
          4,
          4,
          3,
          2,
          1
        ]
      },
      "slotnames": {
        "internal": [
          "Slot01_Size8",
          "Slot02_Size7",
          "Slot03_Size7",
          "Cargo01",
          "Slot04_Size5",
          "Slot05_Size5",
          "Slot06_Size5",
          "Slot07_Size4",
          "Slot08_Size4",
          "Slot09_Size3",
          "Slot10_Size2",
          "Slot11_Size1"
        ]
      },
      "reserved": {
        "internal": [
          null,
          null,
          null,
          {
            "cft": 1,
            "icr": 1
          }
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          0,
          0,
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41850,
          42750,
          43851,
          44550,
          45850,
          46850,
          47630
        ],
        "military": [
          0,
          0
        ],
        "internal": [
          750,
          650,
          30750,
          0,
          450,
          0,
          0,
          0,
          0,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40110": {
          "mtype": "cbh",
          "cost": 907348010,
          "name": "Mk II Ablative Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "reserved": {
            "18": 1,
            "47": 1
          },
          "fdid": 129046032,
          "fdname": "AnacondaMkII_Armour_Reactive",
          "eddbid": null,
          "hidden": 0
        },
        "40113": {
          "mtype": "cbh",
          "cost": null,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": null,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": null,
          "fdname": null,
          "eddbid": null,
          "hidden": 1
        },
        "40114": {
          "mtype": "cbh",
          "cost": null,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": null,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": null,
          "fdname": null,
          "eddbid": null,
          "hidden": 1
        },
        "40115": {
          "mtype": "cbh",
          "cost": null,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": null,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": null,
          "fdname": null,
          "eddbid": null,
          "hidden": 1
        },
        "40118": {
          "mtype": "cbh",
          "cost": 346462970,
          "name": "Mk II Ablative Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "reserved": {
            "18": 1,
            "47": 1
          },
          "fdid": 129046030,
          "fdname": "AnacondaMkII_Armour_Grade3",
          "eddbid": null,
          "hidden": 0
        },
        "40119": {
          "mtype": "cbh",
          "cost": 818807470,
          "name": "Mk II Ablative Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "reserved": {
            "18": 1,
            "47": 1
          },
          "fdid": 129046031,
          "fdname": "AnacondaMkII_Armour_Mirrored",
          "eddbid": null,
          "hidden": 0
        },
        "40122": {
          "mtype": "cbh",
          "cost": null,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": null,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": null,
          "fdname": null,
          "eddbid": null,
          "hidden": 1
        },
        "40127": {
          "mtype": "cbh",
          "cost": 153983540,
          "name": "Mk II Ablative Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 30,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "reserved": {
            "18": 1,
            "47": 1
          },
          "fdid": 129046029,
          "fdname": "AnacondaMkII_Armour_Grade2",
          "eddbid": null,
          "hidden": 0
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129046028,
          "fdname": "AnacondaMkII_Armour_Grade1_Default",
          "eddbid": null
        },
        "40136": {
          "mtype": "cbh",
          "cost": 19247940,
          "name": "Mk II Ablative Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 15,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "reserved": {
            "18": 1,
            "47": 1
          },
          "fdid": 129046027,
          "fdname": "AnacondaMkII_Armour_Grade1",
          "eddbid": null,
          "hidden": 0
        }
      }
    },
    "eagle": {
      "fdid": 128049255,
      "fdname": "Eagle",
      "eddbid": 7,
      "id": 21,
      "stype": "co",
      "name": "Eagle",
      "class": 1,
      "cost": 7490,
      "retail": 44800,
      "topspd": 240,
      "bstspd": 350,
      "mnv": 7,
      "shields": 80,
      "armour": 40,
      "mass": 50,
      "fwdacc": 43.97,
      "revacc": 29.97,
      "latacc": 29.86,
      "minthrust": 75,
      "boostcost": 8,
      "boostint": 4.5,
      "pitch": 50,
      "yaw": 18,
      "roll": 120,
      "pitchacc": 220,
      "yawacc": 110,
      "rollacc": 240,
      "minpitch": 40,
      "heatcap": 165,
      "heatdismin": 1.38,
      "heatdismax": 21.48,
      "fuelcost": 50,
      "fuelreserve": 0.34,
      "hardness": 28,
      "masslock": 6,
      "crew": 1,
      "slots": {
        "hardpoint": [
          1,
          1,
          1
        ],
        "utility": [
          0
        ],
        "component": [
          1,
          2,
          3,
          3,
          1,
          2,
          2,
          2
        ],
        "military": [
          2
        ],
        "internal": [
          3,
          2,
          1,
          1,
          1,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          62160,
          62160,
          0
        ],
        "utility": [
          0
        ],
        "component": [
          40131,
          41240,
          42350,
          43350,
          44150,
          45250,
          46250,
          47230
        ],
        "military": [
          0
        ],
        "internal": [
          30350,
          150,
          0,
          0,
          -3152,
          -3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 90050,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 8,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049258,
          "fdname": "Eagle_Armour_Grade3",
          "eddbid": 745
        },
        "40114": {
          "mtype": "cbh",
          "cost": 140090,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 8,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049259,
          "fdname": "Eagle_Armour_Mirrored",
          "eddbid": 746
        },
        "40115": {
          "mtype": "cbh",
          "cost": 150390,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 8,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049260,
          "fdname": "Eagle_Armour_Reactive",
          "eddbid": 747
        },
        "40122": {
          "mtype": "cbh",
          "cost": 26880,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 4,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049257,
          "fdname": "Eagle_Armour_Grade2",
          "eddbid": 744
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049256,
          "fdname": "Eagle_Armour_Grade1",
          "eddbid": 743
        }
      }
    },
    "viper": {
      "fdid": 128049273,
      "fdname": "Viper",
      "eddbid": 22,
      "id": 22,
      "stype": "co",
      "name": "Viper Mk III",
      "class": 1,
      "cost": 74610,
      "retail": 142930,
      "topspd": 320,
      "bstspd": 400,
      "mnv": 4,
      "shields": 105,
      "armour": 70,
      "mass": 50,
      "fwdacc": 53.98,
      "revacc": 29.7,
      "latacc": 24.95,
      "minthrust": 62.5,
      "boostcost": 10,
      "boostint": 5,
      "pitch": 35,
      "yaw": 15,
      "roll": 90,
      "pitchacc": 200,
      "yawacc": 100,
      "rollacc": 220,
      "minpitch": 30,
      "heatcap": 195,
      "heatdismin": 1.69,
      "heatdismax": 26.2,
      "fuelcost": 50,
      "fuelreserve": 0.41,
      "hardness": 35,
      "masslock": 7,
      "crew": 1,
      "slots": {
        "hardpoint": [
          2,
          2,
          1,
          1
        ],
        "utility": [
          0,
          0
        ],
        "component": [
          1,
          3,
          3,
          3,
          2,
          3,
          3,
          2
        ],
        "military": [
          3
        ],
        "internal": [
          3,
          3,
          2,
          1,
          1,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          62160,
          62160,
          0,
          0
        ],
        "utility": [
          0,
          0
        ],
        "component": [
          40131,
          41350,
          42350,
          43350,
          44250,
          45350,
          46350,
          47230
        ],
        "military": [
          0
        ],
        "internal": [
          250,
          30350,
          0,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 128640,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 9,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049276,
          "fdname": "Viper_Armour_Grade3",
          "eddbid": 760
        },
        "40114": {
          "mtype": "cbh",
          "cost": 304010,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 9,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049277,
          "fdname": "Viper_Armour_Mirrored",
          "eddbid": 761
        },
        "40115": {
          "mtype": "cbh",
          "cost": 336890,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 9,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049278,
          "fdname": "Viper_Armour_Reactive",
          "eddbid": 762
        },
        "40122": {
          "mtype": "cbh",
          "cost": 57170,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 5,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049275,
          "fdname": "Viper_Armour_Grade2",
          "eddbid": 759
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049274,
          "fdname": "Viper_Armour_Grade1",
          "eddbid": 758
        }
      }
    },
    "vulture": {
      "fdid": 128049309,
      "fdname": "Vulture",
      "eddbid": 23,
      "id": 23,
      "stype": "co",
      "name": "Vulture",
      "class": 1,
      "cost": 4670100,
      "retail": 4925620,
      "topspd": 210,
      "bstspd": 340,
      "mnv": 5,
      "shields": 240,
      "armour": 160,
      "mass": 230,
      "fwdacc": 39.55,
      "revacc": 29.88,
      "latacc": 19.98,
      "minthrust": 90.476,
      "boostcost": 16,
      "boostint": 4.5,
      "pitch": 42,
      "yaw": 17,
      "roll": 110,
      "pitchacc": 180,
      "yawacc": 90,
      "rollacc": 200,
      "minpitch": 35,
      "heatcap": 237,
      "heatdismin": 1.87,
      "heatdismax": 35.63,
      "fuelcost": 50,
      "fuelreserve": 0.57,
      "hardness": 55,
      "masslock": 10,
      "crew": 2,
      "slots": {
        "hardpoint": [
          3,
          3
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          4,
          5,
          4,
          3,
          5,
          4,
          3
        ],
        "military": [
          5
        ],
        "internal": [
          5,
          4,
          2,
          1,
          1,
          1,
          1
        ]
      },
      "slotnames": {
        "internal": [
          "Slot01_Size5",
          "Slot02_Size4",
          "Slot03_Size2",
          "Slot05_Size1",
          "Slot06_Size1",
          "Slot07_Size1",
          "Slot08_Size1"
        ]
      },
      "stock": {
        "hardpoint": [
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41450,
          42550,
          43450,
          44350,
          45550,
          46450,
          47330
        ],
        "military": [
          0
        ],
        "internal": [
          30550,
          350,
          0,
          0,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 4433050,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 35,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049312,
          "fdname": "Vulture_Armour_Grade3",
          "eddbid": 785
        },
        "40114": {
          "mtype": "cbh",
          "cost": 10476780,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 35,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049313,
          "fdname": "Vulture_Armour_Mirrored",
          "eddbid": 786
        },
        "40115": {
          "mtype": "cbh",
          "cost": 11609670,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 35,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049314,
          "fdname": "Vulture_Armour_Reactive",
          "eddbid": 787
        },
        "40122": {
          "mtype": "cbh",
          "cost": 1970250,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 17,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049311,
          "fdname": "Vulture_Armour_Grade2",
          "eddbid": 784
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049310,
          "fdname": "Vulture_Armour_Grade1",
          "eddbid": 783
        }
      }
    },
    "ferdelance": {
      "fdid": 128049351,
      "fdname": "FerDeLance",
      "eddbid": 11,
      "id": 24,
      "stype": "co",
      "name": "Fer-de-Lance",
      "class": 2,
      "cost": 51126980,
      "retail": 51567040,
      "topspd": 260,
      "bstspd": 350,
      "mnv": 4,
      "shields": 300,
      "armour": 225,
      "mass": 250,
      "fwdacc": 29.31,
      "revacc": 24.34,
      "latacc": 20.04,
      "minthrust": 84.615,
      "boostcost": 19,
      "boostint": 5,
      "pitch": 38,
      "yaw": 12,
      "roll": 90,
      "pitchacc": 200,
      "yawacc": 100,
      "rollacc": 220,
      "minpitch": 30,
      "heatcap": 224,
      "heatdismin": 2.05,
      "heatdismax": 41.63,
      "fuelcost": 50,
      "fuelreserve": 0.67,
      "hardness": 70,
      "masslock": 12,
      "crew": 2,
      "slots": {
        "hardpoint": [
          4,
          2,
          2,
          2,
          2
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          6,
          5,
          4,
          4,
          6,
          4,
          3
        ],
        "military": [],
        "internal": [
          5,
          4,
          4,
          2,
          1,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          62160,
          62160,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41650,
          42550,
          43450,
          44450,
          45650,
          46450,
          47330
        ],
        "military": [],
        "internal": [
          450,
          30450,
          350,
          0,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 46410340,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 38,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049354,
          "fdname": "FerDeLance_Armour_Grade3",
          "eddbid": 815
        },
        "40114": {
          "mtype": "cbh",
          "cost": 109683100,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 38,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049355,
          "fdname": "FerDeLance_Armour_Mirrored",
          "eddbid": 816
        },
        "40115": {
          "mtype": "cbh",
          "cost": 121543510,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 38,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049356,
          "fdname": "FerDeLance_Armour_Reactive",
          "eddbid": 817
        },
        "40122": {
          "mtype": "cbh",
          "cost": 20626820,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 19,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049353,
          "fdname": "FerDeLance_Armour_Grade2",
          "eddbid": 814
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049352,
          "fdname": "FerDeLance_Armour_Grade1",
          "eddbid": 813
        }
      }
    },
    "empire_eagle": {
      "fdid": 128672138,
      "fdname": "Empire_Eagle",
      "eddbid": 15,
      "id": 25,
      "stype": "co",
      "name": "Imperial Eagle",
      "class": 1,
      "cost": 50890,
      "retail": 110830,
      "topspd": 300,
      "bstspd": 400,
      "mnv": 5,
      "shields": 80,
      "armour": 60,
      "mass": 50,
      "fwdacc": 34.54,
      "revacc": 27.84,
      "latacc": 27.84,
      "minthrust": 70,
      "boostcost": 8,
      "boostint": 4.5,
      "pitch": 40,
      "yaw": 15,
      "roll": 100,
      "pitchacc": 220,
      "yawacc": 110,
      "rollacc": 240,
      "minpitch": 30,
      "heatcap": 163,
      "heatdismin": 1.5,
      "heatdismax": 21.2,
      "fuelcost": 50,
      "fuelreserve": 0.37,
      "hardness": 28,
      "masslock": 6,
      "crew": 1,
      "slots": {
        "hardpoint": [
          2,
          1,
          1
        ],
        "utility": [
          0
        ],
        "component": [
          1,
          3,
          3,
          3,
          1,
          2,
          2,
          2
        ],
        "military": [
          2
        ],
        "internal": [
          3,
          2,
          1,
          1,
          1,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          62160,
          62160
        ],
        "utility": [
          0
        ],
        "component": [
          40131,
          41350,
          42350,
          43350,
          44150,
          45250,
          46250,
          47230
        ],
        "military": [
          0
        ],
        "internal": [
          30350,
          150,
          0,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 222760,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 8,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672142,
          "fdname": "Empire_Eagle_Armour_Grade3",
          "eddbid": 1463
        },
        "40114": {
          "mtype": "cbh",
          "cost": 346550,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 8,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128672143,
          "fdname": "Empire_Eagle_Armour_Mirrored",
          "eddbid": 1464
        },
        "40115": {
          "mtype": "cbh",
          "cost": 372040,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 8,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128672144,
          "fdname": "Empire_Eagle_Armour_Reactive",
          "eddbid": 1465
        },
        "40122": {
          "mtype": "cbh",
          "cost": 66500,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 4,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672141,
          "fdname": "Empire_Eagle_Armour_Grade2",
          "eddbid": 1462
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672140,
          "fdname": "Empire_Eagle_Armour_Grade1",
          "eddbid": 1461
        }
      }
    },
    "federation_dropship_mkii": {
      "fdid": 128672145,
      "fdname": "Federation_Dropship_MkII",
      "eddbid": 8,
      "id": 26,
      "stype": "co",
      "name": "Federal Assault Ship",
      "class": 2,
      "cost": 19102490,
      "retail": 19814210,
      "faction": "Federation",
      "rank": 5,
      "topspd": 210,
      "bstspd": 350,
      "mnv": 4,
      "shields": 200,
      "armour": 300,
      "mass": 480,
      "fwdacc": 39.81,
      "revacc": 20.04,
      "latacc": 15.07,
      "minthrust": 71.429,
      "boostcost": 19,
      "boostint": 6,
      "pitch": 38,
      "yaw": 19,
      "roll": 90,
      "pitchacc": 170,
      "yawacc": 80,
      "rollacc": 200,
      "minpitch": 30,
      "heatcap": 286,
      "heatdismin": 2.53,
      "heatdismax": 45.23,
      "fuelcost": 50,
      "fuelreserve": 0.72,
      "hardness": 60,
      "masslock": 14,
      "crew": 2,
      "slots": {
        "hardpoint": [
          3,
          3,
          2,
          2
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          6,
          6,
          5,
          5,
          6,
          4,
          4
        ],
        "military": [
          4,
          4
        ],
        "internal": [
          5,
          5,
          4,
          3,
          2,
          2,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41650,
          42650,
          43550,
          44550,
          45650,
          46450,
          47430
        ],
        "military": [
          0,
          0
        ],
        "internal": [
          30550,
          450,
          350,
          350,
          0,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 17832780,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 87,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672149,
          "fdname": "Federation_Dropship_MkII_Armour_Grade3",
          "eddbid": 1468
        },
        "40114": {
          "mtype": "cbh",
          "cost": 42144810,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 87,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128672150,
          "fdname": "Federation_Dropship_MkII_Armour_Mirrored",
          "eddbid": 1469
        },
        "40115": {
          "mtype": "cbh",
          "cost": 46702080,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 87,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128672151,
          "fdname": "Federation_Dropship_MkII_Armour_Reactive",
          "eddbid": 1470
        },
        "40122": {
          "mtype": "cbh",
          "cost": 7925680,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 44,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672148,
          "fdname": "Federation_Dropship_MkII_Armour_Grade2",
          "eddbid": 1467
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672147,
          "fdname": "Federation_Dropship_MkII_Armour_Grade1",
          "eddbid": 1466
        }
      }
    },
    "federation_gunship": {
      "fdid": 128672152,
      "fdname": "Federation_Gunship",
      "eddbid": 10,
      "id": 27,
      "stype": "co",
      "name": "Federal Gunship",
      "class": 2,
      "cost": 34806280,
      "retail": 35814210,
      "faction": "Federation",
      "rank": 7,
      "topspd": 170,
      "bstspd": 280,
      "mnv": 1,
      "shields": 250,
      "armour": 350,
      "mass": 580,
      "fwdacc": 24.61,
      "revacc": 17.83,
      "latacc": 10.08,
      "minthrust": 58.824,
      "boostcost": 23,
      "boostint": 6,
      "pitch": 25,
      "yaw": 18,
      "roll": 80,
      "pitchacc": 100,
      "yawacc": 50,
      "rollacc": 80,
      "minpitch": 20,
      "heatcap": 325,
      "heatdismin": 2.87,
      "heatdismax": 51.4,
      "fuelcost": 50,
      "fuelreserve": 0.82,
      "hardness": 60,
      "masslock": 14,
      "crew": 2,
      "slots": {
        "hardpoint": [
          3,
          2,
          2,
          2,
          2,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          6,
          6,
          5,
          5,
          7,
          5,
          4
        ],
        "military": [
          4,
          4,
          4
        ],
        "internal": [
          6,
          6,
          5,
          2,
          2,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          0,
          62160,
          62160,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41650,
          42650,
          43550,
          44550,
          45750,
          46550,
          47430
        ],
        "military": [
          0,
          0,
          0
        ],
        "internal": [
          0,
          30650,
          450,
          0,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 32232790,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 87,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672156,
          "fdname": "Federation_Gunship_Armour_Grade3",
          "eddbid": 1473
        },
        "40114": {
          "mtype": "cbh",
          "cost": 76176810,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 87,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128672157,
          "fdname": "Federation_Gunship_Armour_Mirrored",
          "eddbid": 1474
        },
        "40115": {
          "mtype": "cbh",
          "cost": 84414090,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 87,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128672158,
          "fdname": "Federation_Gunship_Armour_Reactive",
          "eddbid": 1475
        },
        "40122": {
          "mtype": "cbh",
          "cost": 14325690,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 44,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672155,
          "fdname": "Federation_Gunship_Armour_Grade2",
          "eddbid": 1472
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672154,
          "fdname": "Federation_Gunship_Armour_Grade1",
          "eddbid": 1471
        }
      }
    },
    "viper_mkiv": {
      "fdid": 128672255,
      "fdname": "Viper_MkIV",
      "eddbid": 28,
      "id": 28,
      "stype": "co",
      "name": "Viper Mk IV",
      "class": 1,
      "cost": 290680,
      "retail": 437930,
      "topspd": 280,
      "bstspd": 360,
      "mnv": 3,
      "shields": 160,
      "armour": 150,
      "mass": 190,
      "fwdacc": 53.84,
      "revacc": 30.14,
      "latacc": 24.97,
      "minthrust": 64.815,
      "boostcost": 10,
      "boostint": 5,
      "pitch": 33,
      "yaw": 13,
      "roll": 90,
      "pitchacc": 200,
      "yawacc": 100,
      "rollacc": 220,
      "minpitch": 25,
      "heatcap": 209,
      "heatdismin": 1.82,
      "heatdismax": 28.98,
      "fuelcost": 50,
      "fuelreserve": 0.46,
      "hardness": 35,
      "masslock": 7,
      "crew": 1,
      "slots": {
        "hardpoint": [
          2,
          2,
          1,
          1
        ],
        "utility": [
          0,
          0
        ],
        "component": [
          1,
          4,
          4,
          4,
          2,
          3,
          3,
          4
        ],
        "military": [
          3
        ],
        "internal": [
          4,
          4,
          3,
          2,
          2,
          1,
          1,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          62160,
          62160,
          0,
          0
        ],
        "utility": [
          0,
          0
        ],
        "component": [
          40131,
          41450,
          42450,
          43450,
          44250,
          45350,
          46350,
          47430
        ],
        "military": [
          0
        ],
        "internal": [
          350,
          350,
          30350,
          150,
          0,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 394140,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 9,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672259,
          "fdname": "Viper_MkIV_Armour_Grade3",
          "eddbid": 1510
        },
        "40114": {
          "mtype": "cbh",
          "cost": 931480,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 9,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128672260,
          "fdname": "Viper_MkIV_Armour_Mirrored",
          "eddbid": 1511
        },
        "40115": {
          "mtype": "cbh",
          "cost": 1032200,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 9,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128672261,
          "fdname": "Viper_MkIV_Armour_Reactive",
          "eddbid": 1512
        },
        "40122": {
          "mtype": "cbh",
          "cost": 175180,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 5,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672258,
          "fdname": "Viper_MkIV_Armour_Grade2",
          "eddbid": 1509
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672257,
          "fdname": "Viper_MkIV_Armour_Grade1",
          "eddbid": 1508
        }
      }
    },
    "smallcombat01_nx": {
      "fdid": 129039241,
      "fdname": "SmallCombat01_NX",
      "eddbid": null,
      "id": 29,
      "stype": "co",
      "name": "Kestrel Mk II",
      "class": 1,
      "cost": 13776380,
      "retail": 14273820,
      "topspd": 270,
      "bstspd": 360,
      "mnv": 8,
      "shields": 225,
      "armour": 70,
      "mass": 190,
      "fwdacc": null,
      "revacc": null,
      "latacc": null,
      "minthrust": 89,
      "boostcost": 14,
      "boostint": 4.5,
      "pitch": 50,
      "yaw": 24,
      "roll": 120,
      "pitchacc": null,
      "yawacc": null,
      "rollacc": null,
      "minpitch": 40,
      "heatcap": 276,
      "heatdismin": null,
      "heatdismax": 39.85,
      "fuelcost": 50,
      "fuelreserve": 0.61,
      "hardness": 55,
      "masslock": 11,
      "crew": 1,
      "slots": {
        "hardpoint": [
          3,
          3,
          3,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          5,
          5,
          4,
          1,
          5,
          2,
          4
        ],
        "military": [
          4
        ],
        "internal": [
          5,
          4,
          3,
          2,
          2,
          2,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          0,
          72160,
          72160
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41550,
          42550,
          43451,
          44150,
          45550,
          46250,
          47430
        ],
        "military": [
          0
        ],
        "internal": [
          30550,
          0,
          250,
          0,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 12846440,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 35,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129039245,
          "fdname": "SmallCombat01_NX_Armour_Grade3",
          "eddbid": null
        },
        "40114": {
          "mtype": "cbh",
          "cost": 30360410,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 35,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 129039246,
          "fdname": "SmallCombat01_NX_Armour_Mirrored",
          "eddbid": null
        },
        "40115": {
          "mtype": "cbh",
          "cost": 33643390,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 35,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 129039247,
          "fdname": "SmallCombat01_NX_Armour_Reactive",
          "eddbid": null
        },
        "40122": {
          "mtype": "cbh",
          "cost": 5709530,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 17,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129039244,
          "fdname": "SmallCombat01_NX_Armour_Grade2",
          "eddbid": null
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129039243,
          "fdname": "SmallCombat01_NX_Armour_Grade1",
          "eddbid": null
        }
      }
    },
    "hauler": {
      "fdid": 128049261,
      "fdname": "Hauler",
      "eddbid": 12,
      "id": 31,
      "stype": "fr",
      "name": "Hauler",
      "class": 1,
      "cost": 8160,
      "retail": 52720,
      "topspd": 200,
      "bstspd": 300,
      "mnv": 4,
      "shields": 50,
      "armour": 100,
      "mass": 14,
      "fwdacc": 39.87,
      "revacc": 29.95,
      "latacc": 29.95,
      "minthrust": 35,
      "boostcost": 7,
      "boostint": 4,
      "pitch": 36,
      "yaw": 14,
      "roll": 100,
      "pitchacc": 220,
      "yawacc": 110,
      "rollacc": 240,
      "minpitch": 30,
      "heatcap": 123,
      "heatdismin": 1.06,
      "heatdismax": 16.2,
      "fuelcost": 50,
      "fuelreserve": 0.25,
      "hardness": 20,
      "masslock": 6,
      "crew": 1,
      "slots": {
        "hardpoint": [
          1
        ],
        "utility": [
          0,
          0
        ],
        "component": [
          1,
          2,
          2,
          2,
          1,
          1,
          1,
          2
        ],
        "military": [],
        "internal": [
          3,
          3,
          2,
          1,
          1,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          62160
        ],
        "utility": [
          0,
          0
        ],
        "component": [
          40131,
          41250,
          42250,
          43250,
          44150,
          45150,
          46150,
          47230
        ],
        "military": [],
        "internal": [
          250,
          250,
          30250,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 185050,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 2,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049264,
          "fdname": "Hauler_Armour_Grade3",
          "eddbid": 750
        },
        "40114": {
          "mtype": "cbh",
          "cost": 270300,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 2,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049265,
          "fdname": "Hauler_Armour_Mirrored",
          "eddbid": 751
        },
        "40115": {
          "mtype": "cbh",
          "cost": 282420,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 2,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049266,
          "fdname": "Hauler_Armour_Reactive",
          "eddbid": 752
        },
        "40122": {
          "mtype": "cbh",
          "cost": 42180,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 1,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049263,
          "fdname": "Hauler_Armour_Grade2",
          "eddbid": 749
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049262,
          "fdname": "Hauler_Armour_Grade1",
          "eddbid": 748
        }
      }
    },
    "type6": {
      "fdid": 128049285,
      "fdname": "Type6",
      "eddbid": 19,
      "id": 32,
      "stype": "fr",
      "name": "Type-6 Transporter",
      "class": 2,
      "cost": 858010,
      "retail": 1045950,
      "topspd": 220,
      "bstspd": 350,
      "mnv": 3,
      "shields": 125,
      "armour": 180,
      "mass": 155,
      "fwdacc": 20.1,
      "revacc": 14.96,
      "latacc": 15.07,
      "minthrust": 40.909,
      "boostcost": 10,
      "boostint": 4,
      "pitch": 30,
      "yaw": 17,
      "roll": 100,
      "pitchacc": 220,
      "yawacc": 110,
      "rollacc": 240,
      "minpitch": 23,
      "heatcap": 179,
      "heatdismin": 1.7,
      "heatdismax": 24.55,
      "fuelcost": 50,
      "fuelreserve": 0.39,
      "hardness": 35,
      "masslock": 8,
      "crew": 1,
      "slots": {
        "hardpoint": [
          1,
          1
        ],
        "utility": [
          0,
          0,
          0
        ],
        "component": [
          1,
          3,
          4,
          4,
          2,
          3,
          2,
          4
        ],
        "military": [],
        "internal": [
          6,
          5,
          5,
          4,
          4,
          3,
          2,
          2,
          1
        ]
      },
      "slotnames": {
        "internal": [
          "Slot00_Size6",
          "Slot01_Size5",
          "Slot02_Size5",
          "Slot03_Size4",
          "Slot04_Size4",
          "Slot05_Size3",
          "Slot06_Size2",
          "Slot07_Size2",
          "Slot08_Size1"
        ]
      },
      "stock": {
        "hardpoint": [
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0
        ],
        "component": [
          40131,
          41350,
          42450,
          43450,
          44250,
          45350,
          46250,
          47430
        ],
        "military": [],
        "internal": [
          0,
          450,
          450,
          350,
          350,
          30350,
          150,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 941350,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 23,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049288,
          "fdname": "Type6_Armour_Grade3",
          "eddbid": 770
        },
        "40114": {
          "mtype": "cbh",
          "cost": 2224730,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 23,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049289,
          "fdname": "Type6_Armour_Mirrored",
          "eddbid": 771
        },
        "40115": {
          "mtype": "cbh",
          "cost": 2465290,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 23,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049290,
          "fdname": "Type6_Armour_Reactive",
          "eddbid": 772
        },
        "40122": {
          "mtype": "cbh",
          "cost": 418380,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 12,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049287,
          "fdname": "Type6_Armour_Grade2",
          "eddbid": 769
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049286,
          "fdname": "Type6_Armour_Grade1",
          "eddbid": 768
        }
      }
    },
    "type7": {
      "fdid": 128049297,
      "fdname": "Type7",
      "eddbid": 20,
      "id": 33,
      "stype": "fr",
      "name": "Type-7 Transporter",
      "class": 3,
      "cost": 16774470,
      "retail": 17472250,
      "topspd": 180,
      "bstspd": 300,
      "mnv": 1,
      "shields": 156,
      "armour": 340,
      "mass": 300,
      "fwdacc": 20.11,
      "revacc": 15.02,
      "latacc": 15.13,
      "minthrust": 33.333,
      "boostcost": 10,
      "boostint": 6,
      "pitch": 22,
      "yaw": 22,
      "roll": 60,
      "pitchacc": 200,
      "yawacc": 50,
      "rollacc": 200,
      "minpitch": 16,
      "minyaw": 16,
      "heatcap": 232,
      "heatdismin": null,
      "heatdismax": null,
      "fuelcost": 50,
      "fuelreserve": 0.52,
      "hardness": 54,
      "masslock": 10,
      "crew": 1,
      "slots": {
        "hardpoint": [
          1,
          1,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          5,
          5,
          5,
          4,
          4,
          3,
          5
        ],
        "military": [],
        "internal": [
          7,
          6,
          6,
          6,
          6,
          5,
          5,
          5,
          3,
          3,
          2,
          1
        ]
      },
      "slotnames": {
        "internal": [
          "Slot00_Size7",
          "Slot00_Size6",
          "Slot01_Size6",
          "Slot02_Size6",
          "Slot03_Size5",
          "Slot04_Size5",
          "Slot05_Size4",
          "Slot06_Size4",
          "Slot07_Size2",
          "Slot08_Size2",
          "Slot09_Size2",
          "Slot09_Size1"
        ]
      },
      "stock": {
        "hardpoint": [
          62160,
          62160,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41450,
          42550,
          43550,
          44450,
          45350,
          46350,
          47530
        ],
        "military": [],
        "internal": [
          0,
          0,
          550,
          550,
          550,
          450,
          450,
          30450,
          0,
          0,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 15725030,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 63,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049300,
          "fdname": "Type7_Armour_Grade3",
          "eddbid": 775
        },
        "40114": {
          "mtype": "cbh",
          "cost": 37163480,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 63,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049301,
          "fdname": "Type7_Armour_Mirrored",
          "eddbid": 776
        },
        "40115": {
          "mtype": "cbh",
          "cost": 41182100,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 63,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049302,
          "fdname": "Type7_Armour_Reactive",
          "eddbid": 777
        },
        "40122": {
          "mtype": "cbh",
          "cost": 6988900,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 32,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049299,
          "fdname": "Type7_Armour_Grade2",
          "eddbid": 774
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049298,
          "fdname": "Type7_Armour_Grade1",
          "eddbid": 773
        }
      }
    },
    "type9": {
      "fdid": 128049333,
      "fdname": "Type9",
      "eddbid": 21,
      "id": 34,
      "stype": "fr",
      "name": "Type-9 Heavy",
      "class": 3,
      "cost": 72108220,
      "retail": 76555840,
      "topspd": 130,
      "bstspd": 200,
      "mnv": 0,
      "shields": 240,
      "armour": 480,
      "mass": 850,
      "fwdacc": 20.03,
      "revacc": 10.11,
      "latacc": 10.03,
      "minthrust": 30.769,
      "boostcost": 19,
      "boostint": 6,
      "pitch": 20,
      "yaw": 8,
      "roll": 20,
      "pitchacc": 100,
      "yawacc": 50,
      "rollacc": 80,
      "minpitch": 15,
      "heatcap": 289,
      "heatdismin": 3.1,
      "heatdismax": 48.35,
      "fuelcost": 50,
      "fuelreserve": 0.77,
      "hardness": 65,
      "masslock": 16,
      "crew": 4,
      "slots": {
        "hardpoint": [
          2,
          2,
          2,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          6,
          7,
          6,
          5,
          6,
          4,
          6
        ],
        "military": [],
        "internal": [
          8,
          8,
          7,
          6,
          5,
          4,
          4,
          3,
          3,
          2,
          1
        ]
      },
      "slotnames": {
        "internal": [
          "Slot00_Size8",
          "Slot01_Size8",
          "Slot02_Size7",
          "Slot03_Size6",
          "Slot04_Size5",
          "Slot05_Size4",
          "Slot06_Size4",
          "Slot07_Size3",
          "Slot08_Size3",
          "Slot11_Size2",
          "Slot12_Size1"
        ]
      },
      "stock": {
        "hardpoint": [
          62160,
          62160,
          0,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41650,
          42750,
          43650,
          44550,
          45650,
          46450,
          47630
        ],
        "military": [],
        "internal": [
          750,
          750,
          650,
          30650,
          450,
          350,
          0,
          250,
          0,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 68900260,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 150,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049336,
          "fdname": "Type9_Armour_Grade3",
          "eddbid": 805
        },
        "40114": {
          "mtype": "cbh",
          "cost": 162834280,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 150,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049337,
          "fdname": "Type9_Armour_Mirrored",
          "eddbid": 806
        },
        "40115": {
          "mtype": "cbh",
          "cost": 180442120,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 150,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049338,
          "fdname": "Type9_Armour_Reactive",
          "eddbid": 807
        },
        "40122": {
          "mtype": "cbh",
          "cost": 30622340,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 75,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049335,
          "fdname": "Type9_Armour_Grade2",
          "eddbid": 804
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049334,
          "fdname": "Type9_Armour_Grade1",
          "eddbid": 803
        }
      }
    },
    "independant_trader": {
      "fdid": 128672269,
      "fdname": "Independant_Trader",
      "eddbid": 27,
      "id": 35,
      "stype": "fr",
      "name": "Keelback",
      "class": 2,
      "cost": 2937840,
      "retail": 3126150,
      "topspd": 200,
      "bstspd": 300,
      "mnv": 2,
      "shields": 135,
      "armour": 270,
      "mass": 180,
      "fwdacc": 20.22,
      "revacc": 15.07,
      "latacc": 15.03,
      "minthrust": 45,
      "boostcost": 10,
      "boostint": 4,
      "pitch": 27,
      "yaw": 15,
      "roll": 100,
      "pitchacc": 220,
      "yawacc": 110,
      "rollacc": 240,
      "minpitch": 20,
      "heatcap": 215,
      "heatdismin": 1.87,
      "heatdismax": 29.78,
      "fuelcost": 50,
      "fuelreserve": 0.39,
      "hardness": 45,
      "masslock": 8,
      "crew": 2,
      "slots": {
        "hardpoint": [
          2,
          2,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0
        ],
        "component": [
          1,
          4,
          4,
          4,
          1,
          3,
          2,
          4
        ],
        "military": [],
        "internal": [
          5,
          5,
          4,
          3,
          2,
          2,
          1
        ]
      },
      "slotnames": {
        "internal": [
          "Slot01_Size5",
          "Slot02_Size5",
          "Slot03_Size3",
          "Slot04_Size3",
          "Slot05_Size2",
          "Slot06_Size2",
          "Slot07_Size1"
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0
        ],
        "component": [
          40131,
          41450,
          42450,
          43450,
          44150,
          45350,
          46250,
          47430
        ],
        "military": [],
        "internal": [
          450,
          450,
          350,
          30350,
          150,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 2813540,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 23,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672273,
          "fdname": "Independant_Trader_Armour_Grade3",
          "eddbid": 1515
        },
        "40114": {
          "mtype": "cbh",
          "cost": 6649330,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 23,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128672274,
          "fdname": "Independant_Trader_Armour_Mirrored",
          "eddbid": 1516
        },
        "40115": {
          "mtype": "cbh",
          "cost": 7368340,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 23,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128672275,
          "fdname": "Independant_Trader_Armour_Reactive",
          "eddbid": 1517
        },
        "40122": {
          "mtype": "cbh",
          "cost": 1250460,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 12,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672272,
          "fdname": "Independant_Trader_Armour_Grade2",
          "eddbid": 1514
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672271,
          "fdname": "Independant_Trader_Armour_Grade1",
          "eddbid": 1513
        }
      }
    },
    "type9_military": {
      "fdid": 128785619,
      "fdname": "Type9_Military",
      "eddbid": 32,
      "id": 36,
      "stype": "fr",
      "name": "Type-10 Defender",
      "class": 3,
      "cost": 121486140,
      "retail": 124755340,
      "topspd": 180,
      "bstspd": 220,
      "mnv": 0,
      "shields": 320,
      "armour": 580,
      "mass": 1200,
      "fwdacc": 17.96,
      "revacc": 10.04,
      "latacc": 10.09,
      "minthrust": 83.333,
      "boostcost": 19,
      "boostint": 6,
      "pitch": 22,
      "yaw": 8,
      "roll": 40,
      "pitchacc": 100,
      "yawacc": 35,
      "rollacc": 80,
      "minpitch": 18,
      "heatcap": 335,
      "heatdismin": 3.16,
      "heatdismax": 67.15,
      "fuelcost": 50,
      "fuelreserve": 0.77,
      "hardness": 75,
      "masslock": 26,
      "crew": 4,
      "slots": {
        "hardpoint": [
          3,
          3,
          3,
          3,
          2,
          2,
          2,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          8,
          7,
          7,
          5,
          7,
          4,
          6
        ],
        "military": [
          5,
          5
        ],
        "internal": [
          8,
          7,
          6,
          5,
          4,
          4,
          3,
          3,
          2,
          1
        ]
      },
      "slotnames": {
        "internal": [
          "Slot01_Size8",
          "Slot02_Size7",
          "Slot03_Size6",
          "Slot04_Size5",
          "Slot05_Size4",
          "Slot06_Size4",
          "Slot07_Size3",
          "Slot08_Size3",
          "Slot11_Size2",
          "Slot12_Size1"
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          0,
          0,
          62160,
          62160,
          0,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41650,
          42750,
          43650,
          44550,
          45650,
          46450,
          47630
        ],
        "military": [
          0,
          0
        ],
        "internal": [
          750,
          650,
          30650,
          450,
          350,
          0,
          250,
          0,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 112279810,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 150,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128785623,
          "fdname": "Type9_Military_Armour_Grade3",
          "eddbid": 1629
        },
        "40114": {
          "mtype": "cbh",
          "cost": 265354610,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 150,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128785624,
          "fdname": "Type9_Military_Armour_Mirrored",
          "eddbid": 1630
        },
        "40115": {
          "mtype": "cbh",
          "cost": 294048340,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 150,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128785625,
          "fdname": "Type9_Military_Armour_Reactive",
          "eddbid": 1631
        },
        "40122": {
          "mtype": "cbh",
          "cost": 49902130,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 75,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128785622,
          "fdname": "Type9_Military_Armour_Grade2",
          "eddbid": 1628
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128785621,
          "fdname": "Type9_Military_Armour_Grade1",
          "eddbid": 1627
        }
      }
    },
    "type8": {
      "fdid": 129030534,
      "fdname": "Type8",
      "id": 37,
      "stype": "fr",
      "name": "Type-8 Transporter",
      "class": 2,
      "cost": 36238840,
      "retail": 38453970,
      "topspd": 200,
      "bstspd": 340,
      "mnv": 1,
      "shields": 228,
      "armour": 440,
      "mass": 400,
      "fwdacc": null,
      "revacc": null,
      "latacc": null,
      "minthrust": 45,
      "boostcost": 10,
      "boostint": 6,
      "pitch": 28,
      "yaw": 18,
      "roll": 60,
      "pitchacc": null,
      "yawacc": null,
      "rollacc": null,
      "minpitch": 17,
      "minyaw": 16,
      "heatcap": 236,
      "heatdismin": 2.27,
      "heatdismax": 36.5,
      "fuelcost": 50,
      "fuelreserve": 0.52,
      "hardness": 58,
      "masslock": 18,
      "crew": 1,
      "slots": {
        "hardpoint": [
          2,
          1,
          1,
          1,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          5,
          5,
          5,
          3,
          4,
          3,
          5
        ],
        "military": [],
        "internal": [
          7,
          6,
          6,
          6,
          5,
          5,
          4,
          2,
          1
        ]
      },
      "slotnames": {
        "hardpoint": [
          "MediumHardpoint1",
          "SmallHardpoint1",
          "SmallHardpoint2",
          "SmallHardpoint4",
          "SmallHardpoint5",
          "SmallHardpoint6"
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          62160,
          62160,
          0,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41550,
          42550,
          43531,
          44350,
          45450,
          46350,
          47530
        ],
        "military": [],
        "internal": [
          750,
          550,
          0,
          0,
          450,
          30450,
          0,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 34608570,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 63,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129030537,
          "fdname": "Type8_Armour_Grade3",
          "eddbid": null
        },
        "40114": {
          "mtype": "cbh",
          "cost": 81791590,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 63,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 129030538,
          "fdname": "Type8_Armour_Mirrored",
          "eddbid": null
        },
        "40115": {
          "mtype": "cbh",
          "cost": 90636000,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 63,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 129030539,
          "fdname": "Type8_Armour_Reactive",
          "eddbid": null
        },
        "40122": {
          "mtype": "cbh",
          "cost": 15381590,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 32,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129030536,
          "fdname": "Type8_Armour_Grade2",
          "eddbid": null
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129030535,
          "fdname": "Type8_Armour_Grade1",
          "eddbid": null
        }
      }
    },
    "lakonminer": {
      "fdid": 129036130,
      "fdname": "LakonMiner",
      "eddbid": null,
      "id": 38,
      "stype": "mi",
      "name": "Type-11 Prospector",
      "class": 2,
      "cost": 66346710,
      "retail": 67861850,
      "topspd": 270,
      "bstspd": 365,
      "mnv": 2,
      "shields": 275,
      "armour": 350,
      "mass": 320,
      "fwdacc": null,
      "revacc": null,
      "latacc": null,
      "minthrust": 70.5,
      "boostcost": 25,
      "boostint": 6,
      "pitch": 25,
      "yaw": 22,
      "roll": 37.5,
      "pitchacc": null,
      "yawacc": null,
      "rollacc": null,
      "minpitch": 22,
      "heatcap": 300,
      "heatdismin": 2.68,
      "heatdismax": 52.15,
      "fuelcost": 50,
      "fuelreserve": 0.6,
      "hardness": 58,
      "masslock": 15,
      "crew": 3,
      "slots": {
        "hardpoint": [
          3,
          2,
          2,
          2,
          1,
          1,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          6,
          5,
          5,
          3,
          7,
          3,
          5
        ],
        "military": [],
        "internal": [
          6,
          6,
          6,
          5,
          5,
          5,
          5,
          4,
          3,
          2,
          1,
          1
        ]
      },
      "slotnames": {
        "hardpoint": [
          "LargeMiningHardpoint1",
          "MediumMiningHardpoint1",
          "MediumMiningHardpoint2",
          "MediumHardpoint3",
          "SmallMiningHardpoint1",
          "SmallHardpoint2",
          "SmallHardpoint3",
          "SmallHardpoint4"
        ],
        "internal": [
          "Slot01_Size6",
          "Slot02_Size6",
          "Slot03_Size6",
          "Slot04_Size5",
          "Slot05_Size5",
          "LimpetController01",
          "FighterBay01",
          "Slot06_Size4",
          "Slot07_Size3",
          "Slot08_Size2",
          "Slot09_Size1",
          "Slot10_Size1"
        ]
      },
      "reserved": {
        "hardpoint": [
          {
            "hmtl": 1,
            "hmtm": 1
          },
          {
            "hmtl": 1,
            "hmtm": 1
          },
          {
            "hmtl": 1,
            "hmtm": 1
          },
          null,
          {
            "hmtl": 1,
            "hmtm": 1
          }
        ],
        "internal": [
          null,
          null,
          null,
          null,
          null,
          {
            "iclc": 1,
            "idlc": 1,
            "iftlc": 1,
            "ihblc": 1,
            "imlc": 1,
            "iplc": 1,
            "inlc": 1,
            "irlc": 1,
            "islc": 1
          },
          {
            "ifh": 1,
            "ipvh": 1
          }
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          0,
          0,
          0,
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41650,
          42550,
          43551,
          44350,
          45750,
          46350,
          47530
        ],
        "military": [],
        "internal": [
          550,
          550,
          30550,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          3151,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 61075670,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 63,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129036134,
          "fdname": "LakonMiner_Armour_Grade3",
          "eddbid": null
        },
        "40114": {
          "mtype": "cbh",
          "cost": 144342150,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 63,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 129036135,
          "fdname": "LakonMiner_Armour_Mirrored",
          "eddbid": null
        },
        "40115": {
          "mtype": "cbh",
          "cost": 159950380,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 63,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 129036136,
          "fdname": "LakonMiner_Armour_Reactive",
          "eddbid": null
        },
        "40122": {
          "mtype": "cbh",
          "cost": 27144740,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 32,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129036133,
          "fdname": "LakonMiner_Armour_Grade2",
          "eddbid": null
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129036132,
          "fdname": "LakonMiner_Armour_Grade1",
          "eddbid": null
        }
      }
    },
    "adder": {
      "fdid": 128049267,
      "fdname": "Adder",
      "eddbid": 1,
      "id": 41,
      "stype": "ex",
      "name": "Adder",
      "class": 1,
      "cost": 18710,
      "retail": 87810,
      "topspd": 220,
      "bstspd": 320,
      "mnv": 4,
      "shields": 60,
      "armour": 90,
      "mass": 35,
      "fwdacc": 39.41,
      "revacc": 27.73,
      "latacc": 27.86,
      "minthrust": 45.454,
      "boostcost": 8,
      "boostint": 4,
      "pitch": 38,
      "yaw": 14,
      "roll": 100,
      "pitchacc": 200,
      "yawacc": 100,
      "rollacc": 220,
      "minpitch": 30,
      "heatcap": 170,
      "heatdismin": 1.45,
      "heatdismax": 22.6,
      "fuelcost": 50,
      "fuelreserve": 0.36,
      "hardness": 35,
      "masslock": 7,
      "crew": 2,
      "slots": {
        "hardpoint": [
          2,
          1,
          1
        ],
        "utility": [
          0,
          0
        ],
        "component": [
          1,
          3,
          3,
          3,
          1,
          2,
          3,
          3
        ],
        "military": [],
        "internal": [
          3,
          3,
          2,
          2,
          1,
          1,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0
        ],
        "component": [
          40131,
          41350,
          42350,
          43350,
          44150,
          45250,
          46350,
          47330
        ],
        "military": [],
        "internal": [
          250,
          30350,
          150,
          0,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 79030,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 5,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049270,
          "fdname": "Adder_Armour_Grade3",
          "eddbid": 755
        },
        "40114": {
          "mtype": "cbh",
          "cost": 186770,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 5,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049271,
          "fdname": "Adder_Armour_Mirrored",
          "eddbid": 756
        },
        "40115": {
          "mtype": "cbh",
          "cost": 206960,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 5,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049272,
          "fdname": "Adder_Armour_Reactive",
          "eddbid": 757
        },
        "40122": {
          "mtype": "cbh",
          "cost": 35120,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 3,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049269,
          "fdname": "Adder_Armour_Grade2",
          "eddbid": 754
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049268,
          "fdname": "Adder_Armour_Grade1",
          "eddbid": 753
        }
      }
    },
    "asp": {
      "fdid": 128049303,
      "fdname": "Asp",
      "eddbid": 3,
      "id": 42,
      "stype": "ex",
      "name": "Asp Explorer",
      "class": 2,
      "cost": 6137180,
      "retail": 6661160,
      "topspd": 250,
      "bstspd": 340,
      "mnv": 4,
      "shields": 140,
      "armour": 210,
      "mass": 280,
      "fwdacc": 23.64,
      "revacc": 15.04,
      "latacc": 14.97,
      "minthrust": 48,
      "boostcost": 13,
      "boostint": 4.5,
      "pitch": 38,
      "yaw": 10,
      "roll": 100,
      "pitchacc": 200,
      "yawacc": 100,
      "rollacc": 220,
      "minpitch": 30,
      "heatcap": 272,
      "heatdismin": 2.34,
      "heatdismax": 39.9,
      "fuelcost": 50,
      "fuelreserve": 0.63,
      "hardness": 52,
      "masslock": 11,
      "crew": 2,
      "slots": {
        "hardpoint": [
          2,
          2,
          1,
          1,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          5,
          5,
          5,
          4,
          4,
          5,
          5
        ],
        "military": [],
        "internal": [
          6,
          5,
          3,
          3,
          3,
          2,
          2,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          62160,
          62160,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41550,
          42550,
          43550,
          44450,
          45450,
          46550,
          47530
        ],
        "military": [],
        "internal": [
          550,
          30550,
          250,
          0,
          0,
          150,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 5995040,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 42,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049306,
          "fdname": "Asp_Armour_Grade3",
          "eddbid": 780
        },
        "40114": {
          "mtype": "cbh",
          "cost": 14168270,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 42,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049307,
          "fdname": "Asp_Armour_Mirrored",
          "eddbid": 781
        },
        "40115": {
          "mtype": "cbh",
          "cost": 15700340,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 42,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049308,
          "fdname": "Asp_Armour_Reactive",
          "eddbid": 782
        },
        "40122": {
          "mtype": "cbh",
          "cost": 2664460,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 21,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049305,
          "fdname": "Asp_Armour_Grade2",
          "eddbid": 779
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049304,
          "fdname": "Asp_Armour_Grade1",
          "eddbid": 778
        }
      }
    },
    "diamondback": {
      "fdid": 128671217,
      "fdname": "DiamondBack",
      "eddbid": 6,
      "id": 43,
      "stype": "ex",
      "name": "Diamondback Scout",
      "class": 1,
      "cost": 441800,
      "retail": 564330,
      "topspd": 280,
      "bstspd": 380,
      "mnv": 5,
      "shields": 120,
      "armour": 120,
      "mass": 170,
      "fwdacc": 39.57,
      "revacc": 29.82,
      "latacc": 25.19,
      "minthrust": 60.714,
      "boostcost": 10,
      "boostint": 4,
      "pitch": 42,
      "yaw": 15,
      "roll": 100,
      "pitchacc": 200,
      "yawacc": 100,
      "rollacc": 220,
      "minpitch": 35,
      "heatcap": 346,
      "heatdismin": 2.42,
      "heatdismax": 48.05,
      "fuelcost": 50,
      "fuelreserve": 0.49,
      "hardness": 40,
      "masslock": 8,
      "crew": 1,
      "slots": {
        "hardpoint": [
          2,
          2,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          4,
          4,
          4,
          2,
          3,
          2,
          4
        ],
        "military": [],
        "internal": [
          3,
          3,
          3,
          2,
          1,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          62160,
          62160,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41450,
          42450,
          43450,
          44250,
          45350,
          46250,
          47430
        ],
        "military": [],
        "internal": [
          30350,
          0,
          0,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 507900,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 26,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128671220,
          "fdname": "DiamondBack_Armour_Grade3",
          "eddbid": 1386
        },
        "40114": {
          "mtype": "cbh",
          "cost": 1185090,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 26,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128671221,
          "fdname": "DiamondBack_Armour_Mirrored",
          "eddbid": 1387
        },
        "40115": {
          "mtype": "cbh",
          "cost": 1330120,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 26,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128671222,
          "fdname": "DiamondBack_Armour_Reactive",
          "eddbid": 1388
        },
        "40122": {
          "mtype": "cbh",
          "cost": 225730,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 13,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128671219,
          "fdname": "DiamondBack_Armour_Grade2",
          "eddbid": 1385
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128671218,
          "fdname": "DiamondBack_Armour_Grade1",
          "eddbid": 1384
        }
      }
    },
    "diamondbackxl": {
      "fdid": 128671831,
      "fdname": "DiamondBackXL",
      "eddbid": 5,
      "id": 44,
      "stype": "ex",
      "name": "Diamondback Explorer",
      "class": 1,
      "cost": 1616160,
      "retail": 1894760,
      "topspd": 260,
      "bstspd": 340,
      "mnv": 4,
      "shields": 150,
      "armour": 150,
      "mass": 260,
      "fwdacc": 34.63,
      "revacc": 25.06,
      "latacc": 19.89,
      "minthrust": 61.538,
      "boostcost": 13,
      "boostint": 4,
      "pitch": 35,
      "yaw": 13,
      "roll": 90,
      "pitchacc": 200,
      "yawacc": 100,
      "rollacc": 220,
      "minpitch": 28,
      "heatcap": 351,
      "heatdismin": 2.46,
      "heatdismax": 50.55,
      "fuelcost": 50,
      "fuelreserve": 0.52,
      "hardness": 42,
      "masslock": 10,
      "crew": 1,
      "slots": {
        "hardpoint": [
          3,
          2,
          2
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          4,
          4,
          5,
          3,
          4,
          3,
          5
        ],
        "military": [],
        "internal": [
          4,
          4,
          3,
          3,
          2,
          2,
          1,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41450,
          42450,
          43550,
          44350,
          45450,
          46350,
          47530
        ],
        "military": [],
        "internal": [
          30450,
          350,
          250,
          0,
          0,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 1705290,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 47,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128671834,
          "fdname": "DiamondBackXL_Armour_Grade3",
          "eddbid": 1458
        },
        "40114": {
          "mtype": "cbh",
          "cost": 3979000,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 47,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128671835,
          "fdname": "DiamondBackXL_Armour_Mirrored",
          "eddbid": 1459
        },
        "40115": {
          "mtype": "cbh",
          "cost": 4465950,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 47,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128671836,
          "fdname": "DiamondBackXL_Armour_Reactive",
          "eddbid": 1460
        },
        "40122": {
          "mtype": "cbh",
          "cost": 757910,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 23,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128671833,
          "fdname": "DiamondBackXL_Armour_Grade2",
          "eddbid": 1457
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128671832,
          "fdname": "DiamondBackXL_Armour_Grade1",
          "eddbid": 1456
        }
      }
    },
    "asp_scout": {
      "fdid": 128672276,
      "fdname": "Asp_Scout",
      "eddbid": 24,
      "id": 45,
      "stype": "ex",
      "name": "Asp Scout",
      "class": 2,
      "cost": 3811220,
      "retail": 3961160,
      "topspd": 270,
      "bstspd": 360,
      "mnv": 5,
      "shields": 120,
      "armour": 180,
      "mass": 140,
      "fwdacc": 40,
      "revacc": 30,
      "latacc": 20,
      "minthrust": 50,
      "boostcost": 13,
      "boostint": 4.5,
      "pitch": 40,
      "yaw": 18,
      "roll": 110,
      "pitchacc": null,
      "yawacc": null,
      "rollacc": null,
      "minpitch": 35,
      "heatcap": 210,
      "heatdismin": 1.8,
      "heatdismax": 29.65,
      "fuelcost": 50,
      "fuelreserve": 0.47,
      "hardness": 52,
      "masslock": 8,
      "crew": 2,
      "slots": {
        "hardpoint": [
          2,
          2,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0
        ],
        "component": [
          1,
          4,
          4,
          4,
          3,
          4,
          4,
          4
        ],
        "military": [],
        "internal": [
          5,
          4,
          3,
          3,
          2,
          2,
          1
        ]
      },
      "slotnames": {
        "internal": [
          "Slot01_Size4",
          "Slot02_Size4",
          "Slot03_Size3",
          "Slot04_Size3",
          "Slot05_Size2",
          "Slot06_Size2",
          "Slot07_Size1"
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0
        ],
        "component": [
          40131,
          41450,
          42450,
          43450,
          44350,
          45450,
          46450,
          47430
        ],
        "military": [],
        "internal": [
          350,
          350,
          30350,
          0,
          0,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 3565040,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 42,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672280,
          "fdname": "Asp_Scout_Armour_Grade3",
          "eddbid": 1505
        },
        "40114": {
          "mtype": "cbh",
          "cost": 8425380,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 42,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128672281,
          "fdname": "Asp_Scout_Armour_Mirrored",
          "eddbid": 1506
        },
        "40115": {
          "mtype": "cbh",
          "cost": 9336440,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 42,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128672282,
          "fdname": "Asp_Scout_Armour_Reactive",
          "eddbid": 1507
        },
        "40122": {
          "mtype": "cbh",
          "cost": 1584460,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 21,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672279,
          "fdname": "Asp_Scout_Armour_Grade2",
          "eddbid": 1504
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128672278,
          "fdname": "Asp_Scout_Armour_Grade1",
          "eddbid": 1503
        }
      }
    },
    "mandalay": {
      "fdid": 129030680,
      "fdname": "Mandalay",
      "id": 46,
      "stype": "ex",
      "name": "Mandalay",
      "class": 2,
      "cost": 16527690,
      "retail": 17639220,
      "topspd": 280,
      "bstspd": 350,
      "mnv": 5,
      "shields": 220,
      "armour": 230,
      "mass": 190,
      "fwdacc": null,
      "revacc": null,
      "latacc": null,
      "minthrust": 71.5,
      "boostcost": 14,
      "boostint": 5,
      "pitch": 35,
      "yaw": 28,
      "roll": 96,
      "pitchacc": null,
      "yawacc": null,
      "rollacc": null,
      "minpitch": 24.5,
      "minyaw": 16,
      "heatcap": 245,
      "heatdismin": 2.23,
      "heatdismax": 51,
      "fuelcost": 50,
      "fuelreserve": 0.5,
      "hardness": 55,
      "masslock": 11,
      "crew": 2,
      "slots": {
        "hardpoint": [
          2,
          2,
          2,
          2,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          5,
          5,
          5,
          4,
          5,
          5,
          5
        ],
        "military": [],
        "internal": [
          6,
          5,
          4,
          4,
          3,
          3,
          2,
          1,
          1,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          0,
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41550,
          42550,
          43531,
          44450,
          45550,
          46550,
          47530
        ],
        "military": [],
        "internal": [
          550,
          30550,
          350,
          0,
          0,
          0,
          0,
          0,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 15875300,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 38,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129030683,
          "fdname": "Mandalay_Armour_Grade3",
          "eddbid": null
        },
        "40114": {
          "mtype": "cbh",
          "cost": 37518620,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 38,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 129030684,
          "fdname": "Mandalay_Armour_Mirrored",
          "eddbid": null
        },
        "40115": {
          "mtype": "cbh",
          "cost": 41575640,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 38,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 129030685,
          "fdname": "Mandalay_Armour_Reactive",
          "eddbid": null
        },
        "40122": {
          "mtype": "cbh",
          "cost": 7055690,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 19,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129030682,
          "fdname": "Mandalay_Armour_Grade2",
          "eddbid": null
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129030681,
          "fdname": "Mandalay_Armour_Grade1",
          "eddbid": null
        }
      }
    },
    "explorer_nx": {
      "fdid": 129036569,
      "fdname": "Explorer_NX",
      "eddbid": null,
      "id": 47,
      "stype": "ex",
      "name": "Caspian Explorer",
      "class": 3,
      "cost": 189326510,
      "retail": 194861290,
      "topspd": 210,
      "bstspd": 290,
      "mnv": 2,
      "shields": 500,
      "armour": 345,
      "mass": 825,
      "fwdacc": null,
      "revacc": null,
      "latacc": null,
      "minthrust": 76,
      "boostcost": 25,
      "boostint": 5.5,
      "pitch": 30,
      "yaw": 14,
      "roll": 75,
      "pitchacc": null,
      "yawacc": null,
      "rollacc": null,
      "minpitch": 23,
      "heatcap": 341,
      "heatdismin": 3.21,
      "heatdismax": 72.1,
      "fuelcost": 50,
      "fuelreserve": 1.14,
      "hardness": 60,
      "masslock": 21,
      "crew": 4,
      "slots": {
        "hardpoint": [
          3,
          2,
          2,
          2,
          2,
          2,
          2
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          8,
          7,
          8,
          5,
          7,
          8,
          7
        ],
        "military": [],
        "internal": [
          7,
          6,
          6,
          5,
          5,
          5,
          5,
          4,
          4,
          3,
          2,
          1,
          1,
          1
        ]
      },
      "slotnames": {
        "hardpoint": [
          "LargeHardpoint1",
          "MediumHardpoint6",
          "MediumHardpoint5",
          "MediumHardpoint1",
          "MediumHardpoint2",
          "MediumHardpoint3",
          "MediumHardpoint4"
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          0,
          62160,
          62160,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41850,
          42750,
          43851,
          44550,
          45750,
          46850,
          47730
        ],
        "military": [],
        "internal": [
          650,
          30650,
          550,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40110": {
          "mtype": "cbh",
          "cost": 459288060,
          "name": "Mk II Ablative Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "reserved": {
            "18": 1,
            "47": 1
          },
          "fdid": 129036575,
          "fdname": "Explorer_NX_Armour_Reactive",
          "eddbid": null,
          "hidden": 0
        },
        "40113": {
          "mtype": "cbh",
          "cost": null,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": null,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": null,
          "fdname": null,
          "eddbid": null,
          "hidden": 1
        },
        "40114": {
          "mtype": "cbh",
          "cost": null,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": null,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": null,
          "fdname": null,
          "eddbid": null,
          "hidden": 1
        },
        "40115": {
          "mtype": "cbh",
          "cost": null,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": null,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": null,
          "fdname": null,
          "eddbid": null,
          "hidden": 1
        },
        "40118": {
          "mtype": "cbh",
          "cost": 175375160,
          "name": "Mk II Ablative Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "reserved": {
            "18": 1,
            "47": 1
          },
          "fdid": 129036573,
          "fdname": "Explorer_NX_Armour_Grade3",
          "eddbid": null,
          "hidden": 0
        },
        "40119": {
          "mtype": "cbh",
          "cost": 414469960,
          "name": "Mk II Ablative Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "reserved": {
            "18": 1,
            "47": 1
          },
          "fdid": 129036574,
          "fdname": "Explorer_NX_Armour_Mirrored",
          "eddbid": null,
          "hidden": 0
        },
        "40122": {
          "mtype": "cbh",
          "cost": null,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": null,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": null,
          "fdname": null,
          "eddbid": null,
          "hidden": 1
        },
        "40127": {
          "mtype": "cbh",
          "cost": 77944520,
          "name": "Mk II Ablative Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 30,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "reserved": {
            "18": 1,
            "47": 1
          },
          "fdid": 129036572,
          "fdname": "Explorer_NX_Armour_Grade2",
          "eddbid": null,
          "hidden": 0
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129036581,
          "fdname": "Explorer_NX_Armour_Grade1_Default",
          "eddbid": null
        },
        "40136": {
          "mtype": "cbh",
          "cost": 9743070,
          "name": "Mk II Ablative Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 15,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "reserved": {
            "18": 1,
            "47": 1
          },
          "fdid": 129036571,
          "fdname": "Explorer_NX_Armour_Grade1",
          "eddbid": null,
          "hidden": 0
        }
      }
    },
    "orca": {
      "fdid": 128049327,
      "fdname": "Orca",
      "eddbid": 16,
      "id": 51,
      "stype": "pa",
      "name": "Orca",
      "class": 3,
      "cost": 47792090,
      "retail": 48539890,
      "topspd": 300,
      "bstspd": 380,
      "mnv": 1,
      "shields": 220,
      "armour": 220,
      "mass": 290,
      "fwdacc": 29.66,
      "revacc": 25.08,
      "latacc": 19.95,
      "minthrust": 66.667,
      "boostcost": 16,
      "boostint": 4,
      "pitch": 25,
      "yaw": 18,
      "roll": 55,
      "pitchacc": 220,
      "yawacc": 110,
      "rollacc": 240,
      "minpitch": 20,
      "heatcap": 262,
      "heatdismin": 2.3,
      "heatdismax": 42.68,
      "fuelcost": 50,
      "fuelreserve": 0.79,
      "hardness": 55,
      "masslock": 15,
      "crew": 2,
      "slots": {
        "hardpoint": [
          3,
          2,
          2
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          5,
          6,
          5,
          6,
          5,
          4,
          5
        ],
        "military": [],
        "internal": [
          6,
          5,
          5,
          5,
          4,
          3,
          2,
          2,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41550,
          42650,
          43550,
          44650,
          45550,
          46450,
          47530
        ],
        "military": [],
        "internal": [
          6650,
          6450,
          450,
          30550,
          350,
          0,
          0,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 43685900,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 87,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049330,
          "fdname": "Orca_Armour_Grade3",
          "eddbid": 800
        },
        "40114": {
          "mtype": "cbh",
          "cost": 103244340,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 87,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049331,
          "fdname": "Orca_Armour_Mirrored",
          "eddbid": 801
        },
        "40115": {
          "mtype": "cbh",
          "cost": 114408510,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 87,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049332,
          "fdname": "Orca_Armour_Reactive",
          "eddbid": 802
        },
        "40122": {
          "mtype": "cbh",
          "cost": 19415960,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 21,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049329,
          "fdname": "Orca_Armour_Grade2",
          "eddbid": 799
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049328,
          "fdname": "Orca_Armour_Grade1",
          "eddbid": 798
        }
      }
    },
    "belugaliner": {
      "fdid": 128049345,
      "fdname": "BelugaLiner",
      "eddbid": 30,
      "id": 52,
      "stype": "pa",
      "name": "Beluga Liner",
      "class": 3,
      "cost": 79686090,
      "retail": 84532760,
      "topspd": 200,
      "bstspd": 280,
      "mnv": 2,
      "shields": 280,
      "armour": 280,
      "mass": 950,
      "fwdacc": 20.01,
      "revacc": 17.12,
      "latacc": 15.03,
      "minthrust": 55,
      "boostcost": 19,
      "boostint": 6,
      "pitch": 25,
      "yaw": 17,
      "roll": 60,
      "pitchacc": 100,
      "yawacc": 50,
      "rollacc": 80,
      "minpitch": 20,
      "heatcap": 283,
      "heatdismin": 2.6,
      "heatdismax": 50.85,
      "fuelcost": 50,
      "fuelreserve": 0.81,
      "hardness": 60,
      "masslock": 18,
      "crew": 4,
      "slots": {
        "hardpoint": [
          2,
          2,
          2,
          2,
          2
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          6,
          7,
          7,
          8,
          6,
          5,
          7
        ],
        "military": [],
        "internal": [
          6,
          6,
          6,
          6,
          5,
          5,
          4,
          3,
          3,
          3,
          3,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          62160,
          62160,
          0,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41650,
          42750,
          43750,
          44850,
          45650,
          46550,
          47730
        ],
        "military": [],
        "internal": [
          30650,
          550,
          6640,
          6640,
          6440,
          6440,
          350,
          250,
          0,
          0,
          0,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 76079500,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 165,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049348,
          "fdname": "BelugaLiner_Armour_Grade3",
          "eddbid": 1556
        },
        "40114": {
          "mtype": "cbh",
          "cost": 179801200,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 165,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049349,
          "fdname": "BelugaLiner_Armour_Mirrored",
          "eddbid": 1557
        },
        "40115": {
          "mtype": "cbh",
          "cost": 199243730,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 165,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049350,
          "fdname": "BelugaLiner_Armour_Reactive",
          "eddbid": 1558
        },
        "40122": {
          "mtype": "cbh",
          "cost": 33813120,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 83,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049347,
          "fdname": "BelugaLiner_Armour_Grade2",
          "eddbid": 1555
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049346,
          "fdname": "BelugaLiner_Armour_Grade1",
          "eddbid": 1554
        }
      }
    },
    "dolphin": {
      "fdid": 128049291,
      "fdname": "Dolphin",
      "eddbid": 31,
      "id": 53,
      "stype": "pa",
      "name": "Dolphin",
      "class": 1,
      "cost": 1095780,
      "retail": 1337320,
      "topspd": 250,
      "bstspd": 350,
      "mnv": 3,
      "shields": 110,
      "armour": 110,
      "mass": 140,
      "fwdacc": 39.63,
      "revacc": 30.01,
      "latacc": 14.97,
      "minthrust": 48,
      "boostcost": 10,
      "boostint": 4,
      "pitch": 30,
      "yaw": 20,
      "roll": 100,
      "pitchacc": 220,
      "yawacc": 110,
      "rollacc": 240,
      "minpitch": 23,
      "heatcap": 245,
      "heatdismin": 1.91,
      "heatdismax": 56,
      "fuelcost": 50,
      "fuelreserve": 0.5,
      "hardness": 35,
      "masslock": 9,
      "crew": 1,
      "slots": {
        "hardpoint": [
          1,
          1
        ],
        "utility": [
          0,
          0,
          0
        ],
        "component": [
          1,
          4,
          5,
          4,
          4,
          3,
          3,
          4
        ],
        "military": [],
        "internal": [
          5,
          4,
          4,
          3,
          2,
          2,
          2,
          1,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          62160,
          62160
        ],
        "utility": [
          0,
          0,
          0
        ],
        "component": [
          40131,
          41450,
          42550,
          43450,
          44450,
          45350,
          46350,
          47430
        ],
        "military": [],
        "internal": [
          6550,
          350,
          30450,
          250,
          150,
          0,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 1203600,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 63,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049294,
          "fdname": "Dolphin_Armour_Grade3",
          "eddbid": 1591
        },
        "40114": {
          "mtype": "cbh",
          "cost": 2808390,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 63,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049295,
          "fdname": "Dolphin_Armour_Mirrored",
          "eddbid": 1592
        },
        "40115": {
          "mtype": "cbh",
          "cost": 3152080,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 63,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049296,
          "fdname": "Dolphin_Armour_Reactive",
          "eddbid": 1593
        },
        "40122": {
          "mtype": "cbh",
          "cost": 534940,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 32,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049293,
          "fdname": "Dolphin_Armour_Grade2",
          "eddbid": 1590
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049292,
          "fdname": "Dolphin_Armour_Grade1",
          "eddbid": 1589
        }
      }
    },
    "mediumtransport01": {
      "fdid": 129041442,
      "fdname": "MediumTransport01",
      "eddbid": null,
      "id": 54,
      "stype": "pa",
      "name": "Lynx Highliner",
      "class": 2,
      "cost": 67992080,
      "retail": 69289470,
      "topspd": 285,
      "bstspd": 350,
      "mnv": 3,
      "shields": 200,
      "armour": 350,
      "mass": 260,
      "fwdacc": null,
      "revacc": null,
      "latacc": null,
      "minthrust": 73.75,
      "boostcost": 14,
      "boostint": 5,
      "pitch": 26,
      "yaw": 19,
      "roll": 60,
      "pitchacc": null,
      "yawacc": null,
      "rollacc": null,
      "minpitch": 23,
      "heatcap": 279,
      "heatdismin": 1.67,
      "heatdismax": 49.35,
      "fuelcost": 50,
      "fuelreserve": 0.75,
      "hardness": 55,
      "masslock": 16,
      "crew": 2,
      "slots": {
        "hardpoint": [
          3,
          2,
          2,
          2,
          2
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          5,
          6,
          5,
          6,
          5,
          3,
          5
        ],
        "military": [],
        "internal": [
          6,
          6,
          6,
          5,
          5,
          4,
          4,
          3,
          2,
          1
        ]
      },
      "slotnames": {
        "internal": [
          "Slot01_Size6",
          "Passenger01",
          "Passenger02",
          "Passenger03",
          "Slot02_Size5",
          "Slot03_Size4",
          "Slot04_Size4",
          "Slot05_Size3",
          "Slot06_Size2",
          "Slot07_Size1"
        ]
      },
      "reserved": {
        "internal": [
          null,
          {
            "ipc": 1
          },
          {
            "ipc": 1
          },
          {
            "ipc": 1
          }
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          62160,
          62160,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41550,
          42650,
          43551,
          44650,
          45550,
          46350,
          47530
        ],
        "military": [],
        "internal": [
          30550,
          6550,
          6550,
          6450,
          6450,
          0,
          0,
          0,
          3152,
          3151
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 62360520,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 53,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129041446,
          "fdname": "MediumTransport01_Armour_Grade3",
          "eddbid": null
        },
        "40114": {
          "mtype": "cbh",
          "cost": 147378700,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 53,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 129041447,
          "fdname": "MediumTransport01_Armour_Mirrored",
          "eddbid": null
        },
        "40115": {
          "mtype": "cbh",
          "cost": 163315270,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 53,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 129041448,
          "fdname": "MediumTransport01_Armour_Reactive",
          "eddbid": null
        },
        "40122": {
          "mtype": "cbh",
          "cost": 27715790,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 26,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129041445,
          "fdname": "MediumTransport01_Armour_Grade2",
          "eddbid": null
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129041444,
          "fdname": "MediumTransport01_Armour_Grade1",
          "eddbid": null
        }
      }
    },
    "federation_corvette": {
      "fdid": 128049369,
      "fdname": "Federation_Corvette",
      "eddbid": 25,
      "id": 61,
      "stype": "sh",
      "name": "Federal Corvette",
      "class": 3,
      "cost": 183147460,
      "retail": 187969450,
      "faction": "Federation",
      "rank": 12,
      "topspd": 200,
      "bstspd": 260,
      "mnv": 2,
      "shields": 555,
      "armour": 370,
      "mass": 900,
      "fwdacc": 19.87,
      "revacc": 10.08,
      "latacc": 9.98,
      "minthrust": 50,
      "boostcost": 27,
      "boostint": 6,
      "pitch": 28,
      "yaw": 8,
      "roll": 75,
      "pitchacc": 100,
      "yawacc": 50,
      "rollacc": 80,
      "minpitch": 22,
      "heatcap": 333,
      "heatdismin": 3.28,
      "heatdismax": 70.33,
      "fuelcost": 50,
      "fuelreserve": 1.13,
      "hardness": 70,
      "masslock": 24,
      "crew": 4,
      "slots": {
        "hardpoint": [
          4,
          4,
          3,
          2,
          2,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          8,
          7,
          6,
          5,
          8,
          8,
          5
        ],
        "military": [
          5,
          5
        ],
        "internal": [
          7,
          7,
          7,
          6,
          6,
          5,
          5,
          4,
          4,
          3,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          0,
          62160,
          62160,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41850,
          42750,
          43650,
          44550,
          45850,
          46850,
          47530
        ],
        "military": [
          0,
          0
        ],
        "internal": [
          30750,
          650,
          0,
          0,
          0,
          0,
          0,
          350,
          0,
          250,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 169172510,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049372,
          "fdname": "Federation_Corvette_Armour_Grade3",
          "eddbid": 1500
        },
        "40114": {
          "mtype": "cbh",
          "cost": 399811020,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049373,
          "fdname": "Federation_Corvette_Armour_Mirrored",
          "eddbid": 1501
        },
        "40115": {
          "mtype": "cbh",
          "cost": 443044000,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049374,
          "fdname": "Federation_Corvette_Armour_Reactive",
          "eddbid": 1502
        },
        "40122": {
          "mtype": "cbh",
          "cost": 75187780,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 30,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049371,
          "fdname": "Federation_Corvette_Armour_Grade2",
          "eddbid": 1499
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049370,
          "fdname": "Federation_Corvette_Armour_Grade1",
          "eddbid": 1498
        }
      }
    },
    "cutter": {
      "fdid": 128049375,
      "fdname": "Cutter",
      "eddbid": 26,
      "id": 62,
      "stype": "sh",
      "name": "Imperial Cutter",
      "class": 3,
      "cost": 200484780,
      "retail": 208969450,
      "faction": "Empire",
      "rank": 12,
      "topspd": 200,
      "bstspd": 320,
      "mnv": 0,
      "shields": 600,
      "armour": 400,
      "mass": 1100,
      "fwdacc": 29.37,
      "revacc": 10.04,
      "latacc": 6.06,
      "minthrust": 80,
      "boostcost": 23,
      "boostint": 6,
      "pitch": 18,
      "yaw": 8,
      "roll": 45,
      "pitchacc": 100,
      "yawacc": 50,
      "rollacc": 80,
      "minpitch": 14,
      "heatcap": 327,
      "heatdismin": 3.27,
      "heatdismax": 72.58,
      "fuelcost": 50,
      "fuelreserve": 1.16,
      "hardness": 70,
      "masslock": 26,
      "crew": 4,
      "slots": {
        "hardpoint": [
          4,
          3,
          3,
          2,
          2,
          2,
          2
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          8,
          8,
          7,
          7,
          7,
          7,
          6
        ],
        "military": [
          5,
          5
        ],
        "internal": [
          8,
          8,
          6,
          6,
          6,
          5,
          5,
          4,
          3,
          1
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          0,
          62160,
          62160,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41850,
          42850,
          43750,
          44750,
          45750,
          46750,
          47630
        ],
        "military": [
          0,
          0
        ],
        "internal": [
          30850,
          750,
          550,
          0,
          0,
          0,
          0,
          0,
          250,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 188072510,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049378,
          "fdname": "Cutter_Armour_Grade3",
          "eddbid": 1495
        },
        "40114": {
          "mtype": "cbh",
          "cost": 444478020,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 128049379,
          "fdname": "Cutter_Armour_Mirrored",
          "eddbid": 1496
        },
        "40115": {
          "mtype": "cbh",
          "cost": 492541000,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 60,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 128049380,
          "fdname": "Cutter_Armour_Reactive",
          "eddbid": 1497
        },
        "40122": {
          "mtype": "cbh",
          "cost": 83587780,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 30,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049377,
          "fdname": "Cutter_Armour_Grade2",
          "eddbid": 1494
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 128049376,
          "fdname": "Cutter_Armour_Grade1",
          "eddbid": 1493
        }
      }
    },
    "panthermkii": {
      "fdid": 129034269,
      "fdname": "PantherMkII",
      "eddbid": null,
      "id": 63,
      "stype": "sh",
      "name": "Panther Clipper Mk II",
      "class": 3,
      "cost": 286906165,
      "retail": 301348585,
      "topspd": 180,
      "bstspd": 250,
      "mnv": 0,
      "shields": 350,
      "armour": 620,
      "mass": 1200,
      "fwdacc": null,
      "revacc": null,
      "latacc": null,
      "minthrust": 33.3,
      "boostcost": 19,
      "boostint": 6.5,
      "pitch": 18,
      "yaw": 10,
      "roll": 20,
      "pitchacc": null,
      "yawacc": null,
      "rollacc": null,
      "minpitch": 14,
      "heatcap": 329,
      "heatdismin": 3.21,
      "heatdismax": 62.5,
      "fuelcost": 50,
      "fuelreserve": 1.11,
      "hardness": 70,
      "masslock": 25,
      "crew": 4,
      "slots": {
        "hardpoint": [
          3,
          3,
          2,
          2,
          2,
          2,
          1,
          1,
          1,
          1
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          1,
          8,
          8,
          7,
          5,
          7,
          5,
          7
        ],
        "military": [],
        "internal": [
          8,
          8,
          7,
          7,
          6,
          6,
          6,
          5,
          5,
          4,
          2,
          1
        ]
      },
      "slotnames": {
        "internal": [
          "Cargo01",
          "Slot01_Size8",
          "Cargo02",
          "Slot02_Size7",
          "Slot03_Size6",
          "Slot04_Size6",
          "Slot05_Size6",
          "Slot06_Size5",
          "Slot07_Size5",
          "Slot08_Size4",
          "Slot09_Size2",
          "Slot10_Size1"
        ]
      },
      "reserved": {
        "internal": [
          {
            "cft": 1,
            "icr": 1
          },
          null,
          {
            "cft": 1,
            "icr": 1
          }
        ]
      },
      "stock": {
        "hardpoint": [
          0,
          0,
          62160,
          62160,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "utility": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "component": [
          40131,
          41850,
          42850,
          43751,
          44550,
          45750,
          46550,
          47730
        ],
        "military": [],
        "internal": [
          750,
          30750,
          0,
          0,
          0,
          550,
          550,
          0,
          0,
          0,
          3151,
          3152
        ]
      },
      "module": {
        "40113": {
          "mtype": "cbh",
          "cost": 271213730,
          "name": "Military Grade Composite",
          "class": 1,
          "rating": "A",
          "mass": 150,
          "hullbst": 250,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129034273,
          "fdname": "PantherMkII_Armour_Grade3",
          "eddbid": null
        },
        "40114": {
          "mtype": "cbh",
          "cost": 632832030,
          "name": "Mirrored Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 150,
          "hullbst": 250,
          "kinres": -75,
          "thmres": 50,
          "expres": -50,
          "axeres": 90,
          "fdid": 129034274,
          "fdname": "PantherMkII_Armour_Mirrored",
          "eddbid": null
        },
        "40115": {
          "mtype": "cbh",
          "cost": 710278610,
          "name": "Reactive Surface Composite",
          "class": 1,
          "rating": "A",
          "mass": 150,
          "hullbst": 250,
          "kinres": 25,
          "thmres": -40,
          "expres": 20,
          "axeres": 90,
          "fdid": 129034275,
          "fdname": "PantherMkII_Armour_Reactive",
          "eddbid": null
        },
        "40122": {
          "mtype": "cbh",
          "cost": 120539430,
          "name": "Reinforced Alloy",
          "class": 1,
          "rating": "B",
          "mass": 75,
          "hullbst": 152,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129034272,
          "fdname": "PantherMkII_Armour_Grade2",
          "eddbid": null
        },
        "40131": {
          "mtype": "cbh",
          "cost": 0,
          "name": "Lightweight Alloy",
          "class": 1,
          "rating": "C",
          "mass": 0,
          "hullbst": 80,
          "kinres": -20,
          "thmres": 0,
          "expres": -40,
          "axeres": 90,
          "fdid": 129034271,
          "fdname": "PantherMkII_Armour_Grade1",
          "eddbid": null
        }
      }
    }
  },
  "stockModules": {
    "150": {
      "fdname": "Int_CargoRack_Size1_Class1",
      "name": "Cargo Rack (Cap: 2)"
    },
    "151": {
      "fdname": "Int_CorrosionProofCargoRack_Size1_Class1",
      "name": "Anti-Corrosion Cargo Rack (Cap: 1)"
    },
    "161": {
      "fdname": "Int_CorrosionProofCargoRack_Size1_Class2",
      "name": "Anti-Corrosion Cargo Rack (Cap: 2)"
    },
    "250": {
      "fdname": "Int_CargoRack_Size2_Class1",
      "name": "Cargo Rack (Cap: 4)"
    },
    "251": {
      "fdname": "Int_CorrosionProofCargoRack_Size2_Class1",
      "name": "Anti-Corrosion Cargo Rack (Cap: 4)"
    },
    "350": {
      "fdname": "Int_CargoRack_Size3_Class1",
      "name": "Cargo Rack (Cap: 8)"
    },
    "450": {
      "fdname": "Int_CargoRack_Size4_Class1",
      "name": "Cargo Rack (Cap: 16)"
    },
    "451": {
      "fdname": "Int_CorrosionProofCargoRack_Size4_Class1",
      "name": "Anti-Corrosion Cargo Rack (Cap: 16)"
    },
    "550": {
      "fdname": "Int_CargoRack_Size5_Class1",
      "name": "Cargo Rack (Cap: 32)"
    },
    "551": {
      "fdname": "Int_CorrosionProofCargoRack_Size5_Class1",
      "name": "Anti-Corrosion Cargo Rack (Cap: 32)"
    },
    "640": {
      "fdname": "Int_LargeCargoRack_Size6_Class1",
      "name": "Mk II Cargo Rack (Cap: 96)"
    },
    "650": {
      "fdname": "Int_CargoRack_Size6_Class1",
      "name": "Cargo Rack (Cap: 64)"
    },
    "651": {
      "fdname": "Int_CorrosionProofCargoRack_Size6_Class1",
      "name": "Anti-Corrosion Cargo Rack (Cap: 64)"
    },
    "740": {
      "fdname": "Int_LargeCargoRack_Size7_Class1",
      "name": "Mk II Cargo Rack (Cap: 192)"
    },
    "750": {
      "fdname": "Int_CargoRack_Size7_Class1",
      "name": "Cargo Rack (Cap: 128)"
    },
    "840": {
      "fdname": "Int_LargeCargoRack_Size8_Class1",
      "name": "Mk II Cargo Rack (Cap: 384)"
    },
    "850": {
      "fdname": "Int_CargoRack_Size8_Class1",
      "name": "Cargo Rack (Cap: 256)"
    },
    "1110": {
      "fdname": "Int_Repairer_Size1_Class5",
      "name": "Auto Field-Maintenance Unit"
    },
    "1120": {
      "fdname": "Int_Repairer_Size1_Class4",
      "name": "Auto Field-Maintenance Unit"
    },
    "1130": {
      "fdname": "Int_Repairer_Size1_Class3",
      "name": "Auto Field-Maintenance Unit"
    },
    "1140": {
      "fdname": "Int_Repairer_Size1_Class2",
      "name": "Auto Field-Maintenance Unit"
    },
    "1150": {
      "fdname": "Int_Repairer_Size1_Class1",
      "name": "Auto Field-Maintenance Unit"
    },
    "1210": {
      "fdname": "Int_Repairer_Size2_Class5",
      "name": "Auto Field-Maintenance Unit"
    },
    "1220": {
      "fdname": "Int_Repairer_Size2_Class4",
      "name": "Auto Field-Maintenance Unit"
    },
    "1230": {
      "fdname": "Int_Repairer_Size2_Class3",
      "name": "Auto Field-Maintenance Unit"
    },
    "1240": {
      "fdname": "Int_Repairer_Size2_Class2",
      "name": "Auto Field-Maintenance Unit"
    },
    "1250": {
      "fdname": "Int_Repairer_Size2_Class1",
      "name": "Auto Field-Maintenance Unit"
    },
    "1310": {
      "fdname": "Int_Repairer_Size3_Class5",
      "name": "Auto Field-Maintenance Unit"
    },
    "1320": {
      "fdname": "Int_Repairer_Size3_Class4",
      "name": "Auto Field-Maintenance Unit"
    },
    "1330": {
      "fdname": "Int_Repairer_Size3_Class3",
      "name": "Auto Field-Maintenance Unit"
    },
    "1340": {
      "fdname": "Int_Repairer_Size3_Class2",
      "name": "Auto Field-Maintenance Unit"
    },
    "1350": {
      "fdname": "Int_Repairer_Size3_Class1",
      "name": "Auto Field-Maintenance Unit"
    },
    "1410": {
      "fdname": "Int_Repairer_Size4_Class5",
      "name": "Auto Field-Maintenance Unit"
    },
    "1420": {
      "fdname": "Int_Repairer_Size4_Class4",
      "name": "Auto Field-Maintenance Unit"
    },
    "1430": {
      "fdname": "Int_Repairer_Size4_Class3",
      "name": "Auto Field-Maintenance Unit"
    },
    "1440": {
      "fdname": "Int_Repairer_Size4_Class2",
      "name": "Auto Field-Maintenance Unit"
    },
    "1450": {
      "fdname": "Int_Repairer_Size4_Class1",
      "name": "Auto Field-Maintenance Unit"
    },
    "1510": {
      "fdname": "Int_Repairer_Size5_Class5",
      "name": "Auto Field-Maintenance Unit"
    },
    "1520": {
      "fdname": "Int_Repairer_Size5_Class4",
      "name": "Auto Field-Maintenance Unit"
    },
    "1530": {
      "fdname": "Int_Repairer_Size5_Class3",
      "name": "Auto Field-Maintenance Unit"
    },
    "1540": {
      "fdname": "Int_Repairer_Size5_Class2",
      "name": "Auto Field-Maintenance Unit"
    },
    "1550": {
      "fdname": "Int_Repairer_Size5_Class1",
      "name": "Auto Field-Maintenance Unit"
    },
    "1610": {
      "fdname": "Int_Repairer_Size6_Class5",
      "name": "Auto Field-Maintenance Unit"
    },
    "1620": {
      "fdname": "Int_Repairer_Size6_Class4",
      "name": "Auto Field-Maintenance Unit"
    },
    "1630": {
      "fdname": "Int_Repairer_Size6_Class3",
      "name": "Auto Field-Maintenance Unit"
    },
    "1640": {
      "fdname": "Int_Repairer_Size6_Class2",
      "name": "Auto Field-Maintenance Unit"
    },
    "1650": {
      "fdname": "Int_Repairer_Size6_Class1",
      "name": "Auto Field-Maintenance Unit"
    },
    "1710": {
      "fdname": "Int_Repairer_Size7_Class5",
      "name": "Auto Field-Maintenance Unit"
    },
    "1720": {
      "fdname": "Int_Repairer_Size7_Class4",
      "name": "Auto Field-Maintenance Unit"
    },
    "1730": {
      "fdname": "Int_Repairer_Size7_Class3",
      "name": "Auto Field-Maintenance Unit"
    },
    "1740": {
      "fdname": "Int_Repairer_Size7_Class2",
      "name": "Auto Field-Maintenance Unit"
    },
    "1750": {
      "fdname": "Int_Repairer_Size7_Class1",
      "name": "Auto Field-Maintenance Unit"
    },
    "1810": {
      "fdname": "Int_Repairer_Size8_Class5",
      "name": "Auto Field-Maintenance Unit"
    },
    "1820": {
      "fdname": "Int_Repairer_Size8_Class4",
      "name": "Auto Field-Maintenance Unit"
    },
    "1830": {
      "fdname": "Int_Repairer_Size8_Class3",
      "name": "Auto Field-Maintenance Unit"
    },
    "1840": {
      "fdname": "Int_Repairer_Size8_Class2",
      "name": "Auto Field-Maintenance Unit"
    },
    "1850": {
      "fdname": "Int_Repairer_Size8_Class1",
      "name": "Auto Field-Maintenance Unit"
    },
    "2110": {
      "fdname": "Int_Refinery_Size1_Class5",
      "name": "Refinery"
    },
    "2120": {
      "fdname": "Int_Refinery_Size1_Class4",
      "name": "Refinery"
    },
    "2130": {
      "fdname": "Int_Refinery_Size1_Class3",
      "name": "Refinery"
    },
    "2140": {
      "fdname": "Int_Refinery_Size1_Class2",
      "name": "Refinery"
    },
    "2150": {
      "fdname": "Int_Refinery_Size1_Class1",
      "name": "Refinery"
    },
    "2210": {
      "fdname": "Int_Refinery_Size2_Class5",
      "name": "Refinery"
    },
    "2220": {
      "fdname": "Int_Refinery_Size2_Class4",
      "name": "Refinery"
    },
    "2230": {
      "fdname": "Int_Refinery_Size2_Class3",
      "name": "Refinery"
    },
    "2240": {
      "fdname": "Int_Refinery_Size2_Class2",
      "name": "Refinery"
    },
    "2250": {
      "fdname": "Int_Refinery_Size2_Class1",
      "name": "Refinery"
    },
    "2310": {
      "fdname": "Int_Refinery_Size3_Class5",
      "name": "Refinery"
    },
    "2320": {
      "fdname": "Int_Refinery_Size3_Class4",
      "name": "Refinery"
    },
    "2330": {
      "fdname": "Int_Refinery_Size3_Class3",
      "name": "Refinery"
    },
    "2340": {
      "fdname": "Int_Refinery_Size3_Class2",
      "name": "Refinery"
    },
    "2350": {
      "fdname": "Int_Refinery_Size3_Class1",
      "name": "Refinery"
    },
    "2410": {
      "fdname": "Int_Refinery_Size4_Class5",
      "name": "Refinery"
    },
    "2420": {
      "fdname": "Int_Refinery_Size4_Class4",
      "name": "Refinery"
    },
    "2430": {
      "fdname": "Int_Refinery_Size4_Class3",
      "name": "Refinery"
    },
    "2440": {
      "fdname": "Int_Refinery_Size4_Class2",
      "name": "Refinery"
    },
    "2450": {
      "fdname": "Int_Refinery_Size4_Class1",
      "name": "Refinery"
    },
    "3150": {
      "fdname": "Int_DockingComputer_Standard",
      "name": "Standard Docking Computer"
    },
    "3151": {
      "fdname": "Int_DockingComputer_Advanced",
      "name": "Advanced Docking Computer"
    },
    "3152": {
      "fdname": "Int_SuperCruiseAssist",
      "name": "Supercruise Assist"
    },
    "4140": {
      "fdname": "Int_HullReinforcement_Size1_Class2",
      "name": "Hull Reinforcement Package"
    },
    "4141": {
      "fdname": "Int_GuardianHullReinforcement_Size1_Class2",
      "name": "Guardian Hull Reinforcement Package"
    },
    "4150": {
      "fdname": "Int_HullReinforcement_Size1_Class1",
      "name": "Hull Reinforcement Package"
    },
    "4151": {
      "fdname": "Int_GuardianHullReinforcement_Size1_Class1",
      "name": "Guardian Hull Reinforcement Package"
    },
    "4240": {
      "fdname": "Int_HullReinforcement_Size2_Class2",
      "name": "Hull Reinforcement Package"
    },
    "4241": {
      "fdname": "Int_GuardianHullReinforcement_Size2_Class2",
      "name": "Guardian Hull Reinforcement Package"
    },
    "4250": {
      "fdname": "Int_HullReinforcement_Size2_Class1",
      "name": "Hull Reinforcement Package"
    },
    "4251": {
      "fdname": "Int_GuardianHullReinforcement_Size2_Class1",
      "name": "Guardian Hull Reinforcement Package"
    },
    "4340": {
      "fdname": "Int_HullReinforcement_Size3_Class2",
      "name": "Hull Reinforcement Package"
    },
    "4341": {
      "fdname": "Int_GuardianHullReinforcement_Size3_Class2",
      "name": "Guardian Hull Reinforcement Package"
    },
    "4350": {
      "fdname": "Int_HullReinforcement_Size3_Class1",
      "name": "Hull Reinforcement Package"
    },
    "4351": {
      "fdname": "Int_GuardianHullReinforcement_Size3_Class1",
      "name": "Guardian Hull Reinforcement Package"
    },
    "4440": {
      "fdname": "Int_HullReinforcement_Size4_Class2",
      "name": "Hull Reinforcement Package"
    },
    "4441": {
      "fdname": "Int_GuardianHullReinforcement_Size4_Class2",
      "name": "Guardian Hull Reinforcement Package"
    },
    "4450": {
      "fdname": "Int_HullReinforcement_Size4_Class1",
      "name": "Hull Reinforcement Package"
    },
    "4451": {
      "fdname": "Int_GuardianHullReinforcement_Size4_Class1",
      "name": "Guardian Hull Reinforcement Package"
    },
    "4540": {
      "fdname": "Int_HullReinforcement_Size5_Class2",
      "name": "Hull Reinforcement Package"
    },
    "4541": {
      "fdname": "Int_GuardianHullReinforcement_Size5_Class2",
      "name": "Guardian Hull Reinforcement Package"
    },
    "4550": {
      "fdname": "Int_HullReinforcement_Size5_Class1",
      "name": "Hull Reinforcement Package"
    },
    "4551": {
      "fdname": "Int_GuardianHullReinforcement_Size5_Class1",
      "name": "Guardian Hull Reinforcement Package"
    },
    "5260": {
      "fdname": "Int_LargeBuggyBay_Size2_Class3",
      "name": "Large Planetary Vehicle Hangar"
    },
    "5261": {
      "fdname": "Int_MkIILargeBuggyBay_Size2_Class3",
      "name": "Mk II Large Planetary Vehicle Hangar"
    },
    "5262": {
      "fdname": "Int_LargeBuggyBay_Size2_Class3_Free",
      "name": "Large Planetary Vehicle Hangar"
    },
    "5263": {
      "fdname": "Int_MkIILargeBuggyBay_Size2_Class3_Free",
      "name": "Mk II Large Planetary Vehicle Hangar"
    },
    "5270": {
      "fdname": "Int_BuggyBay_Size2_Class2",
      "name": "Planetary Vehicle Hangar"
    },
    "5280": {
      "fdname": "Int_BuggyBay_Size2_Class1",
      "name": "Planetary Vehicle Hangar"
    },
    "5460": {
      "fdname": "Int_LargeBuggyBay_Size4_Class3",
      "name": "Large Planetary Vehicle Hangar"
    },
    "5461": {
      "fdname": "Int_MkIILargeBuggyBay_Size4_Class3",
      "name": "Mk II Large Planetary Vehicle Hangar"
    },
    "5462": {
      "fdname": "Int_LargeBuggyBay_Size4_Class3_Free",
      "name": "Large Planetary Vehicle Hangar"
    },
    "5463": {
      "fdname": "Int_MkIILargeBuggyBay_Size4_Class3_Free",
      "name": "Mk II Large Planetary Vehicle Hangar"
    },
    "5470": {
      "fdname": "Int_BuggyBay_Size4_Class2",
      "name": "Planetary Vehicle Hangar"
    },
    "5480": {
      "fdname": "Int_BuggyBay_Size4_Class1",
      "name": "Planetary Vehicle Hangar"
    },
    "5660": {
      "fdname": "Int_LargeBuggyBay_Size6_Class3",
      "name": "Large Planetary Vehicle Hangar"
    },
    "5661": {
      "fdname": "Int_MkIILargeBuggyBay_Size6_Class3",
      "name": "Mk II Large Planetary Vehicle Hangar"
    },
    "5662": {
      "fdname": "Int_LargeBuggyBay_Size6_Class3_Free",
      "name": "Large Planetary Vehicle Hangar"
    },
    "5663": {
      "fdname": "Int_MkIILargeBuggyBay_Size6_Class3_Free",
      "name": "Mk II Large Planetary Vehicle Hangar"
    },
    "5670": {
      "fdname": "Int_BuggyBay_Size6_Class2",
      "name": "Planetary Vehicle Hangar"
    },
    "5680": {
      "fdname": "Int_BuggyBay_Size6_Class1",
      "name": "Planetary Vehicle Hangar"
    },
    "6242": {
      "fdname": "Int_MkII_PassengerCabin_Size2_Class1",
      "name": "Mk II Economy Class Passenger Cabin"
    },
    "6250": {
      "fdname": "Int_PassengerCabin_Size2_Class1",
      "name": "Economy Class Passenger Cabin"
    },
    "6332": {
      "fdname": "Int_MkII_PassengerCabin_Size3_Class2",
      "name": "Mk II Business Class Passenger Cabin"
    },
    "6340": {
      "fdname": "Int_PassengerCabin_Size3_Class2",
      "name": "Business Class Passenger Cabin"
    },
    "6342": {
      "fdname": "Int_MkII_PassengerCabin_Size3_Class1",
      "name": "Mk II Economy Class Passenger Cabin"
    },
    "6350": {
      "fdname": "Int_PassengerCabin_Size3_Class1",
      "name": "Economy Class Passenger Cabin"
    },
    "6430": {
      "fdname": "Int_PassengerCabin_Size4_Class3",
      "name": "First Class Passenger Cabin"
    },
    "6432": {
      "fdname": "Int_MkII_PassengerCabin_Size4_Class2",
      "name": "Mk II Business Class Passenger Cabin"
    },
    "6440": {
      "fdname": "Int_PassengerCabin_Size4_Class2",
      "name": "Business Class Passenger Cabin"
    },
    "6442": {
      "fdname": "Int_MkII_PassengerCabin_Size4_Class1",
      "name": "Mk II Economy Class Passenger Cabin"
    },
    "6450": {
      "fdname": "Int_PassengerCabin_Size4_Class1",
      "name": "Economy Class Passenger Cabin"
    },
    "6520": {
      "fdname": "Int_PassengerCabin_Size5_Class4",
      "name": "Luxury Class Passenger Cabin"
    },
    "6530": {
      "fdname": "Int_PassengerCabin_Size5_Class3",
      "name": "First Class Passenger Cabin"
    },
    "6532": {
      "fdname": "Int_MkII_PassengerCabin_Size5_Class2",
      "name": "Mk II Business Class Passenger Cabin"
    },
    "6540": {
      "fdname": "Int_PassengerCabin_Size5_Class2",
      "name": "Business Class Passenger Cabin"
    },
    "6542": {
      "fdname": "Int_MkII_PassengerCabin_Size5_Class1",
      "name": "Mk II Economy Class Passenger Cabin"
    },
    "6550": {
      "fdname": "Int_PassengerCabin_Size5_Class1",
      "name": "Economy Class Passenger Cabin"
    },
    "6620": {
      "fdname": "Int_PassengerCabin_Size6_Class4",
      "name": "Luxury Class Passenger Cabin"
    },
    "6630": {
      "fdname": "Int_PassengerCabin_Size6_Class3",
      "name": "First Class Passenger Cabin"
    },
    "6632": {
      "fdname": "Int_MkII_PassengerCabin_Size6_Class2",
      "name": "Mk II Business Class Passenger Cabin"
    },
    "6640": {
      "fdname": "Int_PassengerCabin_Size6_Class2",
      "name": "Business Class Passenger Cabin"
    },
    "6642": {
      "fdname": "Int_MkII_PassengerCabin_Size6_Class1",
      "name": "Mk II Economy Class Passenger Cabin"
    },
    "6650": {
      "fdname": "Int_PassengerCabin_Size6_Class1",
      "name": "Economy Class Passenger Cabin"
    },
    "7540": {
      "fdname": "Int_FighterBay_Size5_Class1",
      "name": "Vessel Hangar"
    },
    "7541": {
      "fdname": "Int_FighterBay_Size5_Class1_Free",
      "name": "Vessel Hangar"
    },
    "7542": {
      "fdname": "Int_FighterBayMk2_Size5_Class1",
      "name": "Mk II Vessel Hangar"
    },
    "7543": {
      "fdname": "Int_FighterBayMk2_Size5_Class1_Free",
      "name": "Mk II Vessel Hangar"
    },
    "7640": {
      "fdname": "Int_FighterBay_Size6_Class1",
      "name": "Vessel Hangar"
    },
    "7641": {
      "fdname": "Int_FighterBay_Size6_Class1_Free",
      "name": "Vessel Hangar"
    },
    "7642": {
      "fdname": "Int_FighterBayMk2_Size6_Class1",
      "name": "Mk II Vessel Hangar"
    },
    "7643": {
      "fdname": "Int_FighterBayMk2_Size6_Class1_Free",
      "name": "Mk II Vessel Hangar"
    },
    "7740": {
      "fdname": "Int_FighterBay_Size7_Class1",
      "name": "Vessel Hangar"
    },
    "7741": {
      "fdname": "Int_FighterBay_Size7_Class1_Free",
      "name": "Vessel Hangar"
    },
    "7742": {
      "fdname": "Int_FighterBayMk2_Size7_Class1",
      "name": "Mk II Vessel Hangar"
    },
    "7743": {
      "fdname": "Int_FighterBayMk2_Size7_Class1_Free",
      "name": "Mk II Vessel Hangar"
    },
    "8140": {
      "fdname": "Int_ModuleReinforcement_Size1_Class2",
      "name": "Module Reinforcement Package"
    },
    "8141": {
      "fdname": "Int_GuardianModuleReinforcement_Size1_Class2",
      "name": "Guardian Module Reinforcement Package"
    },
    "8150": {
      "fdname": "Int_ModuleReinforcement_Size1_Class1",
      "name": "Module Reinforcement Package"
    },
    "8151": {
      "fdname": "Int_GuardianModuleReinforcement_Size1_Class1",
      "name": "Guardian Module Reinforcement Package"
    },
    "8240": {
      "fdname": "Int_ModuleReinforcement_Size2_Class2",
      "name": "Module Reinforcement Package"
    },
    "8241": {
      "fdname": "Int_GuardianModuleReinforcement_Size2_Class2",
      "name": "Guardian Module Reinforcement Package"
    },
    "8250": {
      "fdname": "Int_ModuleReinforcement_Size2_Class1",
      "name": "Module Reinforcement Package"
    },
    "8251": {
      "fdname": "Int_GuardianModuleReinforcement_Size2_Class1",
      "name": "Guardian Module Reinforcement Package"
    },
    "8340": {
      "fdname": "Int_ModuleReinforcement_Size3_Class2",
      "name": "Module Reinforcement Package"
    },
    "8341": {
      "fdname": "Int_GuardianModuleReinforcement_Size3_Class2",
      "name": "Guardian Module Reinforcement Package"
    },
    "8350": {
      "fdname": "Int_ModuleReinforcement_Size3_Class1",
      "name": "Module Reinforcement Package"
    },
    "8351": {
      "fdname": "Int_GuardianModuleReinforcement_Size3_Class1",
      "name": "Guardian Module Reinforcement Package"
    },
    "8440": {
      "fdname": "Int_ModuleReinforcement_Size4_Class2",
      "name": "Module Reinforcement Package"
    },
    "8441": {
      "fdname": "Int_GuardianModuleReinforcement_Size4_Class2",
      "name": "Guardian Module Reinforcement Package"
    },
    "8450": {
      "fdname": "Int_ModuleReinforcement_Size4_Class1",
      "name": "Module Reinforcement Package"
    },
    "8451": {
      "fdname": "Int_GuardianModuleReinforcement_Size4_Class1",
      "name": "Guardian Module Reinforcement Package"
    },
    "8540": {
      "fdname": "Int_ModuleReinforcement_Size5_Class2",
      "name": "Module Reinforcement Package"
    },
    "8541": {
      "fdname": "Int_GuardianModuleReinforcement_Size5_Class2",
      "name": "Guardian Module Reinforcement Package"
    },
    "8550": {
      "fdname": "Int_ModuleReinforcement_Size5_Class1",
      "name": "Module Reinforcement Package"
    },
    "8551": {
      "fdname": "Int_GuardianModuleReinforcement_Size5_Class1",
      "name": "Guardian Module Reinforcement Package"
    },
    "9141": {
      "fdname": "Int_MetaAlloyHullReinforcement_Size1_Class2",
      "name": "Meta Alloy Hull Reinforcement Package"
    },
    "9151": {
      "fdname": "Int_MetaAlloyHullReinforcement_Size1_Class1",
      "name": "Meta Alloy Hull Reinforcement Package"
    },
    "9241": {
      "fdname": "Int_MetaAlloyHullReinforcement_Size2_Class2",
      "name": "Meta Alloy Hull Reinforcement Package"
    },
    "9251": {
      "fdname": "Int_MetaAlloyHullReinforcement_Size2_Class1",
      "name": "Meta Alloy Hull Reinforcement Package"
    },
    "9341": {
      "fdname": "Int_MetaAlloyHullReinforcement_Size3_Class2",
      "name": "Meta Alloy Hull Reinforcement Package"
    },
    "9351": {
      "fdname": "Int_MetaAlloyHullReinforcement_Size3_Class1",
      "name": "Meta Alloy Hull Reinforcement Package"
    },
    "9441": {
      "fdname": "Int_MetaAlloyHullReinforcement_Size4_Class2",
      "name": "Meta Alloy Hull Reinforcement Package"
    },
    "9451": {
      "fdname": "Int_MetaAlloyHullReinforcement_Size4_Class1",
      "name": "Meta Alloy Hull Reinforcement Package"
    },
    "9541": {
      "fdname": "Int_MetaAlloyHullReinforcement_Size5_Class2",
      "name": "Meta Alloy Hull Reinforcement Package"
    },
    "9551": {
      "fdname": "Int_MetaAlloyHullReinforcement_Size5_Class1",
      "name": "Meta Alloy Hull Reinforcement Package"
    },
    "11130": {
      "fdname": "Int_DetailedSurfaceScanner_Tiny",
      "name": "Detailed Surface Scanner"
    },
    "12180": {
      "fdname": "Int_GuardianFSDBooster_Size1",
      "name": "Guardian Frame Shift Drive Booster"
    },
    "12280": {
      "fdname": "Int_GuardianFSDBooster_Size2",
      "name": "Guardian Frame Shift Drive Booster"
    },
    "12380": {
      "fdname": "Int_GuardianFSDBooster_Size3",
      "name": "Guardian Frame Shift Drive Booster"
    },
    "12480": {
      "fdname": "Int_GuardianFSDBooster_Size4",
      "name": "Guardian Frame Shift Drive Booster"
    },
    "12580": {
      "fdname": "Int_GuardianFSDBooster_Size5",
      "name": "Guardian Frame Shift Drive Booster"
    },
    "13360": {
      "fdname": "Int_ExpModuleStabiliser_Size3_Class3",
      "name": "Experimental Weapon Stabiliser"
    },
    "13560": {
      "fdname": "Int_ExpModuleStabiliser_Size5_Class3",
      "name": "Experimental Weapon Stabiliser"
    },
    "19322": {
      "fdname": "Int_MultiDroneControl_Operations_Size3_Class4",
      "name": "Operations Limpet Controller"
    },
    "19324": {
      "fdname": "Int_MultiDroneControl_Xeno_Size3_Class4",
      "name": "Xeno Limpet Controller"
    },
    "19331": {
      "fdname": "Int_MultiDroneControl_Mining_Size3_Class3",
      "name": "Mining Multi-Limpet Controller"
    },
    "19332": {
      "fdname": "Int_MultiDroneControl_Operations_Size3_Class3",
      "name": "Operations Limpet Controller"
    },
    "19333": {
      "fdname": "Int_MultiDroneControl_Rescue_Size3_Class3",
      "name": "Rescue Limpet Controller"
    },
    "19334": {
      "fdname": "Int_MultiDroneControl_Xeno_Size3_Class3",
      "name": "Xeno Limpet Controller"
    },
    "19343": {
      "fdname": "Int_MultiDroneControl_Rescue_Size3_Class2",
      "name": "Rescue Limpet Controller"
    },
    "19351": {
      "fdname": "Int_MultiDroneControl_Mining_Size3_Class1",
      "name": "Mining Multi-Limpet Controller"
    },
    "19511": {
      "fdname": "Int_MultiDroneControl_MiningV2_Size5_Class5",
      "name": "Mk II Mining Multi-Limpet Controller"
    },
    "19710": {
      "fdname": "Int_MultiDroneControl_Universal_Size7_Class5",
      "name": "Universal Multi-Limpet Controller"
    },
    "19730": {
      "fdname": "Int_MultiDroneControl_Universal_Size7_Class3",
      "name": "Universal Multi-Limpet Controller"
    },
    "20110": {
      "fdname": "Int_FuelScoop_Size1_Class5",
      "name": "Fuel Scoop"
    },
    "20120": {
      "fdname": "Int_FuelScoop_Size1_Class4",
      "name": "Fuel Scoop"
    },
    "20130": {
      "fdname": "Int_FuelScoop_Size1_Class3",
      "name": "Fuel Scoop"
    },
    "20140": {
      "fdname": "Int_FuelScoop_Size1_Class2",
      "name": "Fuel Scoop"
    },
    "20150": {
      "fdname": "Int_FuelScoop_Size1_Class1",
      "name": "Fuel Scoop"
    },
    "20210": {
      "fdname": "Int_FuelScoop_Size2_Class5",
      "name": "Fuel Scoop"
    },
    "20220": {
      "fdname": "Int_FuelScoop_Size2_Class4",
      "name": "Fuel Scoop"
    },
    "20230": {
      "fdname": "Int_FuelScoop_Size2_Class3",
      "name": "Fuel Scoop"
    },
    "20240": {
      "fdname": "Int_FuelScoop_Size2_Class2",
      "name": "Fuel Scoop"
    },
    "20250": {
      "fdname": "Int_FuelScoop_Size2_Class1",
      "name": "Fuel Scoop"
    },
    "20310": {
      "fdname": "Int_FuelScoop_Size3_Class5",
      "name": "Fuel Scoop"
    },
    "20320": {
      "fdname": "Int_FuelScoop_Size3_Class4",
      "name": "Fuel Scoop"
    },
    "20330": {
      "fdname": "Int_FuelScoop_Size3_Class3",
      "name": "Fuel Scoop"
    },
    "20340": {
      "fdname": "Int_FuelScoop_Size3_Class2",
      "name": "Fuel Scoop"
    },
    "20350": {
      "fdname": "Int_FuelScoop_Size3_Class1",
      "name": "Fuel Scoop"
    },
    "20410": {
      "fdname": "Int_FuelScoop_Size4_Class5",
      "name": "Fuel Scoop"
    },
    "20420": {
      "fdname": "Int_FuelScoop_Size4_Class4",
      "name": "Fuel Scoop"
    },
    "20430": {
      "fdname": "Int_FuelScoop_Size4_Class3",
      "name": "Fuel Scoop"
    },
    "20440": {
      "fdname": "Int_FuelScoop_Size4_Class2",
      "name": "Fuel Scoop"
    },
    "20450": {
      "fdname": "Int_FuelScoop_Size4_Class1",
      "name": "Fuel Scoop"
    },
    "20510": {
      "fdname": "Int_FuelScoop_Size5_Class5",
      "name": "Fuel Scoop"
    },
    "20520": {
      "fdname": "Int_FuelScoop_Size5_Class4",
      "name": "Fuel Scoop"
    },
    "20530": {
      "fdname": "Int_FuelScoop_Size5_Class3",
      "name": "Fuel Scoop"
    },
    "20540": {
      "fdname": "Int_FuelScoop_Size5_Class2",
      "name": "Fuel Scoop"
    },
    "20550": {
      "fdname": "Int_FuelScoop_Size5_Class1",
      "name": "Fuel Scoop"
    },
    "20610": {
      "fdname": "Int_FuelScoop_Size6_Class5",
      "name": "Fuel Scoop"
    },
    "20620": {
      "fdname": "Int_FuelScoop_Size6_Class4",
      "name": "Fuel Scoop"
    },
    "20630": {
      "fdname": "Int_FuelScoop_Size6_Class3",
      "name": "Fuel Scoop"
    },
    "20640": {
      "fdname": "Int_FuelScoop_Size6_Class2",
      "name": "Fuel Scoop"
    },
    "20650": {
      "fdname": "Int_FuelScoop_Size6_Class1",
      "name": "Fuel Scoop"
    },
    "20710": {
      "fdname": "Int_FuelScoop_Size7_Class5",
      "name": "Fuel Scoop"
    },
    "20720": {
      "fdname": "Int_FuelScoop_Size7_Class4",
      "name": "Fuel Scoop"
    },
    "20730": {
      "fdname": "Int_FuelScoop_Size7_Class3",
      "name": "Fuel Scoop"
    },
    "20740": {
      "fdname": "Int_FuelScoop_Size7_Class2",
      "name": "Fuel Scoop"
    },
    "20750": {
      "fdname": "Int_FuelScoop_Size7_Class1",
      "name": "Fuel Scoop"
    },
    "20810": {
      "fdname": "Int_FuelScoop_Size8_Class5",
      "name": "Fuel Scoop"
    },
    "20820": {
      "fdname": "Int_FuelScoop_Size8_Class4",
      "name": "Fuel Scoop"
    },
    "20830": {
      "fdname": "Int_FuelScoop_Size8_Class3",
      "name": "Fuel Scoop"
    },
    "20840": {
      "fdname": "Int_FuelScoop_Size8_Class2",
      "name": "Fuel Scoop"
    },
    "20850": {
      "fdname": "Int_FuelScoop_Size8_Class1",
      "name": "Fuel Scoop"
    },
    "21150": {
      "fdname": "Int_DroneControl_Recon_Size1_Class1",
      "name": "Recon Limpet Controller"
    },
    "21350": {
      "fdname": "Int_DroneControl_Recon_Size3_Class1",
      "name": "Recon Limpet Controller"
    },
    "21550": {
      "fdname": "Int_DroneControl_Recon_Size5_Class1",
      "name": "Recon Limpet Controller"
    },
    "21750": {
      "fdname": "Int_DroneControl_Recon_Size7_Class1",
      "name": "Recon Limpet Controller"
    },
    "22110": {
      "fdname": "Int_DroneControl_Collection_Size1_Class5",
      "name": "Collector Limpet Controller"
    },
    "22120": {
      "fdname": "Int_DroneControl_Collection_Size1_Class4",
      "name": "Collector Limpet Controller"
    },
    "22130": {
      "fdname": "Int_DroneControl_Collection_Size1_Class3",
      "name": "Collector Limpet Controller"
    },
    "22140": {
      "fdname": "Int_DroneControl_Collection_Size1_Class2",
      "name": "Collector Limpet Controller"
    },
    "22150": {
      "fdname": "Int_DroneControl_Collection_Size1_Class1",
      "name": "Collector Limpet Controller"
    },
    "22310": {
      "fdname": "Int_DroneControl_Collection_Size3_Class5",
      "name": "Collector Limpet Controller"
    },
    "22320": {
      "fdname": "Int_DroneControl_Collection_Size3_Class4",
      "name": "Collector Limpet Controller"
    },
    "22330": {
      "fdname": "Int_DroneControl_Collection_Size3_Class3",
      "name": "Collector Limpet Controller"
    },
    "22340": {
      "fdname": "Int_DroneControl_Collection_Size3_Class2",
      "name": "Collector Limpet Controller"
    },
    "22350": {
      "fdname": "Int_DroneControl_Collection_Size3_Class1",
      "name": "Collector Limpet Controller"
    },
    "22510": {
      "fdname": "Int_DroneControl_Collection_Size5_Class5",
      "name": "Collector Limpet Controller"
    },
    "22520": {
      "fdname": "Int_DroneControl_Collection_Size5_Class4",
      "name": "Collector Limpet Controller"
    },
    "22530": {
      "fdname": "Int_DroneControl_Collection_Size5_Class3",
      "name": "Collector Limpet Controller"
    },
    "22540": {
      "fdname": "Int_DroneControl_Collection_Size5_Class2",
      "name": "Collector Limpet Controller"
    },
    "22550": {
      "fdname": "Int_DroneControl_Collection_Size5_Class1",
      "name": "Collector Limpet Controller"
    },
    "22710": {
      "fdname": "Int_DroneControl_Collection_Size7_Class5",
      "name": "Collector Limpet Controller"
    },
    "22720": {
      "fdname": "Int_DroneControl_Collection_Size7_Class4",
      "name": "Collector Limpet Controller"
    },
    "22730": {
      "fdname": "Int_DroneControl_Collection_Size7_Class3",
      "name": "Collector Limpet Controller"
    },
    "22740": {
      "fdname": "Int_DroneControl_Collection_Size7_Class2",
      "name": "Collector Limpet Controller"
    },
    "22750": {
      "fdname": "Int_DroneControl_Collection_Size7_Class1",
      "name": "Collector Limpet Controller"
    },
    "23110": {
      "fdname": "Int_DroneControl_FuelTransfer_Size1_Class5",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23120": {
      "fdname": "Int_DroneControl_FuelTransfer_Size1_Class4",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23130": {
      "fdname": "Int_DroneControl_FuelTransfer_Size1_Class3",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23140": {
      "fdname": "Int_DroneControl_FuelTransfer_Size1_Class2",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23150": {
      "fdname": "Int_DroneControl_FuelTransfer_Size1_Class1",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23310": {
      "fdname": "Int_DroneControl_FuelTransfer_Size3_Class5",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23320": {
      "fdname": "Int_DroneControl_FuelTransfer_Size3_Class4",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23330": {
      "fdname": "Int_DroneControl_FuelTransfer_Size3_Class3",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23340": {
      "fdname": "Int_DroneControl_FuelTransfer_Size3_Class2",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23350": {
      "fdname": "Int_DroneControl_FuelTransfer_Size3_Class1",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23510": {
      "fdname": "Int_DroneControl_FuelTransfer_Size5_Class5",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23520": {
      "fdname": "Int_DroneControl_FuelTransfer_Size5_Class4",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23530": {
      "fdname": "Int_DroneControl_FuelTransfer_Size5_Class3",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23540": {
      "fdname": "Int_DroneControl_FuelTransfer_Size5_Class2",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23550": {
      "fdname": "Int_DroneControl_FuelTransfer_Size5_Class1",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23710": {
      "fdname": "Int_DroneControl_FuelTransfer_Size7_Class5",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23720": {
      "fdname": "Int_DroneControl_FuelTransfer_Size7_Class4",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23730": {
      "fdname": "Int_DroneControl_FuelTransfer_Size7_Class3",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23740": {
      "fdname": "Int_DroneControl_FuelTransfer_Size7_Class2",
      "name": "Fuel Transfer Limpet Controller"
    },
    "23750": {
      "fdname": "Int_DroneControl_FuelTransfer_Size7_Class1",
      "name": "Fuel Transfer Limpet Controller"
    },
    "24110": {
      "fdname": "Int_DroneControl_Prospector_Size1_Class5",
      "name": "Prospector Limpet Controller"
    },
    "24120": {
      "fdname": "Int_DroneControl_Prospector_Size1_Class4",
      "name": "Prospector Limpet Controller"
    },
    "24130": {
      "fdname": "Int_DroneControl_Prospector_Size1_Class3",
      "name": "Prospector Limpet Controller"
    },
    "24140": {
      "fdname": "Int_DroneControl_Prospector_Size1_Class2",
      "name": "Prospector Limpet Controller"
    },
    "24150": {
      "fdname": "Int_DroneControl_Prospector_Size1_Class1",
      "name": "Prospector Limpet Controller"
    },
    "24310": {
      "fdname": "Int_DroneControl_Prospector_Size3_Class5",
      "name": "Prospector Limpet Controller"
    },
    "24320": {
      "fdname": "Int_DroneControl_Prospector_Size3_Class4",
      "name": "Prospector Limpet Controller"
    },
    "24330": {
      "fdname": "Int_DroneControl_Prospector_Size3_Class3",
      "name": "Prospector Limpet Controller"
    },
    "24340": {
      "fdname": "Int_DroneControl_Prospector_Size3_Class2",
      "name": "Prospector Limpet Controller"
    },
    "24350": {
      "fdname": "Int_DroneControl_Prospector_Size3_Class1",
      "name": "Prospector Limpet Controller"
    },
    "24510": {
      "fdname": "Int_DroneControl_Prospector_Size5_Class5",
      "name": "Prospector Limpet Controller"
    },
    "24520": {
      "fdname": "Int_DroneControl_Prospector_Size5_Class4",
      "name": "Prospector Limpet Controller"
    },
    "24530": {
      "fdname": "Int_DroneControl_Prospector_Size5_Class3",
      "name": "Prospector Limpet Controller"
    },
    "24540": {
      "fdname": "Int_DroneControl_Prospector_Size5_Class2",
      "name": "Prospector Limpet Controller"
    },
    "24550": {
      "fdname": "Int_DroneControl_Prospector_Size5_Class1",
      "name": "Prospector Limpet Controller"
    },
    "24710": {
      "fdname": "Int_DroneControl_Prospector_Size7_Class5",
      "name": "Prospector Limpet Controller"
    },
    "24720": {
      "fdname": "Int_DroneControl_Prospector_Size7_Class4",
      "name": "Prospector Limpet Controller"
    },
    "24730": {
      "fdname": "Int_DroneControl_Prospector_Size7_Class3",
      "name": "Prospector Limpet Controller"
    },
    "24740": {
      "fdname": "Int_DroneControl_Prospector_Size7_Class2",
      "name": "Prospector Limpet Controller"
    },
    "24750": {
      "fdname": "Int_DroneControl_Prospector_Size7_Class1",
      "name": "Prospector Limpet Controller"
    },
    "25110": {
      "fdname": "Int_FSDInterdictor_Size1_Class5",
      "name": "Frame Shift Drive Interdictor"
    },
    "25120": {
      "fdname": "Int_FSDInterdictor_Size1_Class4",
      "name": "Frame Shift Drive Interdictor"
    },
    "25130": {
      "fdname": "Int_FSDInterdictor_Size1_Class3",
      "name": "Frame Shift Drive Interdictor"
    },
    "25140": {
      "fdname": "Int_FSDInterdictor_Size1_Class2",
      "name": "Frame Shift Drive Interdictor"
    },
    "25150": {
      "fdname": "Int_FSDInterdictor_Size1_Class1",
      "name": "Frame Shift Drive Interdictor"
    },
    "25210": {
      "fdname": "Int_FSDInterdictor_Size2_Class5",
      "name": "Frame Shift Drive Interdictor"
    },
    "25220": {
      "fdname": "Int_FSDInterdictor_Size2_Class4",
      "name": "Frame Shift Drive Interdictor"
    },
    "25230": {
      "fdname": "Int_FSDInterdictor_Size2_Class3",
      "name": "Frame Shift Drive Interdictor"
    },
    "25240": {
      "fdname": "Int_FSDInterdictor_Size2_Class2",
      "name": "Frame Shift Drive Interdictor"
    },
    "25250": {
      "fdname": "Int_FSDInterdictor_Size2_Class1",
      "name": "Frame Shift Drive Interdictor"
    },
    "25310": {
      "fdname": "Int_FSDInterdictor_Size3_Class5",
      "name": "Frame Shift Drive Interdictor"
    },
    "25320": {
      "fdname": "Int_FSDInterdictor_Size3_Class4",
      "name": "Frame Shift Drive Interdictor"
    },
    "25330": {
      "fdname": "Int_FSDInterdictor_Size3_Class3",
      "name": "Frame Shift Drive Interdictor"
    },
    "25340": {
      "fdname": "Int_FSDInterdictor_Size3_Class2",
      "name": "Frame Shift Drive Interdictor"
    },
    "25350": {
      "fdname": "Int_FSDInterdictor_Size3_Class1",
      "name": "Frame Shift Drive Interdictor"
    },
    "25410": {
      "fdname": "Int_FSDInterdictor_Size4_Class5",
      "name": "Frame Shift Drive Interdictor"
    },
    "25420": {
      "fdname": "Int_FSDInterdictor_Size4_Class4",
      "name": "Frame Shift Drive Interdictor"
    },
    "25430": {
      "fdname": "Int_FSDInterdictor_Size4_Class3",
      "name": "Frame Shift Drive Interdictor"
    },
    "25440": {
      "fdname": "Int_FSDInterdictor_Size4_Class2",
      "name": "Frame Shift Drive Interdictor"
    },
    "25450": {
      "fdname": "Int_FSDInterdictor_Size4_Class1",
      "name": "Frame Shift Drive Interdictor"
    },
    "26110": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size1_Class5",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26120": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size1_Class4",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26130": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size1_Class3",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26140": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size1_Class2",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26150": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size1_Class1",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26191": {
      "fdname": "Int_DroneControl_ResourceSiphon",
      "name": "Limpet Control"
    },
    "26310": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size3_Class5",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26320": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size3_Class4",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26330": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size3_Class3",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26340": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size3_Class2",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26350": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size3_Class1",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26510": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size5_Class5",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26520": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size5_Class4",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26530": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size5_Class3",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26540": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size5_Class2",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26550": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size5_Class1",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26710": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size7_Class5",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26720": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size7_Class4",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26730": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size7_Class3",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26740": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size7_Class2",
      "name": "Hatch Breaker Limpet Controller"
    },
    "26750": {
      "fdname": "Int_DroneControl_ResourceSiphon_Size7_Class1",
      "name": "Hatch Breaker Limpet Controller"
    },
    "27110": {
      "fdname": "Int_DroneControl_Repair_Size1_Class5",
      "name": "Repair Limpet Controller"
    },
    "27120": {
      "fdname": "Int_DroneControl_Repair_Size1_Class4",
      "name": "Repair Limpet Controller"
    },
    "27130": {
      "fdname": "Int_DroneControl_Repair_Size1_Class3",
      "name": "Repair Limpet Controller"
    },
    "27140": {
      "fdname": "Int_DroneControl_Repair_Size1_Class2",
      "name": "Repair Limpet Controller"
    },
    "27150": {
      "fdname": "Int_DroneControl_Repair_Size1_Class1",
      "name": "Repair Limpet Controller"
    },
    "27310": {
      "fdname": "Int_DroneControl_Repair_Size3_Class5",
      "name": "Repair Limpet Controller"
    },
    "27320": {
      "fdname": "Int_DroneControl_Repair_Size3_Class4",
      "name": "Repair Limpet Controller"
    },
    "27330": {
      "fdname": "Int_DroneControl_Repair_Size3_Class3",
      "name": "Repair Limpet Controller"
    },
    "27340": {
      "fdname": "Int_DroneControl_Repair_Size3_Class2",
      "name": "Repair Limpet Controller"
    },
    "27350": {
      "fdname": "Int_DroneControl_Repair_Size3_Class1",
      "name": "Repair Limpet Controller"
    },
    "27510": {
      "fdname": "Int_DroneControl_Repair_Size5_Class5",
      "name": "Repair Limpet Controller"
    },
    "27520": {
      "fdname": "Int_DroneControl_Repair_Size5_Class4",
      "name": "Repair Limpet Controller"
    },
    "27530": {
      "fdname": "Int_DroneControl_Repair_Size5_Class3",
      "name": "Repair Limpet Controller"
    },
    "27540": {
      "fdname": "Int_DroneControl_Repair_Size5_Class2",
      "name": "Repair Limpet Controller"
    },
    "27550": {
      "fdname": "Int_DroneControl_Repair_Size5_Class1",
      "name": "Repair Limpet Controller"
    },
    "27710": {
      "fdname": "Int_DroneControl_Repair_Size7_Class5",
      "name": "Repair Limpet Controller"
    },
    "27720": {
      "fdname": "Int_DroneControl_Repair_Size7_Class4",
      "name": "Repair Limpet Controller"
    },
    "27730": {
      "fdname": "Int_DroneControl_Repair_Size7_Class3",
      "name": "Repair Limpet Controller"
    },
    "27740": {
      "fdname": "Int_DroneControl_Repair_Size7_Class2",
      "name": "Repair Limpet Controller"
    },
    "27750": {
      "fdname": "Int_DroneControl_Repair_Size7_Class1",
      "name": "Repair Limpet Controller"
    },
    "28150": {
      "fdname": "Int_DroneControl_UnkVesselResearch",
      "name": "Research Limpet Controller"
    },
    "29150": {
      "fdname": "Int_DroneControl_Decontamination_Size1_Class1",
      "name": "Decontamination Limpet Controller"
    },
    "29350": {
      "fdname": "Int_DroneControl_Decontamination_Size3_Class1",
      "name": "Decontamination Limpet Controller"
    },
    "29550": {
      "fdname": "Int_DroneControl_Decontamination_Size5_Class1",
      "name": "Decontamination Limpet Controller"
    },
    "29750": {
      "fdname": "Int_DroneControl_Decontamination_Size7_Class1",
      "name": "Decontamination Limpet Controller"
    },
    "30110": {
      "fdname": "Int_ShieldGenerator_Size1_Class5",
      "name": "Shield Generator"
    },
    "30111": {
      "fdname": "Int_ShieldGenerator_Size1_Class5_Strong",
      "name": "Prismatic Shield Generator"
    },
    "30130": {
      "fdname": "Int_ShieldGenerator_Size1_Class3",
      "name": "Shield Generator"
    },
    "30132": {
      "fdname": "Int_ShieldGenerator_Size1_Class3_Fast",
      "name": "Bi-Weave Shield Generator"
    },
    "30140": {
      "fdname": "Int_ShieldGenerator_Size1_Class2",
      "name": "Shield Generator"
    },
    "30150": {
      "fdname": "Int_ShieldGenerator_Size1_Class1",
      "name": "Shield Generator"
    },
    "30210": {
      "fdname": "Int_ShieldGenerator_Size2_Class5",
      "name": "Shield Generator"
    },
    "30211": {
      "fdname": "Int_ShieldGenerator_Size2_Class5_Strong",
      "name": "Prismatic Shield Generator"
    },
    "30220": {
      "fdname": "Int_ShieldGenerator_Size2_Class4",
      "name": "Shield Generator"
    },
    "30230": {
      "fdname": "Int_ShieldGenerator_Size2_Class3",
      "name": "Shield Generator"
    },
    "30232": {
      "fdname": "Int_ShieldGenerator_Size2_Class3_Fast",
      "name": "Bi-Weave Shield Generator"
    },
    "30240": {
      "fdname": "Int_ShieldGenerator_Size2_Class2",
      "name": "Shield Generator"
    },
    "30250": {
      "fdname": "Int_ShieldGenerator_Size2_Class1",
      "name": "Shield Generator"
    },
    "30310": {
      "fdname": "Int_ShieldGenerator_Size3_Class5",
      "name": "Shield Generator"
    },
    "30311": {
      "fdname": "Int_ShieldGenerator_Size3_Class5_Strong",
      "name": "Prismatic Shield Generator"
    },
    "30320": {
      "fdname": "Int_ShieldGenerator_Size3_Class4",
      "name": "Shield Generator"
    },
    "30330": {
      "fdname": "Int_ShieldGenerator_Size3_Class3",
      "name": "Shield Generator"
    },
    "30332": {
      "fdname": "Int_ShieldGenerator_Size3_Class3_Fast",
      "name": "Bi-Weave Shield Generator"
    },
    "30340": {
      "fdname": "Int_ShieldGenerator_Size3_Class2",
      "name": "Shield Generator"
    },
    "30350": {
      "fdname": "Int_ShieldGenerator_Size3_Class1",
      "name": "Shield Generator"
    },
    "30410": {
      "fdname": "Int_ShieldGenerator_Size4_Class5",
      "name": "Shield Generator"
    },
    "30411": {
      "fdname": "Int_ShieldGenerator_Size4_Class5_Strong",
      "name": "Prismatic Shield Generator"
    },
    "30420": {
      "fdname": "Int_ShieldGenerator_Size4_Class4",
      "name": "Shield Generator"
    },
    "30430": {
      "fdname": "Int_ShieldGenerator_Size4_Class3",
      "name": "Shield Generator"
    },
    "30432": {
      "fdname": "Int_ShieldGenerator_Size4_Class3_Fast",
      "name": "Bi-Weave Shield Generator"
    },
    "30440": {
      "fdname": "Int_ShieldGenerator_Size4_Class2",
      "name": "Shield Generator"
    },
    "30450": {
      "fdname": "Int_ShieldGenerator_Size4_Class1",
      "name": "Shield Generator"
    },
    "30510": {
      "fdname": "Int_ShieldGenerator_Size5_Class5",
      "name": "Shield Generator"
    },
    "30511": {
      "fdname": "Int_ShieldGenerator_Size5_Class5_Strong",
      "name": "Prismatic Shield Generator"
    },
    "30520": {
      "fdname": "Int_ShieldGenerator_Size5_Class4",
      "name": "Shield Generator"
    },
    "30530": {
      "fdname": "Int_ShieldGenerator_Size5_Class3",
      "name": "Shield Generator"
    },
    "30532": {
      "fdname": "Int_ShieldGenerator_Size5_Class3_Fast",
      "name": "Bi-Weave Shield Generator"
    },
    "30540": {
      "fdname": "Int_ShieldGenerator_Size5_Class2",
      "name": "Shield Generator"
    },
    "30550": {
      "fdname": "Int_ShieldGenerator_Size5_Class1",
      "name": "Shield Generator"
    },
    "30610": {
      "fdname": "Int_ShieldGenerator_Size6_Class5",
      "name": "Shield Generator"
    },
    "30611": {
      "fdname": "Int_ShieldGenerator_Size6_Class5_Strong",
      "name": "Prismatic Shield Generator"
    },
    "30620": {
      "fdname": "Int_ShieldGenerator_Size6_Class4",
      "name": "Shield Generator"
    },
    "30630": {
      "fdname": "Int_ShieldGenerator_Size6_Class3",
      "name": "Shield Generator"
    },
    "30632": {
      "fdname": "Int_ShieldGenerator_Size6_Class3_Fast",
      "name": "Bi-Weave Shield Generator"
    },
    "30640": {
      "fdname": "Int_ShieldGenerator_Size6_Class2",
      "name": "Shield Generator"
    },
    "30650": {
      "fdname": "Int_ShieldGenerator_Size6_Class1",
      "name": "Shield Generator"
    },
    "30710": {
      "fdname": "Int_ShieldGenerator_Size7_Class5",
      "name": "Shield Generator"
    },
    "30711": {
      "fdname": "Int_ShieldGenerator_Size7_Class5_Strong",
      "name": "Prismatic Shield Generator"
    },
    "30720": {
      "fdname": "Int_ShieldGenerator_Size7_Class4",
      "name": "Shield Generator"
    },
    "30730": {
      "fdname": "Int_ShieldGenerator_Size7_Class3",
      "name": "Shield Generator"
    },
    "30732": {
      "fdname": "Int_ShieldGenerator_Size7_Class3_Fast",
      "name": "Bi-Weave Shield Generator"
    },
    "30740": {
      "fdname": "Int_ShieldGenerator_Size7_Class2",
      "name": "Shield Generator"
    },
    "30750": {
      "fdname": "Int_ShieldGenerator_Size7_Class1",
      "name": "Shield Generator"
    },
    "30810": {
      "fdname": "Int_ShieldGenerator_Size8_Class5",
      "name": "Shield Generator"
    },
    "30811": {
      "fdname": "Int_ShieldGenerator_Size8_Class5_Strong",
      "name": "Prismatic Shield Generator"
    },
    "30820": {
      "fdname": "Int_ShieldGenerator_Size8_Class4",
      "name": "Shield Generator"
    },
    "30830": {
      "fdname": "Int_ShieldGenerator_Size8_Class3",
      "name": "Shield Generator"
    },
    "30832": {
      "fdname": "Int_ShieldGenerator_Size8_Class3_Fast",
      "name": "Bi-Weave Shield Generator"
    },
    "30840": {
      "fdname": "Int_ShieldGenerator_Size8_Class2",
      "name": "Shield Generator"
    },
    "30850": {
      "fdname": "Int_ShieldGenerator_Size8_Class1",
      "name": "Shield Generator"
    },
    "31110": {
      "fdname": "Int_ShieldCellBank_Size1_Class5",
      "name": "Shield Cell Bank"
    },
    "31120": {
      "fdname": "Int_ShieldCellBank_Size1_Class4",
      "name": "Shield Cell Bank"
    },
    "31130": {
      "fdname": "Int_ShieldCellBank_Size1_Class3",
      "name": "Shield Cell Bank"
    },
    "31140": {
      "fdname": "Int_ShieldCellBank_Size1_Class2",
      "name": "Shield Cell Bank"
    },
    "31150": {
      "fdname": "Int_ShieldCellBank_Size1_Class1",
      "name": "Shield Cell Bank"
    },
    "31210": {
      "fdname": "Int_ShieldCellBank_Size2_Class5",
      "name": "Shield Cell Bank"
    },
    "31220": {
      "fdname": "Int_ShieldCellBank_Size2_Class4",
      "name": "Shield Cell Bank"
    },
    "31230": {
      "fdname": "Int_ShieldCellBank_Size2_Class3",
      "name": "Shield Cell Bank"
    },
    "31240": {
      "fdname": "Int_ShieldCellBank_Size2_Class2",
      "name": "Shield Cell Bank"
    },
    "31250": {
      "fdname": "Int_ShieldCellBank_Size2_Class1",
      "name": "Shield Cell Bank"
    },
    "31310": {
      "fdname": "Int_ShieldCellBank_Size3_Class5",
      "name": "Shield Cell Bank"
    },
    "31320": {
      "fdname": "Int_ShieldCellBank_Size3_Class4",
      "name": "Shield Cell Bank"
    },
    "31330": {
      "fdname": "Int_ShieldCellBank_Size3_Class3",
      "name": "Shield Cell Bank"
    },
    "31340": {
      "fdname": "Int_ShieldCellBank_Size3_Class2",
      "name": "Shield Cell Bank"
    },
    "31350": {
      "fdname": "Int_ShieldCellBank_Size3_Class1",
      "name": "Shield Cell Bank"
    },
    "31410": {
      "fdname": "Int_ShieldCellBank_Size4_Class5",
      "name": "Shield Cell Bank"
    },
    "31420": {
      "fdname": "Int_ShieldCellBank_Size4_Class4",
      "name": "Shield Cell Bank"
    },
    "31430": {
      "fdname": "Int_ShieldCellBank_Size4_Class3",
      "name": "Shield Cell Bank"
    },
    "31440": {
      "fdname": "Int_ShieldCellBank_Size4_Class2",
      "name": "Shield Cell Bank"
    },
    "31450": {
      "fdname": "Int_ShieldCellBank_Size4_Class1",
      "name": "Shield Cell Bank"
    },
    "31510": {
      "fdname": "Int_ShieldCellBank_Size5_Class5",
      "name": "Shield Cell Bank"
    },
    "31520": {
      "fdname": "Int_ShieldCellBank_Size5_Class4",
      "name": "Shield Cell Bank"
    },
    "31530": {
      "fdname": "Int_ShieldCellBank_Size5_Class3",
      "name": "Shield Cell Bank"
    },
    "31540": {
      "fdname": "Int_ShieldCellBank_Size5_Class2",
      "name": "Shield Cell Bank"
    },
    "31550": {
      "fdname": "Int_ShieldCellBank_Size5_Class1",
      "name": "Shield Cell Bank"
    },
    "31610": {
      "fdname": "Int_ShieldCellBank_Size6_Class5",
      "name": "Shield Cell Bank"
    },
    "31620": {
      "fdname": "Int_ShieldCellBank_Size6_Class4",
      "name": "Shield Cell Bank"
    },
    "31630": {
      "fdname": "Int_ShieldCellBank_Size6_Class3",
      "name": "Shield Cell Bank"
    },
    "31640": {
      "fdname": "Int_ShieldCellBank_Size6_Class2",
      "name": "Shield Cell Bank"
    },
    "31650": {
      "fdname": "Int_ShieldCellBank_Size6_Class1",
      "name": "Shield Cell Bank"
    },
    "31710": {
      "fdname": "Int_ShieldCellBank_Size7_Class5",
      "name": "Shield Cell Bank"
    },
    "31720": {
      "fdname": "Int_ShieldCellBank_Size7_Class4",
      "name": "Shield Cell Bank"
    },
    "31730": {
      "fdname": "Int_ShieldCellBank_Size7_Class3",
      "name": "Shield Cell Bank"
    },
    "31740": {
      "fdname": "Int_ShieldCellBank_Size7_Class2",
      "name": "Shield Cell Bank"
    },
    "31750": {
      "fdname": "Int_ShieldCellBank_Size7_Class1",
      "name": "Shield Cell Bank"
    },
    "31810": {
      "fdname": "Int_ShieldCellBank_Size8_Class5",
      "name": "Shield Cell Bank"
    },
    "31820": {
      "fdname": "Int_ShieldCellBank_Size8_Class4",
      "name": "Shield Cell Bank"
    },
    "31830": {
      "fdname": "Int_ShieldCellBank_Size8_Class3",
      "name": "Shield Cell Bank"
    },
    "31840": {
      "fdname": "Int_ShieldCellBank_Size8_Class2",
      "name": "Shield Cell Bank"
    },
    "31850": {
      "fdname": "Int_ShieldCellBank_Size8_Class1",
      "name": "Shield Cell Bank"
    },
    "32141": {
      "fdname": "Int_GuardianShieldReinforcement_Size1_Class2",
      "name": "Guardian Shield Reinforcement Package"
    },
    "32151": {
      "fdname": "Int_GuardianShieldReinforcement_Size1_Class1",
      "name": "Guardian Shield Reinforcement Package"
    },
    "32241": {
      "fdname": "Int_GuardianShieldReinforcement_Size2_Class2",
      "name": "Guardian Shield Reinforcement Package"
    },
    "32251": {
      "fdname": "Int_GuardianShieldReinforcement_Size2_Class1",
      "name": "Guardian Shield Reinforcement Package"
    },
    "32341": {
      "fdname": "Int_GuardianShieldReinforcement_Size3_Class2",
      "name": "Guardian Shield Reinforcement Package"
    },
    "32351": {
      "fdname": "Int_GuardianShieldReinforcement_Size3_Class1",
      "name": "Guardian Shield Reinforcement Package"
    },
    "32441": {
      "fdname": "Int_GuardianShieldReinforcement_Size4_Class2",
      "name": "Guardian Shield Reinforcement Package"
    },
    "32451": {
      "fdname": "Int_GuardianShieldReinforcement_Size4_Class1",
      "name": "Guardian Shield Reinforcement Package"
    },
    "32541": {
      "fdname": "Int_GuardianShieldReinforcement_Size5_Class2",
      "name": "Guardian Shield Reinforcement Package"
    },
    "32551": {
      "fdname": "Int_GuardianShieldReinforcement_Size5_Class1",
      "name": "Guardian Shield Reinforcement Package"
    },
    "40110": {
      "fdname": null,
      "name": "Mk II Ablative Reactive Surface Composite"
    },
    "40113": {
      "fdname": null,
      "name": "Military Grade Composite"
    },
    "40114": {
      "fdname": null,
      "name": "Mirrored Surface Composite"
    },
    "40115": {
      "fdname": null,
      "name": "Reactive Surface Composite"
    },
    "40118": {
      "fdname": null,
      "name": "Mk II Ablative Military Grade Composite"
    },
    "40119": {
      "fdname": null,
      "name": "Mk II Ablative Mirrored Surface Composite"
    },
    "40122": {
      "fdname": null,
      "name": "Reinforced Alloy"
    },
    "40127": {
      "fdname": null,
      "name": "Mk II Ablative Reinforced Alloy"
    },
    "40131": {
      "fdname": null,
      "name": "Lightweight Alloy"
    },
    "40136": {
      "fdname": null,
      "name": "Mk II Ablative Lightweight Alloy"
    },
    "41210": {
      "fdname": "Int_Powerplant_Size2_Class5",
      "name": "Power Plant"
    },
    "41211": {
      "fdname": "Int_GuardianPowerplant_Size2",
      "name": "Guardian Hybrid Power Plant"
    },
    "41220": {
      "fdname": "Int_Powerplant_Size2_Class4",
      "name": "Power Plant"
    },
    "41230": {
      "fdname": "Int_Powerplant_Size2_Class3",
      "name": "Power Plant"
    },
    "41240": {
      "fdname": "Int_Powerplant_Size2_Class2",
      "name": "Power Plant"
    },
    "41250": {
      "fdname": "Int_Powerplant_Size2_Class1",
      "name": "Power Plant"
    },
    "41310": {
      "fdname": "Int_Powerplant_Size3_Class5",
      "name": "Power Plant"
    },
    "41311": {
      "fdname": "Int_GuardianPowerplant_Size3",
      "name": "Guardian Hybrid Power Plant"
    },
    "41320": {
      "fdname": "Int_Powerplant_Size3_Class4",
      "name": "Power Plant"
    },
    "41330": {
      "fdname": "Int_Powerplant_Size3_Class3",
      "name": "Power Plant"
    },
    "41340": {
      "fdname": "Int_Powerplant_Size3_Class2",
      "name": "Power Plant"
    },
    "41350": {
      "fdname": "Int_Powerplant_Size3_Class1",
      "name": "Power Plant"
    },
    "41410": {
      "fdname": "Int_Powerplant_Size4_Class5",
      "name": "Power Plant"
    },
    "41411": {
      "fdname": "Int_GuardianPowerplant_Size4",
      "name": "Guardian Hybrid Power Plant"
    },
    "41420": {
      "fdname": "Int_Powerplant_Size4_Class4",
      "name": "Power Plant"
    },
    "41430": {
      "fdname": "Int_Powerplant_Size4_Class3",
      "name": "Power Plant"
    },
    "41440": {
      "fdname": "Int_Powerplant_Size4_Class2",
      "name": "Power Plant"
    },
    "41450": {
      "fdname": "Int_Powerplant_Size4_Class1",
      "name": "Power Plant"
    },
    "41510": {
      "fdname": "Int_Powerplant_Size5_Class5",
      "name": "Power Plant"
    },
    "41511": {
      "fdname": "Int_GuardianPowerplant_Size5",
      "name": "Guardian Hybrid Power Plant"
    },
    "41520": {
      "fdname": "Int_Powerplant_Size5_Class4",
      "name": "Power Plant"
    },
    "41530": {
      "fdname": "Int_Powerplant_Size5_Class3",
      "name": "Power Plant"
    },
    "41540": {
      "fdname": "Int_Powerplant_Size5_Class2",
      "name": "Power Plant"
    },
    "41550": {
      "fdname": "Int_Powerplant_Size5_Class1",
      "name": "Power Plant"
    },
    "41610": {
      "fdname": "Int_Powerplant_Size6_Class5",
      "name": "Power Plant"
    },
    "41611": {
      "fdname": "Int_GuardianPowerplant_Size6",
      "name": "Guardian Hybrid Power Plant"
    },
    "41620": {
      "fdname": "Int_Powerplant_Size6_Class4",
      "name": "Power Plant"
    },
    "41630": {
      "fdname": "Int_Powerplant_Size6_Class3",
      "name": "Power Plant"
    },
    "41640": {
      "fdname": "Int_Powerplant_Size6_Class2",
      "name": "Power Plant"
    },
    "41650": {
      "fdname": "Int_Powerplant_Size6_Class1",
      "name": "Power Plant"
    },
    "41710": {
      "fdname": "Int_Powerplant_Size7_Class5",
      "name": "Power Plant"
    },
    "41711": {
      "fdname": "Int_GuardianPowerplant_Size7",
      "name": "Guardian Hybrid Power Plant"
    },
    "41720": {
      "fdname": "Int_Powerplant_Size7_Class4",
      "name": "Power Plant"
    },
    "41730": {
      "fdname": "Int_Powerplant_Size7_Class3",
      "name": "Power Plant"
    },
    "41740": {
      "fdname": "Int_Powerplant_Size7_Class2",
      "name": "Power Plant"
    },
    "41750": {
      "fdname": "Int_Powerplant_Size7_Class1",
      "name": "Power Plant"
    },
    "41810": {
      "fdname": "Int_Powerplant_Size8_Class5",
      "name": "Power Plant"
    },
    "41811": {
      "fdname": "Int_GuardianPowerplant_Size8",
      "name": "Guardian Hybrid Power Plant"
    },
    "41820": {
      "fdname": "Int_Powerplant_Size8_Class4",
      "name": "Power Plant"
    },
    "41830": {
      "fdname": "Int_Powerplant_Size8_Class3",
      "name": "Power Plant"
    },
    "41840": {
      "fdname": "Int_Powerplant_Size8_Class2",
      "name": "Power Plant"
    },
    "41850": {
      "fdname": "Int_Powerplant_Size8_Class1",
      "name": "Power Plant"
    },
    "42210": {
      "fdname": "Int_Engine_Size2_Class5",
      "name": "Thrusters"
    },
    "42211": {
      "fdname": "Int_Engine_Size2_Class5_Fast",
      "name": "Enhanced Performance Thrusters"
    },
    "42220": {
      "fdname": "Int_Engine_Size2_Class4",
      "name": "Thrusters"
    },
    "42230": {
      "fdname": "Int_Engine_Size2_Class3",
      "name": "Thrusters"
    },
    "42240": {
      "fdname": "Int_Engine_Size2_Class2",
      "name": "Thrusters"
    },
    "42250": {
      "fdname": "Int_Engine_Size2_Class1",
      "name": "Thrusters"
    },
    "42310": {
      "fdname": "Int_Engine_Size3_Class5",
      "name": "Thrusters"
    },
    "42311": {
      "fdname": "Int_Engine_Size3_Class5_Fast",
      "name": "Enhanced Performance Thrusters"
    },
    "42320": {
      "fdname": "Int_Engine_Size3_Class4",
      "name": "Thrusters"
    },
    "42330": {
      "fdname": "Int_Engine_Size3_Class3",
      "name": "Thrusters"
    },
    "42340": {
      "fdname": "Int_Engine_Size3_Class2",
      "name": "Thrusters"
    },
    "42350": {
      "fdname": "Int_Engine_Size3_Class1",
      "name": "Thrusters"
    },
    "42410": {
      "fdname": "Int_Engine_Size4_Class5",
      "name": "Thrusters"
    },
    "42420": {
      "fdname": "Int_Engine_Size4_Class4",
      "name": "Thrusters"
    },
    "42430": {
      "fdname": "Int_Engine_Size4_Class3",
      "name": "Thrusters"
    },
    "42440": {
      "fdname": "Int_Engine_Size4_Class2",
      "name": "Thrusters"
    },
    "42450": {
      "fdname": "Int_Engine_Size4_Class1",
      "name": "Thrusters"
    },
    "42510": {
      "fdname": "Int_Engine_Size5_Class5",
      "name": "Thrusters"
    },
    "42513": {
      "fdname": "Int_MkIIAgileBoost_Engine_Size5_Class5",
      "name": "Mk II Agile Boost Thrusters"
    },
    "42520": {
      "fdname": "Int_Engine_Size5_Class4",
      "name": "Thrusters"
    },
    "42530": {
      "fdname": "Int_Engine_Size5_Class3",
      "name": "Thrusters"
    },
    "42540": {
      "fdname": "Int_Engine_Size5_Class2",
      "name": "Thrusters"
    },
    "42550": {
      "fdname": "Int_Engine_Size5_Class1",
      "name": "Thrusters"
    },
    "42610": {
      "fdname": "Int_Engine_Size6_Class5",
      "name": "Thrusters"
    },
    "42620": {
      "fdname": "Int_Engine_Size6_Class4",
      "name": "Thrusters"
    },
    "42630": {
      "fdname": "Int_Engine_Size6_Class3",
      "name": "Thrusters"
    },
    "42640": {
      "fdname": "Int_Engine_Size6_Class2",
      "name": "Thrusters"
    },
    "42650": {
      "fdname": "Int_Engine_Size6_Class1",
      "name": "Thrusters"
    },
    "42710": {
      "fdname": "Int_Engine_Size7_Class5",
      "name": "Thrusters"
    },
    "42712": {
      "fdname": "Int_Engine_Size7_Class5_GravityOptimised_MkII",
      "name": "Mk II Gravity Optimised Thrusters"
    },
    "42720": {
      "fdname": "Int_Engine_Size7_Class4",
      "name": "Thrusters"
    },
    "42730": {
      "fdname": "Int_Engine_Size7_Class3",
      "name": "Thrusters"
    },
    "42740": {
      "fdname": "Int_Engine_Size7_Class2",
      "name": "Thrusters"
    },
    "42750": {
      "fdname": "Int_Engine_Size7_Class1",
      "name": "Thrusters"
    },
    "42810": {
      "fdname": "Int_Engine_Size8_Class5",
      "name": "Thrusters"
    },
    "42820": {
      "fdname": "Int_Engine_Size8_Class4",
      "name": "Thrusters"
    },
    "42830": {
      "fdname": "Int_Engine_Size8_Class3",
      "name": "Thrusters"
    },
    "42840": {
      "fdname": "Int_Engine_Size8_Class2",
      "name": "Thrusters"
    },
    "42850": {
      "fdname": "Int_Engine_Size8_Class1",
      "name": "Thrusters"
    },
    "43210": {
      "fdname": "Int_Hyperdrive_Size2_Class5",
      "name": "Frame Shift Drive"
    },
    "43211": {
      "fdname": "Int_Hyperdrive_Overcharge_Size2_Class5",
      "name": "Frame Shift Drive (SCO)"
    },
    "43220": {
      "fdname": "Int_Hyperdrive_Size2_Class4",
      "name": "Frame Shift Drive"
    },
    "43221": {
      "fdname": "Int_Hyperdrive_Overcharge_Size2_Class4",
      "name": "Frame Shift Drive (SCO)"
    },
    "43230": {
      "fdname": "Int_Hyperdrive_Size2_Class3",
      "name": "Frame Shift Drive"
    },
    "43231": {
      "fdname": "Int_Hyperdrive_Overcharge_Size2_Class3",
      "name": "Frame Shift Drive (SCO)"
    },
    "43240": {
      "fdname": "Int_Hyperdrive_Size2_Class2",
      "name": "Frame Shift Drive"
    },
    "43241": {
      "fdname": "Int_Hyperdrive_Overcharge_Size2_Class2",
      "name": "Frame Shift Drive (SCO)"
    },
    "43250": {
      "fdname": "Int_Hyperdrive_Size2_Class1",
      "name": "Frame Shift Drive"
    },
    "43251": {
      "fdname": "Int_Hyperdrive_Overcharge_Size2_Class1",
      "name": "Frame Shift Drive (SCO)"
    },
    "43310": {
      "fdname": "Int_Hyperdrive_Size3_Class5",
      "name": "Frame Shift Drive"
    },
    "43311": {
      "fdname": "Int_Hyperdrive_Overcharge_Size3_Class5",
      "name": "Frame Shift Drive (SCO)"
    },
    "43320": {
      "fdname": "Int_Hyperdrive_Size3_Class4",
      "name": "Frame Shift Drive"
    },
    "43321": {
      "fdname": "Int_Hyperdrive_Overcharge_Size3_Class4",
      "name": "Frame Shift Drive (SCO)"
    },
    "43330": {
      "fdname": "Int_Hyperdrive_Size3_Class3",
      "name": "Frame Shift Drive"
    },
    "43331": {
      "fdname": "Int_Hyperdrive_Overcharge_Size3_Class3",
      "name": "Frame Shift Drive (SCO)"
    },
    "43340": {
      "fdname": "Int_Hyperdrive_Size3_Class2",
      "name": "Frame Shift Drive"
    },
    "43341": {
      "fdname": "Int_Hyperdrive_Overcharge_Size3_Class2",
      "name": "Frame Shift Drive (SCO)"
    },
    "43350": {
      "fdname": "Int_Hyperdrive_Size3_Class1",
      "name": "Frame Shift Drive"
    },
    "43351": {
      "fdname": "Int_Hyperdrive_Overcharge_Size3_Class1",
      "name": "Frame Shift Drive (SCO)"
    },
    "43410": {
      "fdname": "Int_Hyperdrive_Size4_Class5",
      "name": "Frame Shift Drive"
    },
    "43411": {
      "fdname": "Int_Hyperdrive_Overcharge_Size4_Class5",
      "name": "Frame Shift Drive (SCO)"
    },
    "43420": {
      "fdname": "Int_Hyperdrive_Size4_Class4",
      "name": "Frame Shift Drive"
    },
    "43421": {
      "fdname": "Int_Hyperdrive_Overcharge_Size4_Class4",
      "name": "Frame Shift Drive (SCO)"
    },
    "43430": {
      "fdname": "Int_Hyperdrive_Size4_Class3",
      "name": "Frame Shift Drive"
    },
    "43431": {
      "fdname": "Int_Hyperdrive_Overcharge_Size4_Class3",
      "name": "Frame Shift Drive (SCO)"
    },
    "43440": {
      "fdname": "Int_Hyperdrive_Size4_Class2",
      "name": "Frame Shift Drive"
    },
    "43441": {
      "fdname": "Int_Hyperdrive_Overcharge_Size4_Class2",
      "name": "Frame Shift Drive (SCO)"
    },
    "43450": {
      "fdname": "Int_Hyperdrive_Size4_Class1",
      "name": "Frame Shift Drive"
    },
    "43451": {
      "fdname": "Int_Hyperdrive_Overcharge_Size4_Class1",
      "name": "Frame Shift Drive (SCO)"
    },
    "43510": {
      "fdname": "Int_Hyperdrive_Size5_Class5",
      "name": "Frame Shift Drive"
    },
    "43511": {
      "fdname": "Int_Hyperdrive_Overcharge_Size5_Class5",
      "name": "Frame Shift Drive (SCO)"
    },
    "43520": {
      "fdname": "Int_Hyperdrive_Size5_Class4",
      "name": "Frame Shift Drive"
    },
    "43521": {
      "fdname": "Int_Hyperdrive_Overcharge_Size5_Class4",
      "name": "Frame Shift Drive (SCO)"
    },
    "43530": {
      "fdname": "Int_Hyperdrive_Size5_Class3",
      "name": "Frame Shift Drive"
    },
    "43531": {
      "fdname": "Int_Hyperdrive_Overcharge_Size5_Class3",
      "name": "Frame Shift Drive (SCO)"
    },
    "43540": {
      "fdname": "Int_Hyperdrive_Size5_Class2",
      "name": "Frame Shift Drive"
    },
    "43541": {
      "fdname": "Int_Hyperdrive_Overcharge_Size5_Class2",
      "name": "Frame Shift Drive (SCO)"
    },
    "43550": {
      "fdname": "Int_Hyperdrive_Size5_Class1",
      "name": "Frame Shift Drive"
    },
    "43551": {
      "fdname": "Int_Hyperdrive_Overcharge_Size5_Class1",
      "name": "Frame Shift Drive (SCO)"
    },
    "43610": {
      "fdname": "Int_Hyperdrive_Size6_Class5",
      "name": "Frame Shift Drive"
    },
    "43611": {
      "fdname": "Int_Hyperdrive_Overcharge_Size6_Class5",
      "name": "Frame Shift Drive (SCO)"
    },
    "43620": {
      "fdname": "Int_Hyperdrive_Size6_Class4",
      "name": "Frame Shift Drive"
    },
    "43621": {
      "fdname": "Int_Hyperdrive_Overcharge_Size6_Class4",
      "name": "Frame Shift Drive (SCO)"
    },
    "43630": {
      "fdname": "Int_Hyperdrive_Size6_Class3",
      "name": "Frame Shift Drive"
    },
    "43631": {
      "fdname": "Int_Hyperdrive_Overcharge_Size6_Class3",
      "name": "Frame Shift Drive (SCO)"
    },
    "43640": {
      "fdname": "Int_Hyperdrive_Size6_Class2",
      "name": "Frame Shift Drive"
    },
    "43641": {
      "fdname": "Int_Hyperdrive_Overcharge_Size6_Class2",
      "name": "Frame Shift Drive (SCO)"
    },
    "43650": {
      "fdname": "Int_Hyperdrive_Size6_Class1",
      "name": "Frame Shift Drive"
    },
    "43651": {
      "fdname": "Int_Hyperdrive_Overcharge_Size6_Class1",
      "name": "Frame Shift Drive (SCO)"
    },
    "43710": {
      "fdname": "Int_Hyperdrive_Size7_Class5",
      "name": "Frame Shift Drive"
    },
    "43711": {
      "fdname": "Int_Hyperdrive_Overcharge_Size7_Class5",
      "name": "Frame Shift Drive (SCO)"
    },
    "43720": {
      "fdname": "Int_Hyperdrive_Size7_Class4",
      "name": "Frame Shift Drive"
    },
    "43721": {
      "fdname": "Int_Hyperdrive_Overcharge_Size7_Class4",
      "name": "Frame Shift Drive (SCO)"
    },
    "43730": {
      "fdname": "Int_Hyperdrive_Size7_Class3",
      "name": "Frame Shift Drive"
    },
    "43731": {
      "fdname": "Int_Hyperdrive_Overcharge_Size7_Class3",
      "name": "Frame Shift Drive (SCO)"
    },
    "43740": {
      "fdname": "Int_Hyperdrive_Size7_Class2",
      "name": "Frame Shift Drive"
    },
    "43741": {
      "fdname": "Int_Hyperdrive_Overcharge_Size7_Class2",
      "name": "Frame Shift Drive (SCO)"
    },
    "43750": {
      "fdname": "Int_Hyperdrive_Size7_Class1",
      "name": "Frame Shift Drive"
    },
    "43751": {
      "fdname": "Int_Hyperdrive_Overcharge_Size7_Class1",
      "name": "Frame Shift Drive (SCO)"
    },
    "43811": {
      "fdname": "Int_Hyperdrive_Overcharge_Size8_Class5",
      "name": "Frame Shift Drive (SCO)"
    },
    "43812": {
      "fdname": "Int_Hyperdrive_Overcharge_Size8_Class5_Overchargebooster_MkII",
      "name": "Mk II Supercharge Optimised FSD (SCO)"
    },
    "43821": {
      "fdname": "Int_Hyperdrive_Overcharge_Size8_Class4",
      "name": "Frame Shift Drive (SCO)"
    },
    "43831": {
      "fdname": "Int_Hyperdrive_Overcharge_Size8_Class3",
      "name": "Frame Shift Drive (SCO)"
    },
    "43841": {
      "fdname": "Int_Hyperdrive_Overcharge_Size8_Class2",
      "name": "Frame Shift Drive (SCO)"
    },
    "43851": {
      "fdname": "Int_Hyperdrive_Overcharge_Size8_Class1",
      "name": "Frame Shift Drive (SCO)"
    },
    "44110": {
      "fdname": "Int_LifeSupport_Size1_Class5",
      "name": "Life Support"
    },
    "44120": {
      "fdname": "Int_LifeSupport_Size1_Class4",
      "name": "Life Support"
    },
    "44130": {
      "fdname": "Int_LifeSupport_Size1_Class3",
      "name": "Life Support"
    },
    "44140": {
      "fdname": "Int_LifeSupport_Size1_Class2",
      "name": "Life Support"
    },
    "44150": {
      "fdname": "Int_LifeSupport_Size1_Class1",
      "name": "Life Support"
    },
    "44210": {
      "fdname": "Int_LifeSupport_Size2_Class5",
      "name": "Life Support"
    },
    "44220": {
      "fdname": "Int_LifeSupport_Size2_Class4",
      "name": "Life Support"
    },
    "44230": {
      "fdname": "Int_LifeSupport_Size2_Class3",
      "name": "Life Support"
    },
    "44240": {
      "fdname": "Int_LifeSupport_Size2_Class2",
      "name": "Life Support"
    },
    "44250": {
      "fdname": "Int_LifeSupport_Size2_Class1",
      "name": "Life Support"
    },
    "44310": {
      "fdname": "Int_LifeSupport_Size3_Class5",
      "name": "Life Support"
    },
    "44320": {
      "fdname": "Int_LifeSupport_Size3_Class4",
      "name": "Life Support"
    },
    "44330": {
      "fdname": "Int_LifeSupport_Size3_Class3",
      "name": "Life Support"
    },
    "44340": {
      "fdname": "Int_LifeSupport_Size3_Class2",
      "name": "Life Support"
    },
    "44350": {
      "fdname": "Int_LifeSupport_Size3_Class1",
      "name": "Life Support"
    },
    "44410": {
      "fdname": "Int_LifeSupport_Size4_Class5",
      "name": "Life Support"
    },
    "44420": {
      "fdname": "Int_LifeSupport_Size4_Class4",
      "name": "Life Support"
    },
    "44430": {
      "fdname": "Int_LifeSupport_Size4_Class3",
      "name": "Life Support"
    },
    "44440": {
      "fdname": "Int_LifeSupport_Size4_Class2",
      "name": "Life Support"
    },
    "44450": {
      "fdname": "Int_LifeSupport_Size4_Class1",
      "name": "Life Support"
    },
    "44510": {
      "fdname": "Int_LifeSupport_Size5_Class5",
      "name": "Life Support"
    },
    "44520": {
      "fdname": "Int_LifeSupport_Size5_Class4",
      "name": "Life Support"
    },
    "44530": {
      "fdname": "Int_LifeSupport_Size5_Class3",
      "name": "Life Support"
    },
    "44540": {
      "fdname": "Int_LifeSupport_Size5_Class2",
      "name": "Life Support"
    },
    "44550": {
      "fdname": "Int_LifeSupport_Size5_Class1",
      "name": "Life Support"
    },
    "44610": {
      "fdname": "Int_LifeSupport_Size6_Class5",
      "name": "Life Support"
    },
    "44620": {
      "fdname": "Int_LifeSupport_Size6_Class4",
      "name": "Life Support"
    },
    "44630": {
      "fdname": "Int_LifeSupport_Size6_Class3",
      "name": "Life Support"
    },
    "44640": {
      "fdname": "Int_LifeSupport_Size6_Class2",
      "name": "Life Support"
    },
    "44650": {
      "fdname": "Int_LifeSupport_Size6_Class1",
      "name": "Life Support"
    },
    "44710": {
      "fdname": "Int_LifeSupport_Size7_Class5",
      "name": "Life Support"
    },
    "44720": {
      "fdname": "Int_LifeSupport_Size7_Class4",
      "name": "Life Support"
    },
    "44730": {
      "fdname": "Int_LifeSupport_Size7_Class3",
      "name": "Life Support"
    },
    "44740": {
      "fdname": "Int_LifeSupport_Size7_Class2",
      "name": "Life Support"
    },
    "44750": {
      "fdname": "Int_LifeSupport_Size7_Class1",
      "name": "Life Support"
    },
    "44810": {
      "fdname": "Int_LifeSupport_Size8_Class5",
      "name": "Life Support"
    },
    "44820": {
      "fdname": "Int_LifeSupport_Size8_Class4",
      "name": "Life Support"
    },
    "44830": {
      "fdname": "Int_LifeSupport_Size8_Class3",
      "name": "Life Support"
    },
    "44840": {
      "fdname": "Int_LifeSupport_Size8_Class2",
      "name": "Life Support"
    },
    "44850": {
      "fdname": "Int_LifeSupport_Size8_Class1",
      "name": "Life Support"
    },
    "45110": {
      "fdname": "Int_PowerDistributor_Size1_Class5",
      "name": "Power Distributor"
    },
    "45111": {
      "fdname": "Int_GuardianPowerDistributor_Size1",
      "name": "Guardian Hybrid Power Distributor"
    },
    "45120": {
      "fdname": "Int_PowerDistributor_Size1_Class4",
      "name": "Power Distributor"
    },
    "45130": {
      "fdname": "Int_PowerDistributor_Size1_Class3",
      "name": "Power Distributor"
    },
    "45140": {
      "fdname": "Int_PowerDistributor_Size1_Class2",
      "name": "Power Distributor"
    },
    "45150": {
      "fdname": "Int_PowerDistributor_Size1_Class1",
      "name": "Power Distributor"
    },
    "45210": {
      "fdname": "Int_PowerDistributor_Size2_Class5",
      "name": "Power Distributor"
    },
    "45211": {
      "fdname": "Int_GuardianPowerDistributor_Size2",
      "name": "Guardian Hybrid Power Distributor"
    },
    "45220": {
      "fdname": "Int_PowerDistributor_Size2_Class4",
      "name": "Power Distributor"
    },
    "45230": {
      "fdname": "Int_PowerDistributor_Size2_Class3",
      "name": "Power Distributor"
    },
    "45240": {
      "fdname": "Int_PowerDistributor_Size2_Class2",
      "name": "Power Distributor"
    },
    "45250": {
      "fdname": "Int_PowerDistributor_Size2_Class1",
      "name": "Power Distributor"
    },
    "45310": {
      "fdname": "Int_PowerDistributor_Size3_Class5",
      "name": "Power Distributor"
    },
    "45311": {
      "fdname": "Int_GuardianPowerDistributor_Size3",
      "name": "Guardian Hybrid Power Distributor"
    },
    "45320": {
      "fdname": "Int_PowerDistributor_Size3_Class4",
      "name": "Power Distributor"
    },
    "45330": {
      "fdname": "Int_PowerDistributor_Size3_Class3",
      "name": "Power Distributor"
    },
    "45340": {
      "fdname": "Int_PowerDistributor_Size3_Class2",
      "name": "Power Distributor"
    },
    "45350": {
      "fdname": "Int_PowerDistributor_Size3_Class1",
      "name": "Power Distributor"
    },
    "45410": {
      "fdname": "Int_PowerDistributor_Size4_Class5",
      "name": "Power Distributor"
    },
    "45411": {
      "fdname": "Int_GuardianPowerDistributor_Size4",
      "name": "Guardian Hybrid Power Distributor"
    },
    "45420": {
      "fdname": "Int_PowerDistributor_Size4_Class4",
      "name": "Power Distributor"
    },
    "45430": {
      "fdname": "Int_PowerDistributor_Size4_Class3",
      "name": "Power Distributor"
    },
    "45440": {
      "fdname": "Int_PowerDistributor_Size4_Class2",
      "name": "Power Distributor"
    },
    "45450": {
      "fdname": "Int_PowerDistributor_Size4_Class1",
      "name": "Power Distributor"
    },
    "45510": {
      "fdname": "Int_PowerDistributor_Size5_Class5",
      "name": "Power Distributor"
    },
    "45511": {
      "fdname": "Int_GuardianPowerDistributor_Size5",
      "name": "Guardian Hybrid Power Distributor"
    },
    "45520": {
      "fdname": "Int_PowerDistributor_Size5_Class4",
      "name": "Power Distributor"
    },
    "45530": {
      "fdname": "Int_PowerDistributor_Size5_Class3",
      "name": "Power Distributor"
    },
    "45540": {
      "fdname": "Int_PowerDistributor_Size5_Class2",
      "name": "Power Distributor"
    },
    "45550": {
      "fdname": "Int_PowerDistributor_Size5_Class1",
      "name": "Power Distributor"
    },
    "45610": {
      "fdname": "Int_PowerDistributor_Size6_Class5",
      "name": "Power Distributor"
    },
    "45611": {
      "fdname": "Int_GuardianPowerDistributor_Size6",
      "name": "Guardian Hybrid Power Distributor"
    },
    "45620": {
      "fdname": "Int_PowerDistributor_Size6_Class4",
      "name": "Power Distributor"
    },
    "45630": {
      "fdname": "Int_PowerDistributor_Size6_Class3",
      "name": "Power Distributor"
    },
    "45640": {
      "fdname": "Int_PowerDistributor_Size6_Class2",
      "name": "Power Distributor"
    },
    "45650": {
      "fdname": "Int_PowerDistributor_Size6_Class1",
      "name": "Power Distributor"
    },
    "45710": {
      "fdname": "Int_PowerDistributor_Size7_Class5",
      "name": "Power Distributor"
    },
    "45711": {
      "fdname": "Int_GuardianPowerDistributor_Size7",
      "name": "Guardian Hybrid Power Distributor"
    },
    "45720": {
      "fdname": "Int_PowerDistributor_Size7_Class4",
      "name": "Power Distributor"
    },
    "45730": {
      "fdname": "Int_PowerDistributor_Size7_Class3",
      "name": "Power Distributor"
    },
    "45740": {
      "fdname": "Int_PowerDistributor_Size7_Class2",
      "name": "Power Distributor"
    },
    "45750": {
      "fdname": "Int_PowerDistributor_Size7_Class1",
      "name": "Power Distributor"
    },
    "45810": {
      "fdname": "Int_PowerDistributor_Size8_Class5",
      "name": "Power Distributor"
    },
    "45811": {
      "fdname": "Int_GuardianPowerDistributor_Size8",
      "name": "Guardian Hybrid Power Distributor"
    },
    "45820": {
      "fdname": "Int_PowerDistributor_Size8_Class4",
      "name": "Power Distributor"
    },
    "45830": {
      "fdname": "Int_PowerDistributor_Size8_Class3",
      "name": "Power Distributor"
    },
    "45840": {
      "fdname": "Int_PowerDistributor_Size8_Class2",
      "name": "Power Distributor"
    },
    "45850": {
      "fdname": "Int_PowerDistributor_Size8_Class1",
      "name": "Power Distributor"
    },
    "46110": {
      "fdname": "Int_Sensors_Size1_Class5",
      "name": "Sensors"
    },
    "46120": {
      "fdname": "Int_Sensors_Size1_Class4",
      "name": "Sensors"
    },
    "46130": {
      "fdname": "Int_Sensors_Size1_Class3",
      "name": "Sensors"
    },
    "46140": {
      "fdname": "Int_Sensors_Size1_Class2",
      "name": "Sensors"
    },
    "46150": {
      "fdname": "Int_Sensors_Size1_Class1",
      "name": "Sensors"
    },
    "46210": {
      "fdname": "Int_Sensors_Size2_Class5",
      "name": "Sensors"
    },
    "46220": {
      "fdname": "Int_Sensors_Size2_Class4",
      "name": "Sensors"
    },
    "46230": {
      "fdname": "Int_Sensors_Size2_Class3",
      "name": "Sensors"
    },
    "46240": {
      "fdname": "Int_Sensors_Size2_Class2",
      "name": "Sensors"
    },
    "46250": {
      "fdname": "Int_Sensors_Size2_Class1",
      "name": "Sensors"
    },
    "46310": {
      "fdname": "Int_Sensors_Size3_Class5",
      "name": "Sensors"
    },
    "46320": {
      "fdname": "Int_Sensors_Size3_Class4",
      "name": "Sensors"
    },
    "46330": {
      "fdname": "Int_Sensors_Size3_Class3",
      "name": "Sensors"
    },
    "46340": {
      "fdname": "Int_Sensors_Size3_Class2",
      "name": "Sensors"
    },
    "46350": {
      "fdname": "Int_Sensors_Size3_Class1",
      "name": "Sensors"
    },
    "46410": {
      "fdname": "Int_Sensors_Size4_Class5",
      "name": "Sensors"
    },
    "46420": {
      "fdname": "Int_Sensors_Size4_Class4",
      "name": "Sensors"
    },
    "46430": {
      "fdname": "Int_Sensors_Size4_Class3",
      "name": "Sensors"
    },
    "46440": {
      "fdname": "Int_Sensors_Size4_Class2",
      "name": "Sensors"
    },
    "46450": {
      "fdname": "Int_Sensors_Size4_Class1",
      "name": "Sensors"
    },
    "46510": {
      "fdname": "Int_Sensors_Size5_Class5",
      "name": "Sensors"
    },
    "46520": {
      "fdname": "Int_Sensors_Size5_Class4",
      "name": "Sensors"
    },
    "46530": {
      "fdname": "Int_Sensors_Size5_Class3",
      "name": "Sensors"
    },
    "46540": {
      "fdname": "Int_Sensors_Size5_Class2",
      "name": "Sensors"
    },
    "46550": {
      "fdname": "Int_Sensors_Size5_Class1",
      "name": "Sensors"
    },
    "46610": {
      "fdname": "Int_Sensors_Size6_Class5",
      "name": "Sensors"
    },
    "46620": {
      "fdname": "Int_Sensors_Size6_Class4",
      "name": "Sensors"
    },
    "46630": {
      "fdname": "Int_Sensors_Size6_Class3",
      "name": "Sensors"
    },
    "46640": {
      "fdname": "Int_Sensors_Size6_Class2",
      "name": "Sensors"
    },
    "46650": {
      "fdname": "Int_Sensors_Size6_Class1",
      "name": "Sensors"
    },
    "46710": {
      "fdname": "Int_Sensors_Size7_Class5",
      "name": "Sensors"
    },
    "46720": {
      "fdname": "Int_Sensors_Size7_Class4",
      "name": "Sensors"
    },
    "46730": {
      "fdname": "Int_Sensors_Size7_Class3",
      "name": "Sensors"
    },
    "46740": {
      "fdname": "Int_Sensors_Size7_Class2",
      "name": "Sensors"
    },
    "46750": {
      "fdname": "Int_Sensors_Size7_Class1",
      "name": "Sensors"
    },
    "46810": {
      "fdname": "Int_Sensors_Size8_Class5",
      "name": "Sensors"
    },
    "46820": {
      "fdname": "Int_Sensors_Size8_Class4",
      "name": "Sensors"
    },
    "46830": {
      "fdname": "Int_Sensors_Size8_Class3",
      "name": "Sensors"
    },
    "46840": {
      "fdname": "Int_Sensors_Size8_Class2",
      "name": "Sensors"
    },
    "46850": {
      "fdname": "Int_Sensors_Size8_Class1",
      "name": "Sensors"
    },
    "47130": {
      "fdname": "Int_FuelTank_Size1_Class3",
      "name": "Fuel Tank (Cap: 2)"
    },
    "47230": {
      "fdname": "Int_FuelTank_Size2_Class3",
      "name": "Fuel Tank (Cap: 4)"
    },
    "47330": {
      "fdname": "Int_FuelTank_Size3_Class3",
      "name": "Fuel Tank (Cap: 8)"
    },
    "47430": {
      "fdname": "Int_FuelTank_Size4_Class3",
      "name": "Fuel Tank (Cap: 16)"
    },
    "47530": {
      "fdname": "Int_FuelTank_Size5_Class3",
      "name": "Fuel Tank (Cap: 32)"
    },
    "47630": {
      "fdname": "Int_FuelTank_Size6_Class3",
      "name": "Fuel Tank (Cap: 64)"
    },
    "47730": {
      "fdname": "Int_FuelTank_Size7_Class3",
      "name": "Fuel Tank (Cap: 128)"
    },
    "47830": {
      "fdname": "Int_FuelTank_Size8_Class3",
      "name": "Fuel Tank (Cap: 256)"
    },
    "49180": {
      "fdname": "ModularCargoBayDoor",
      "name": "Cargo Hatch"
    },
    "50090": {
      "fdname": "Hpt_ChaffLauncher_Tiny",
      "name": "Chaff Launcher"
    },
    "51060": {
      "fdname": "Hpt_ElectronicCountermeasure_Tiny",
      "name": "Electronic Countermeasure"
    },
    "52090": {
      "fdname": "Hpt_HeatSinkLauncher_Turret_Tiny",
      "name": "Heat Sink Launcher"
    },
    "52091": {
      "fdname": "Hpt_CausticSinkLauncher_Turret_Tiny",
      "name": "Caustic Sink Launcher"
    },
    "53090": {
      "fdname": "Hpt_PlasmaPointDefence_Turret_Tiny",
      "name": "Point Defence"
    },
    "54010": {
      "fdname": "Hpt_ShieldBooster_Size0_Class5",
      "name": "Shield Booster"
    },
    "54020": {
      "fdname": "Hpt_ShieldBooster_Size0_Class4",
      "name": "Shield Booster"
    },
    "54030": {
      "fdname": "Hpt_ShieldBooster_Size0_Class3",
      "name": "Shield Booster"
    },
    "54040": {
      "fdname": "Hpt_ShieldBooster_Size0_Class2",
      "name": "Shield Booster"
    },
    "54050": {
      "fdname": "Hpt_ShieldBooster_Size0_Class1",
      "name": "Shield Booster"
    },
    "55010": {
      "fdname": "Hpt_CargoScanner_Size0_Class5",
      "name": "Manifest Scanner"
    },
    "55020": {
      "fdname": "Hpt_CargoScanner_Size0_Class4",
      "name": "Manifest Scanner"
    },
    "55030": {
      "fdname": "Hpt_CargoScanner_Size0_Class3",
      "name": "Manifest Scanner"
    },
    "55040": {
      "fdname": "Hpt_CargoScanner_Size0_Class2",
      "name": "Manifest Scanner"
    },
    "55050": {
      "fdname": "Hpt_CargoScanner_Size0_Class1",
      "name": "Manifest Scanner"
    },
    "56010": {
      "fdname": "Hpt_CloudScanner_Size0_Class5",
      "name": "Frame Shift Wake Scanner"
    },
    "56020": {
      "fdname": "Hpt_CloudScanner_Size0_Class4",
      "name": "Frame Shift Wake Scanner"
    },
    "56030": {
      "fdname": "Hpt_CloudScanner_Size0_Class3",
      "name": "Frame Shift Wake Scanner"
    },
    "56040": {
      "fdname": "Hpt_CloudScanner_Size0_Class2",
      "name": "Frame Shift Wake Scanner"
    },
    "56050": {
      "fdname": "Hpt_CloudScanner_Size0_Class1",
      "name": "Frame Shift Wake Scanner"
    },
    "57010": {
      "fdname": "Hpt_CrimeScanner_Size0_Class5",
      "name": "Kill Warrant Scanner"
    },
    "57020": {
      "fdname": "Hpt_CrimeScanner_Size0_Class4",
      "name": "Kill Warrant Scanner"
    },
    "57030": {
      "fdname": "Hpt_CrimeScanner_Size0_Class3",
      "name": "Kill Warrant Scanner"
    },
    "57040": {
      "fdname": "Hpt_CrimeScanner_Size0_Class2",
      "name": "Kill Warrant Scanner"
    },
    "57050": {
      "fdname": "Hpt_CrimeScanner_Size0_Class1",
      "name": "Kill Warrant Scanner"
    },
    "58030": {
      "fdname": "Hpt_XenoScannerMk2_Basic_Tiny",
      "name": "Enhanced Xeno Scanner"
    },
    "58031": {
      "fdname": "Hpt_XenoScanner_Advanced_Tiny",
      "name": "Pulse Wave Xeno Scanner"
    },
    "58050": {
      "fdname": "Hpt_XenoScanner_Basic_Tiny",
      "name": "Xeno Scanner"
    },
    "58052": {
      "fdname": "Hpt_AntiUnknownShutdown_Tiny_V2",
      "name": "Thargoid Pulse Neutraliser"
    },
    "58061": {
      "fdname": "Hpt_AntiUnknownShutdown_Tiny",
      "name": "Shutdown Field Neutraliser"
    },
    "59010": {
      "fdname": "Hpt_MRAScanner_Size0_Class5",
      "name": "Pulse Wave Analyser"
    },
    "59020": {
      "fdname": "Hpt_MRAScanner_Size0_Class4",
      "name": "Pulse Wave Analyser"
    },
    "59030": {
      "fdname": "Hpt_MRAScanner_Size0_Class3",
      "name": "Pulse Wave Analyser"
    },
    "59040": {
      "fdname": "Hpt_MRAScanner_Size0_Class2",
      "name": "Pulse Wave Analyser"
    },
    "59050": {
      "fdname": "Hpt_MRAScanner_Size0_Class1",
      "name": "Pulse Wave Analyser"
    },
    "60150": {
      "fdname": "Hpt_BeamLaser_Fixed_Small",
      "name": "Beam Laser"
    },
    "60151": {
      "fdname": "Hpt_BeamLaser_Gimbal_Small",
      "name": "Beam Laser"
    },
    "60154": {
      "fdname": "Hpt_BeamLaser_Fixed_Small_Heat",
      "name": "Retributor Beam Laser"
    },
    "60162": {
      "fdname": "Hpt_BeamLaser_Turret_Small",
      "name": "Beam Laser"
    },
    "60240": {
      "fdname": "Hpt_BeamLaser_Fixed_Medium",
      "name": "Beam Laser"
    },
    "60241": {
      "fdname": "Hpt_BeamLaser_Gimbal_Medium",
      "name": "Beam Laser"
    },
    "60252": {
      "fdname": "Hpt_BeamLaser_Turret_Medium",
      "name": "Beam Laser"
    },
    "60330": {
      "fdname": "Hpt_BeamLaser_Fixed_Large",
      "name": "Beam Laser"
    },
    "60331": {
      "fdname": "Hpt_BeamLaser_Gimbal_Large",
      "name": "Beam Laser"
    },
    "60332": {
      "fdname": "Hpt_BeamLaser_Turret_Large",
      "name": "Beam Laser"
    },
    "60410": {
      "fdname": "Hpt_BeamLaser_Fixed_Huge",
      "name": "Beam Laser"
    },
    "60411": {
      "fdname": "Hpt_BeamLaser_Gimbal_Huge",
      "name": "Beam Laser"
    },
    "61160": {
      "fdname": "Hpt_PulseLaserBurst_Fixed_Small",
      "name": "Burst Laser"
    },
    "61164": {
      "fdname": "Hpt_PulseLaserBurst_Fixed_Small_Scatter",
      "name": "Cytoscrambler Burst Laser"
    },
    "61171": {
      "fdname": "Hpt_PulseLaserBurst_Gimbal_Small",
      "name": "Burst Laser"
    },
    "61172": {
      "fdname": "Hpt_PulseLaserBurst_Turret_Small",
      "name": "Burst Laser"
    },
    "61250": {
      "fdname": "Hpt_PulseLaserBurst_Fixed_Medium",
      "name": "Burst Laser"
    },
    "61261": {
      "fdname": "Hpt_PulseLaserBurst_Gimbal_Medium",
      "name": "Burst Laser"
    },
    "61262": {
      "fdname": "Hpt_PulseLaserBurst_Turret_Medium",
      "name": "Burst Laser"
    },
    "61340": {
      "fdname": "Hpt_PulseLaserBurst_Fixed_Large",
      "name": "Burst Laser"
    },
    "61351": {
      "fdname": "Hpt_PulseLaserBurst_Gimbal_Large",
      "name": "Burst Laser"
    },
    "61352": {
      "fdname": "Hpt_PulseLaserBurst_Turret_Large",
      "name": "Burst Laser"
    },
    "61450": {
      "fdname": "Hpt_PulseLaserBurst_Fixed_Huge",
      "name": "Burst Laser"
    },
    "61451": {
      "fdname": "Hpt_PulseLaserBurst_Gimbal_Huge",
      "name": "Burst Laser"
    },
    "62160": {
      "fdname": "Hpt_PulseLaser_Fixed_Small",
      "name": "Pulse Laser"
    },
    "62171": {
      "fdname": "Hpt_PulseLaser_Gimbal_Small",
      "name": "Pulse Laser"
    },
    "62172": {
      "fdname": "Hpt_PulseLaser_Turret_Small",
      "name": "Pulse Laser"
    },
    "62250": {
      "fdname": "Hpt_PulseLaser_Fixed_Medium",
      "name": "Pulse Laser"
    },
    "62254": {
      "fdname": "Hpt_PulseLaser_Fixed_Medium_Disruptor",
      "name": "Pulse Disruptor Laser"
    },
    "62261": {
      "fdname": "Hpt_PulseLaser_Gimbal_Medium",
      "name": "Pulse Laser"
    },
    "62262": {
      "fdname": "Hpt_PulseLaser_Turret_Medium",
      "name": "Pulse Laser"
    },
    "62350": {
      "fdname": "Hpt_PulseLaser_Fixed_Large",
      "name": "Pulse Laser"
    },
    "62361": {
      "fdname": "Hpt_PulseLaser_Gimbal_Large",
      "name": "Pulse Laser"
    },
    "62362": {
      "fdname": "Hpt_PulseLaser_Turret_Large",
      "name": "Pulse Laser"
    },
    "62410": {
      "fdname": "Hpt_PulseLaser_Fixed_Huge",
      "name": "Pulse Laser"
    },
    "62411": {
      "fdname": "Hpt_PulseLaser_Gimbal_Huge",
      "name": "Pulse Laser"
    },
    "70140": {
      "fdname": "Hpt_Cannon_Fixed_Small",
      "name": "Cannon"
    },
    "70151": {
      "fdname": "Hpt_Cannon_Gimbal_Small",
      "name": "Cannon"
    },
    "70162": {
      "fdname": "Hpt_Cannon_Turret_Small",
      "name": "Cannon"
    },
    "70240": {
      "fdname": "Hpt_Cannon_Fixed_Medium",
      "name": "Cannon"
    },
    "70241": {
      "fdname": "Hpt_Cannon_Gimbal_Medium",
      "name": "Cannon"
    },
    "70244": {
      "fdname": "Hpt_Cannon_Gimbal_Medium_Burst",
      "name": "Concord Cannon"
    },
    "70252": {
      "fdname": "Hpt_Cannon_Turret_Medium",
      "name": "Cannon"
    },
    "70330": {
      "fdname": "Hpt_Cannon_Fixed_Large",
      "name": "Cannon"
    },
    "70331": {
      "fdname": "Hpt_Cannon_Gimbal_Large",
      "name": "Cannon"
    },
    "70342": {
      "fdname": "Hpt_Cannon_Turret_Large",
      "name": "Cannon"
    },
    "70420": {
      "fdname": "Hpt_Cannon_Fixed_Huge",
      "name": "Cannon"
    },
    "70421": {
      "fdname": "Hpt_Cannon_Gimbal_Huge",
      "name": "Cannon"
    },
    "71150": {
      "fdname": "Hpt_Slugshot_Fixed_Small",
      "name": "Fragment Cannon"
    },
    "71151": {
      "fdname": "Hpt_Slugshot_Gimbal_Small",
      "name": "Fragment Cannon"
    },
    "71152": {
      "fdname": "Hpt_Slugshot_Turret_Small",
      "name": "Fragment Cannon"
    },
    "71210": {
      "fdname": "Hpt_Slugshot_Fixed_Medium",
      "name": "Fragment Cannon"
    },
    "71241": {
      "fdname": "Hpt_Slugshot_Gimbal_Medium",
      "name": "Fragment Cannon"
    },
    "71242": {
      "fdname": "Hpt_Slugshot_Turret_Medium",
      "name": "Fragment Cannon"
    },
    "71330": {
      "fdname": "Hpt_Slugshot_Fixed_Large",
      "name": "Fragment Cannon"
    },
    "71331": {
      "fdname": "Hpt_Slugshot_Gimbal_Large",
      "name": "Fragment Cannon"
    },
    "71332": {
      "fdname": "Hpt_Slugshot_Turret_Large",
      "name": "Fragment Cannon"
    },
    "71334": {
      "fdname": "Hpt_Slugshot_Fixed_Large_Range",
      "name": "Pacifier Frag-Cannon"
    },
    "72144": {
      "fdname": "Hpt_MultiCannon_Fixed_Small_Strong",
      "name": "Enforcer Cannon"
    },
    "72160": {
      "fdname": "Hpt_MultiCannon_Fixed_Small",
      "name": "Multi-cannon"
    },
    "72163": {
      "fdname": "Hpt_MultiCannon_Fixed_Small_Advanced",
      "name": "Advanced Multi-cannon"
    },
    "72171": {
      "fdname": "Hpt_MultiCannon_Gimbal_Small",
      "name": "Multi-cannon"
    },
    "72172": {
      "fdname": "Hpt_MultiCannon_Turret_Small",
      "name": "Multi-cannon"
    },
    "72250": {
      "fdname": "Hpt_MultiCannon_Fixed_Medium",
      "name": "Multi-cannon"
    },
    "72253": {
      "fdname": "Hpt_MultiCannon_Fixed_Medium_Advanced",
      "name": "Advanced Multi-cannon"
    },
    "72261": {
      "fdname": "Hpt_MultiCannon_Gimbal_Medium",
      "name": "Multi-cannon"
    },
    "72262": {
      "fdname": "Hpt_MultiCannon_Turret_Medium",
      "name": "Multi-cannon"
    },
    "72330": {
      "fdname": "Hpt_MultiCannon_Fixed_Large",
      "name": "Multi-cannon"
    },
    "72331": {
      "fdname": "Hpt_MultiCannon_Gimbal_Large",
      "name": "Multi-cannon"
    },
    "72352": {
      "fdname": "Hpt_MultiCannon_Turret_Large",
      "name": "Multi-cannon"
    },
    "72410": {
      "fdname": "Hpt_MultiCannon_Fixed_Huge",
      "name": "Multi-cannon"
    },
    "72411": {
      "fdname": "Hpt_MultiCannon_Gimbal_Huge",
      "name": "Multi-cannon"
    },
    "80190": {
      "fdname": "Hpt_MineLauncher_Fixed_Small",
      "name": "Mine Launcher"
    },
    "80191": {
      "fdname": "Hpt_MineLauncher_Fixed_Small_Impulse",
      "name": "Shock Mine Launcher"
    },
    "80290": {
      "fdname": "Hpt_MineLauncher_Fixed_Medium",
      "name": "Mine Launcher"
    },
    "80339": {
      "fdname": "Hpt_MiningToolV2_Fixed_Large",
      "name": "Mining Volley Repeater"
    },
    "81127": {
      "fdname": "Hpt_Mining_SubSurfDispMisle_Fixed_Small",
      "name": "Sub-surface Displacement Missile"
    },
    "81128": {
      "fdname": "Hpt_Mining_SubSurfDispMisle_Turret_Small",
      "name": "Sub-surface Displacement Missile"
    },
    "81140": {
      "fdname": "Hpt_MiningLaser_Fixed_Small",
      "name": "Mining Laser"
    },
    "81141": {
      "fdname": "Hpt_Mining_AbrBlstr_Fixed_Small",
      "name": "Abrasion Blaster"
    },
    "81142": {
      "fdname": "Hpt_MiningLaser_Turret_Small",
      "name": "Mining Laser"
    },
    "81143": {
      "fdname": "Hpt_Mining_AbrBlstr_Turret_Small",
      "name": "Abrasion Blaster"
    },
    "81144": {
      "fdname": "Hpt_MiningLaser_Fixed_Small_Advanced",
      "name": "Mining Lance Beam Laser"
    },
    "81225": {
      "fdname": "Hpt_Mining_SeismChrgWarhd_Fixed_Medium",
      "name": "Seismic Charge Launcher"
    },
    "81226": {
      "fdname": "Hpt_Mining_SeismChrgWarhd_Turret_Medium",
      "name": "Seismic Charge Launcher"
    },
    "81227": {
      "fdname": "Hpt_Mining_SubSurfDispMisle_Fixed_Medium",
      "name": "Sub-surface Displacement Missile"
    },
    "81228": {
      "fdname": "Hpt_Mining_SubSurfDispMisle_Turret_Medium",
      "name": "Sub-surface Displacement Missile"
    },
    "81229": {
      "fdname": "Hpt_Human_Extraction_Fixed_Medium",
      "name": "Sub-surface Extraction Missile"
    },
    "81240": {
      "fdname": "Hpt_MiningLaser_Fixed_Medium",
      "name": "Mining Laser"
    },
    "81242": {
      "fdname": "Hpt_MiningLaser_Turret_Medium",
      "name": "Mining Laser"
    },
    "82120": {
      "fdname": "Hpt_DumbfireMissileRack_Fixed_Small",
      "name": "Missile Rack"
    },
    "82123": {
      "fdname": "Hpt_BasicMissileRack_Fixed_Small",
      "name": "Seeker Missile Rack"
    },
    "82126": {
      "fdname": "Hpt_DumbfireMissileRack_Fixed_Small_Advanced",
      "name": "Advanced Missile Rack"
    },
    "82220": {
      "fdname": "Hpt_DumbfireMissileRack_Fixed_Medium",
      "name": "Missile Rack"
    },
    "82223": {
      "fdname": "Hpt_BasicMissileRack_Fixed_Medium",
      "name": "Seeker Missile Rack"
    },
    "82224": {
      "fdname": "Hpt_DrunkMissileRack_Fixed_Medium",
      "name": "Pack-Hound Missile Rack"
    },
    "82225": {
      "fdname": "Hpt_DumbfireMissileRack_Fixed_Medium_Lasso",
      "name": "Rocket Propelled FSD Disrupter"
    },
    "82226": {
      "fdname": "Hpt_DumbfireMissileRack_Fixed_Medium_Advanced",
      "name": "Advanced Missile Rack"
    },
    "82310": {
      "fdname": "Hpt_DumbfireMissileRack_Fixed_Large",
      "name": "Missile Rack"
    },
    "82313": {
      "fdname": "Hpt_BasicMissileRack_Fixed_Large",
      "name": "Seeker Missile Rack"
    },
    "83230": {
      "fdname": "Hpt_PlasmaAccelerator_Fixed_Medium",
      "name": "Plasma Accelerator"
    },
    "83320": {
      "fdname": "Hpt_PlasmaAccelerator_Fixed_Large",
      "name": "Plasma Accelerator"
    },
    "83324": {
      "fdname": "Hpt_PlasmaAccelerator_Fixed_Large_Advanced",
      "name": "Advanced Plasma Accelerator"
    },
    "83325": {
      "fdname": "Hpt_MkIIPlasmaShockAutocannon_Fixed_Large",
      "name": "Mk II Plasma Shock Accelerator"
    },
    "83410": {
      "fdname": "Hpt_PlasmaAccelerator_Fixed_Huge",
      "name": "Plasma Accelerator"
    },
    "84140": {
      "fdname": "Hpt_Railgun_Fixed_Small",
      "name": "Rail Gun"
    },
    "84220": {
      "fdname": "Hpt_Railgun_Fixed_Medium",
      "name": "Rail Gun"
    },
    "84224": {
      "fdname": "Hpt_Railgun_Fixed_Medium_Burst",
      "name": "Imperial Hammer Rail Gun"
    },
    "85193": {
      "fdname": "Hpt_AdvancedTorpPylon_Fixed_Small",
      "name": "Torpedo Pylon"
    },
    "85293": {
      "fdname": "Hpt_AdvancedTorpPylon_Fixed_Medium",
      "name": "Torpedo Pylon"
    },
    "85393": {
      "fdname": "Hpt_AdvancedTorpPylon_Fixed_Large",
      "name": "Torpedo Pylon"
    },
    "86226": {
      "fdname": "Hpt_FlakMortar_Fixed_Medium",
      "name": "Remote Release Flak Launcher"
    },
    "86228": {
      "fdname": "Hpt_FlakMortar_Turret_Medium",
      "name": "Remote Release Flak Launcher"
    },
    "86241": {
      "fdname": "Hpt_ATDumbfireMissile_Fixed_Medium_V2",
      "name": "Enhanced AX Missile Rack"
    },
    "86246": {
      "fdname": "Hpt_ATMultiCannon_Fixed_Medium_V2",
      "name": "Enhanced AX Multi-Cannon"
    },
    "86250": {
      "fdname": "Hpt_ATDumbfireMissile_Fixed_Medium",
      "name": "AX Missile Rack"
    },
    "86253": {
      "fdname": "Hpt_ATMultiCannon_Fixed_Medium",
      "name": "AX Multi-Cannon"
    },
    "86257": {
      "fdname": "Hpt_ATMultiCannon_Gimbal_Medium",
      "name": "Enhanced AX Multi-Cannon"
    },
    "86258": {
      "fdname": "Hpt_ATMultiCannon_Turret_Medium_V2",
      "name": "Enhanced AX Multi-Cannon"
    },
    "86259": {
      "fdname": "Hpt_ATDumbfireMissile_Turret_Medium_V2",
      "name": "Enhanced AX Missile Rack"
    },
    "86262": {
      "fdname": "Hpt_ATDumbfireMissile_Turret_Medium",
      "name": "AX Missile Rack"
    },
    "86265": {
      "fdname": "Hpt_ATMultiCannon_Turret_Medium",
      "name": "AX Multi-Cannon"
    },
    "86321": {
      "fdname": "Hpt_ATDumbfireMissile_Fixed_Large_V2",
      "name": "Enhanced AX Missile Rack"
    },
    "86326": {
      "fdname": "Hpt_ATMultiCannon_Fixed_Large_V2",
      "name": "Enhanced AX Multi-Cannon"
    },
    "86330": {
      "fdname": "Hpt_ATDumbfireMissile_Fixed_Large",
      "name": "AX Missile Rack"
    },
    "86333": {
      "fdname": "Hpt_ATMultiCannon_Fixed_Large",
      "name": "AX Multi-Cannon"
    },
    "86337": {
      "fdname": "Hpt_ATMultiCannon_Gimbal_Large",
      "name": "Enhanced AX Multi-Cannon"
    },
    "86348": {
      "fdname": "Hpt_ATMultiCannon_Turret_Large_V2",
      "name": "Enhanced AX Multi-Cannon"
    },
    "86349": {
      "fdname": "Hpt_ATDumbfireMissile_Turret_Large_V2",
      "name": "Enhanced AX Missile Rack"
    },
    "86352": {
      "fdname": "Hpt_ATDumbfireMissile_Turret_Large",
      "name": "AX Missile Rack"
    },
    "86355": {
      "fdname": "Hpt_ATMultiCannon_Turret_Large",
      "name": "AX Multi-Cannon"
    },
    "87144": {
      "fdname": "Hpt_PlasmaShockCannon_Fixed_Small",
      "name": "Shock Cannon"
    },
    "87155": {
      "fdname": "Hpt_PlasmaShockCannon_Gimbal_Small",
      "name": "Shock Cannon"
    },
    "87166": {
      "fdname": "Hpt_PlasmaShockCannon_Turret_Small",
      "name": "Shock Cannon"
    },
    "87220": {
      "fdname": "Hpt_CausticMissile_Fixed_Medium",
      "name": "Enzyme Missile Rack"
    },
    "87222": {
      "fdname": "Hpt_FlechetteLauncher_Turret_Medium",
      "name": "Remote Release Flechette Launcher"
    },
    "87223": {
      "fdname": "Hpt_FlechetteLauncher_Fixed_Medium",
      "name": "Remote Release Flechette Launcher"
    },
    "87244": {
      "fdname": "Hpt_PlasmaShockCannon_Fixed_Medium",
      "name": "Shock Cannon"
    },
    "87245": {
      "fdname": "Hpt_PlasmaShockCannon_Gimbal_Medium",
      "name": "Shock Cannon"
    },
    "87256": {
      "fdname": "Hpt_PlasmaShockCannon_Turret_Medium",
      "name": "Shock Cannon"
    },
    "87334": {
      "fdname": "Hpt_PlasmaShockCannon_Fixed_Large",
      "name": "Shock Cannon"
    },
    "87335": {
      "fdname": "Hpt_PlasmaShockCannon_Gimbal_Large",
      "name": "Shock Cannon"
    },
    "87346": {
      "fdname": "Hpt_PlasmaShockCannon_Turret_Large",
      "name": "Shock Cannon"
    },
    "88140": {
      "fdname": "Hpt_Guardian_GaussCannon_Fixed_Small",
      "name": "Guardian Gauss Cannon"
    },
    "88143": {
      "fdname": "Hpt_Guardian_PlasmaLauncher_Fixed_Small",
      "name": "Guardian Plasma Charger"
    },
    "88146": {
      "fdname": "Hpt_Guardian_ShardCannon_Fixed_Small",
      "name": "Guardian Shard Cannon"
    },
    "88165": {
      "fdname": "Hpt_Guardian_PlasmaLauncher_Turret_Small",
      "name": "Guardian Plasma Charger"
    },
    "88168": {
      "fdname": "Hpt_Guardian_ShardCannon_Turret_Small",
      "name": "Guardian Shard Cannon"
    },
    "88216": {
      "fdname": "Hpt_Guardian_ShardCannon_Fixed_Medium",
      "name": "Guardian Shard Cannon"
    },
    "88218": {
      "fdname": "Hpt_Guardian_ShardCannon_Turret_Medium",
      "name": "Guardian Shard Cannon"
    },
    "88220": {
      "fdname": "Hpt_Guardian_GaussCannon_Fixed_Medium",
      "name": "Guardian Gauss Cannon"
    },
    "88223": {
      "fdname": "Hpt_Guardian_PlasmaLauncher_Fixed_Medium",
      "name": "Guardian Plasma Charger"
    },
    "88255": {
      "fdname": "Hpt_Guardian_PlasmaLauncher_Turret_Medium",
      "name": "Guardian Plasma Charger"
    },
    "88299": {
      "fdname": "Hpt_ATVentDisruptorPylon_Fixed_Medium",
      "name": "Guardian Nanite Torpedo Pylon"
    },
    "88333": {
      "fdname": "Hpt_Guardian_PlasmaLauncher_Fixed_Large",
      "name": "Guardian Plasma Charger"
    },
    "88336": {
      "fdname": "Hpt_Guardian_ShardCannon_Fixed_Large",
      "name": "Guardian Shard Cannon"
    },
    "88345": {
      "fdname": "Hpt_Guardian_PlasmaLauncher_Turret_Large",
      "name": "Guardian Plasma Charger"
    },
    "88348": {
      "fdname": "Hpt_Guardian_ShardCannon_Turret_Large",
      "name": "Guardian Shard Cannon"
    },
    "88399": {
      "fdname": "Hpt_ATVentDisruptorPylon_Fixed_Large",
      "name": "Guardian Nanite Torpedo Pylon"
    }
  }
}
